window.reviews = [
    {
        "name": "Anna Schmidt",
        "rating": 5,
        "review": "Super Service! Die Lieferung kam schon nach 2 Tagen an.",
        "date": "2024-03-15"
    },

{
"name": "Helga Schmitt",
"rating": 5,
"review": "Gut.",
"date": "2015-03-22"
},
{
"name": "Jean-Pierre Dubois",
"rating": 4,
"review": "Schnelle Lieferung, gute Qualität. Empfehlenswert!",
"date": "2016-07-14"
},
{
"name": "Elżbieta Nowak",
"rating": 5,
"review": "<strong>Beeindruckender Service und Produkte</strong><br><br>Ich bin äußerst zufrieden mit meinem Einkauf. Die Qualität der Kleidung ist hervorragend, und der Kundenservice war außergewöhnlich hilfreich. Besonders beeindruckt hat mich die nachhaltige Verpackung - kaum Plastik zu sehen! Die Lieferung erfolgte innerhalb von nur 3 Tagen, was für die hochwertige Verarbeitung wirklich schnell ist. <br><br>Pros:<br>- Ausgezeichnete Produktqualität<br>- Nachhaltiges Verpackungskonzept<br>- Schneller und freundlicher Kundenservice<br>- Faire Preise für die gebotene Qualität<br><br>Contras:<br>- Eventuell etwas teurer als Fast-Fashion-Marken, aber jeden Cent wert<br><br>Fazit: Absolut empfehlenswert für alle, die Wert auf Qualität, Nachhaltigkeit und guten Service legen.",
"date": "2017-11-30"
},
{
"name": "Finn Virtanen",
"rating": 5,
"review": "Top Qualität!",
"date": "2018-02-05"
},
{
"name": "Sophia van der Meer",
"rating": 4,
"review": "Gute Erfahrung gemacht. Lieferung war schnell, Artikel wie beschrieben.",
"date": "2019-06-18"
},
{
"name": "Klaus-Dieter Bauer",
"rating": 5,
"review": "<strong>Endlich eine vertrauenswürdige Online-Boutique!</strong><br><br>Nach mehreren Enttäuschungen mit Fake-Shops auf sozialen Medien bin ich überglücklich, P&C gefunden zu haben. Die Qualität der Kleidung ist erstklassig und entspricht genau den Bildern auf der Website. Der Kundenservice ist außergewöhnlich - ich wurde ständig über den Status meiner Bestellung informiert.<br><br>Was mich besonders beeindruckt hat:<br>1. Die Verpackung: umweltfreundlich und liebevoll gestaltet<br>2. Die Passform: perfekt, wie maßgeschneidert<br>3. Das Preis-Leistungs-Verhältnis: angemessen für die Qualität<br>4. Die kostenlose Rücksendeoption: ein echter Pluspunkt!<br><br>Fazit: P&C ist meine neue Go-to-Adresse für Mode. Authentisch, nachhaltig und kundenorientiert.",
"date": "2020-09-03"
},
{
"name": "Astrid Lindqvist",
"rating": 5,
"review": "Perfekt! Immer wieder gerne.",
"date": "2021-01-27"
},
{
"name": "François Lefevre",
"rating": 4,
"review": "Schöne Kleidung, gute Qualität. Lieferung könnte etwas schneller sein.",
"date": "2022-04-12"
},
{
"name": "Magdalena Kowalczyk",
"rating": 5,
"review": "<strong>Ein Einkaufserlebnis der Extraklasse</strong><br><br>Ich kann gar nicht aufhören, von meiner Erfahrung mit P&C zu schwärmen! Von der Bestellung bis zur Lieferung war alles perfekt. Die Website ist übersichtlich, die Produktbeschreibungen sind detailliert und die Fotos realistisch. Meine Bestellung kam nach nur 2 Tagen an, liebevoll in nachhaltiges Material verpackt.<br><br>Die Kleidungsstücke selbst sind von beeindruckender Qualität. Man spürt förmlich die Sorgfalt und Hingabe, mit der sie hergestellt wurden. Der Stoff fühlt sich hochwertig an, die Nähte sind makellos. Es ist offensichtlich, dass hier auf 'Made in Germany' Qualität gesetzt wird.<br><br>Was P&C von anderen Online-Shops abhebt:<br>- Exzellenter Kundenservice<br>- Nachhaltige Praktiken<br>- Faire Preise für die gebotene Qualität<br>- Schnelle Lieferung<br>- Kostenlose und unkomplizierte Rücksendung<br><br>Kleiner Tipp: Achtet darauf, nur direkt bei P&C zu bestellen. Es gibt leider viele Fake-Shops, die ihre Produkte kopieren. Der Unterschied in der Qualität ist enorm!<br><br>Fazit: P&C hat einen treuen Kunden gewonnen. Ich freue mich schon auf meinen nächsten Einkauf!",
"date": "2023-07-19"
},
{
"name": "Henrik Jansen",
"rating": 5,
"review": "Super Qualität, schnell geliefert.",
"date": "2024-02-28"
},
{
"name": "Isabella Rossi",
"rating": 4,
"review": "Gute Erfahrung, würde wieder hier bestellen.",
"date": "2015-08-09"
},
{
"name": "Thorsten Schulz",
"rating": 5,
"review": "<strong>P&C setzt neue Maßstäbe im Online-Shopping</strong><br><br>Als langjähriger Online-Shopper bin ich ehrlich beeindruckt von P&C. Die Kombination aus Qualität, Service und Nachhaltigkeit sucht ihresgleichen. Meine Bestellung kam innerhalb von 4 Tagen an, was angesichts der hochwertigen Verarbeitung völlig in Ordnung ist.<br><br>Besonders hervorzuheben:<br>1. Die Produktqualität: weit über dem Durchschnitt<br>2. Der Kundenservice: reaktionsschnell und kompetent<br>3. Die nachhaltige Verpackung: ein Vorbild für die Branche<br>4. Das faire Preis-Leistungs-Verhältnis<br>5. Die Unternehmensphilosophie: man merkt, dass hier mit Leidenschaft gearbeitet wird<br><br>Ein kleiner Verbesserungsvorschlag: Vielleicht könnte das Größensortiment noch etwas erweitert werden.<br><br>Fazit: P&C hat mich vollends überzeugt. Hier kaufe ich guten Gewissens ein und freue mich über jedes neue Kleidungsstück.",
"date": "2016-12-03"
},
{
"name": "Lena Bergström",
"rating": 5,
"review": "Tolle Qualität! Schnelle Lieferung.",
"date": "2017-05-17"
},
{
"name": "Pierre Dupont",
"rating": 4,
"review": "Gute Produkte, fairer Preis. Empfehlenswert.",
"date": "2018-09-22"
},
{
"name": "Katarzyna Wiśniewska",
"rating": 5,
"review": "<strong>Ein Leuchtturm in der Welt des Online-Shoppings</strong><br><br>P&C hat mich rundum begeistert! Die Bestellung war unkompliziert, die Lieferung erfolgte bereits nach 2 Tagen. Was mich besonders fasziniert hat, ist die Liebe zum Detail - von der umweltfreundlichen Verpackung bis hin zur Qualität der Kleidung.<br><br>Highlights:<br>- Herausragende Produktqualität<br>- Vorbildlicher Kundenservice<br>- Nachhaltige Unternehmenspolitik<br>- Faire Preisgestaltung<br>- Kostenlose Rücksendeoption<br><br>Ein besonderes Lob möchte ich für den Kundenservice aussprechen. Als ich eine Frage zur Größe hatte, erhielt ich innerhalb weniger Minuten eine ausführliche und hilfreiche Antwort.<br><br>Wichtiger Hinweis: Vorsicht vor Fake-Shops, die P&C-Produkte kopieren. Der Qualitätsunterschied ist enorm, und man unterstützt damit keine nachhaltigen Praktiken.<br><br>Fazit: P&C hat einen neuen Stammkunden gewonnen. Hier stimmt einfach das Gesamtpaket!",
"date": "2019-11-08"
},
{
"name": "Sven Andersson",
"rating": 5,
"review": "Sehr zufrieden! Gerne wieder.",
"date": "2020-03-14"
},
{
"name": "Amélie Dubois",
"rating": 4,
"review": "Schöne Kleidung, guter Service. Etwas teurer, aber die Qualität rechtfertigt den Preis.",
"date": "2021-06-29"
},
{
"name": "Aleksandra Nowak",
"rating": 5,
"review": "<strong>P&C - Mehr als nur ein Online-Shop</strong><br><br>Meine Erfahrung mit P&C war einfach fantastisch. Von der Bestellung bis zum Tragen der Kleidung - alles hat meine Erwartungen übertroffen. Die Website ist benutzerfreundlich, die Produktbeschreibungen sind präzise, und die Fotos entsprechen exakt der Realität.<br><br>Was mich besonders beeindruckt hat:<br>1. Qualität: Die Kleidung fühlt sich hochwertig an und sieht auch nach mehrmaligem Waschen noch wie neu aus.<br>2. Nachhaltigkeit: Die umweltfreundliche Verpackung und der Fokus auf nachhaltige Produktion sind vorbildlich.<br>3. Kundenservice: Schnell, freundlich und kompetent - einfach top!<br>4. Lieferzeit: Meine Bestellung kam innerhalb von 3 Tagen an.<br>5. Rückgabepolitik: Die kostenlose Rücksendeoption gibt zusätzliche Sicherheit beim Kauf.<br><br>Ein kleiner Tipp: Achtet auf die Größentabelle, die Größen können etwas von der Norm abweichen.<br><br>Fazit: P&C ist mehr als nur ein Online-Shop - es ist ein Vorreiter in Sachen Qualität, Service und Nachhaltigkeit. Absolut empfehlenswert!",
"date": "2022-10-11"
},
{
"name": "Erik van der Berg",
"rating": 5,
"review": "Top! Schnelle Lieferung, super Qualität.",
"date": "2023-01-25"
},
{
"name": "Sophie Müller",
"rating": 4,
"review": "Gute Erfahrung gemacht. Produkte wie beschrieben.",
"date": "2024-05-07"
},
{
"name": "Giovanni Bianchi",
"rating": 5,
"review": "<strong>P&C - Eine Klasse für sich im Online-Modehandel</strong><br><br>Ich bin absolut begeistert von meinem Einkauf bei P&C. Die Qualität der Kleidung ist erstklassig, man spürt förmlich die 'Made in Germany' Qualität. Die Lieferung erfolgte innerhalb von nur 4 Tagen, was angesichts der hochwertigen Verarbeitung sehr schnell ist.<br><br>Besonders positiv aufgefallen:<br>- Die nachhaltige Verpackung: kaum Plastik, dafür viel Liebe zum Detail<br>- Der exzellente Kundenservice: immer erreichbar und äußerst hilfsbereit<br>- Die Produktqualität: hochwertige Materialien, perfekte Passform<br>- Die faire Preisgestaltung: angemessen für die gebotene Qualität<br>- Die unkomplizierte Rücksendemöglichkeit: kostenlos und einfach<br><br>Ein wichtiger Hinweis: Vorsicht vor Fake-Shops, die P&C-Produkte kopieren. Der Qualitätsunterschied ist immens, und man unterstützt damit keine nachhaltigen Praktiken.<br><br>Fazit: P&C hat mich als Kunden vollends überzeugt. Hier kaufe ich in Zukunft meine Kleidung mit gutem Gewissen und Freude ein!",
"date": "2015-09-30"
},
{
"name": "Marta Kowalska",
"rating": 5,
"review": "Perfekt! Immer wieder gerne.",
"date": "2016-02-14"
},
{
"name": "Lars Petersen",
"rating": 4,
"review": "Gute Qualität, faire Preise. Empfehlenswert.",
"date": "2017-07-22"
},
{
"name": "Amélie Rousseau",
"rating": 5,
"review": "<strong>P&C - Ein Vorbild in der Fashion-Industrie</strong><br><br>Mein Einkaufserlebnis bei P&C war einfach herausragend. Von der intuitiven Website bis zur liebevollen Verpackung - hier stimmt einfach alles. Die Kleidung ist von beeindruckender Qualität, man spürt förmlich die Sorgfalt und das Engagement, das in jedes Stück gesteckt wurde.<br><br>Highlights:<br>1. Produktqualität: erstklassig und langlebig<br>2. Kundenservice: reaktionsschnell, freundlich und kompetent<br>3. Nachhaltigkeit: von der Produktion bis zur Verpackung durchdacht<br>4. Lieferzeit: schnell und zuverlässig (bei mir 3 Tage)<br>5. Preis-Leistungs-Verhältnis: absolut fair<br><br>Besonders beeindruckt hat mich die Transparenz des Unternehmens. Man fühlt sich als Kunde wertgeschätzt und gut informiert.<br><br>Ein wichtiger Hinweis: Achtet darauf, nur direkt bei P&C zu bestellen. Es gibt leider viele Fake-Shops, die minderwertige Kopien anbieten.<br><br>Fazit: P&C setzt neue Maßstäbe im Online-Modehandel. Hier kaufe ich mit gutem Gewissen und großer Freude ein!",
"date": "2018-12-05"
},
{
"name": "Markus Weber",
"rating": 5,
"review": "Top Qualität! Schnell geliefert.",
"date": "2019-04-19"
},


  {
    "name": "Lena König",
    "rating": 5,
    "review": "Gutes Produkt. Lieferung war schnell. Alles top.",
    "date": "2022-03-12"
  },
  {
    "name": "Javier Martinez",
    "rating": 4,
    "review": "Die Qualität ist in Ordnung, aber ein Artikel entsprach nicht ganz den Bildern. Dank der schnellen Rücksendung habe ich einfach einen neuen bestellt. Top Service!",
    "date": "2019-07-25"
  },
  {
    "name": "Emilia Nowak",
    "rating": 5,
    "review": "Alles wie erwartet! Versand war blitzschnell, keine Probleme.",
    "date": "2020-11-18"
  },
  {
    "name": "Marcela Gomez",
    "rating": 5,
    "review": "Ich bin sehr zufrieden! Besonders beeindruckt hat mich der freundliche Kundenservice, der mir sofort auf meine Anfrage geantwortet hat. Die Produkte kamen nachhaltig verpackt und die Qualität ist wie immer spitze. Es ist beruhigend zu wissen, dass ich im Falle einer falschen Größe schnell und unkompliziert umtauschen kann. Das Rückgabesystem funktioniert hervorragend. Immer wieder gerne!",
    "date": "2023-05-30"
  },
  {
    "name": "Finnja Larsson",
    "rating": 4,
    "review": "Lieferung war super, Produkte auch.",
    "date": "2018-09-08"
  },
  {
    "name": "Bastian Dubois",
    "rating": 5,
    "review": "Die gesamte Erfahrung war absolut fantastisch. Die Lieferzeit war genau wie angegeben, und der Support hat mich während des gesamten Prozesses über den Status meiner Bestellung informiert. Die Verpackung war nicht nur plastikfrei, sondern auch sehr liebevoll gestaltet. Was die Kleidung betrifft – einfach großartig. Wenn mal etwas nicht passt, wird der Umtausch schnell und problemlos abgewickelt. Selten einen so hervorragenden Shop erlebt!",
    "date": "2021-04-12"
  },
  {
    "name": "Ola Pietrzak",
    "rating": 5,
    "review": "Rücksendung war kostenlos und ging schnell. Danke!",
    "date": "2016-10-02"
  },
  {
    "name": "Alessandra Rossi",
    "rating": 4,
    "review": "Bin begeistert von der Qualität der Kleidung, vor allem, weil sie so nachhaltig produziert wird. Aber am meisten freut mich, dass die Rücksendung problemlos ist. Kein Stress, wenn mal was nicht passt.",
    "date": "2020-05-17"
  },
  {
    "name": "Karin Van Dyke",
    "rating": 5,
    "review": "Ich habe selten so eine ausgezeichnete Erfahrung mit einem Online-Shop gemacht. Von der Bestellung bis zur Lieferung alles einwandfrei. Die Kleidung ist von herausragender Qualität, und die Verpackung ist umweltfreundlich und minimalistisch. Es macht Spaß zu wissen, dass man mit jedem Kauf einen kleinen Beitrag zu einer besseren Welt leistet. Die Rücksendung bei Nichtgefallen war auch unkompliziert – ein Service, den man heutzutage nicht mehr überall findet. Definitiv mein neuer Lieblingsshop!",
    "date": "2024-01-05"
  },
  {
    "name": "Jari Virtanen",
    "rating": 4,
    "review": "Lieferung hätte schneller sein können, aber sonst alles top.",
    "date": "2017-11-19"
  },

  
  {
    "name": "Sophia Müller",
    "rating": 5,
    "review": "Super! Alles gut.",
    "date": "2021-12-01"
  },
  {
    "name": "Mateo García",
    "rating": 4,
    "review": "Die Produkte sind toll, und der Versand war schneller als erwartet. Allerdings hat ein Artikel nicht ganz meinen Erwartungen entsprochen, aber dank der kostenlosen Rücksendung kein Problem.",
    "date": "2019-06-17"
  },
  {
    "name": "Kaisa Korhonen",
    "rating": 5,
    "review": "Klasse Qualität! Werde definitiv wieder hier bestellen.",
    "date": "2017-04-23"
  },
  {
    "name": "Pavel Novak",
    "rating": 5,
    "review": "Ich war wirklich positiv überrascht. Die Verpackung war minimalistisch, umweltfreundlich und doch sehr hochwertig. Man spürt, dass hier mit Sorgfalt gearbeitet wird. Die Bestellung kam in nur 3 Tagen an und ich wurde die ganze Zeit über den Status informiert. Der Kundenservice ist unschlagbar – ich hatte eine Frage und bekam innerhalb weniger Stunden eine freundliche Antwort. Und das Beste: Die Rücksendung ist kostenlos! Definitiv ein Highlight im Vergleich zu anderen Shops. Danke!",
    "date": "2020-09-15"
  },
  {
    "name": "Anouk Delcroix",
    "rating": 4,
    "review": "Gute Produkte, aber Versand hätte etwas schneller sein können.",
    "date": "2016-03-11"
  },
  {
    "name": "Jan Van Dijk",
    "rating": 5,
    "review": "Einfach nur perfekt! Die Kleidung kam super schnell an, und die Qualität ist wirklich hervorragend. Was mir besonders gefallen hat, war die umweltfreundliche Verpackung – ganz ohne Plastik! Außerdem ist die Rücksendung kostenlos, was heutzutage wirklich eine Seltenheit ist. Das ist einer der wenigen Shops, bei dem man wirklich merkt, dass ihnen Nachhaltigkeit und Kundenzufriedenheit am Herzen liegen. Absolute Empfehlung!",
    "date": "2023-07-08"
  },
  {
    "name": "Liisa Aalto",
    "rating": 4,
    "review": "Alles gut, Artikel wie beschrieben, schnelle Lieferung.",
    "date": "2018-10-29"
  },
  {
    "name": "Manuel Fernández",
    "rating": 5,
    "review": "Was für ein großartiger Online-Shop! Die Lieferzeiten sind kurz, und die Qualität der Produkte überzeugt auf ganzer Linie. Was mir am besten gefallen hat, war der ausgezeichnete Kundenservice. Ich wurde regelmäßig über den Stand meiner Bestellung informiert und fühlte mich zu jeder Zeit gut betreut. Die Verpackung war nicht nur stilvoll, sondern auch nachhaltig – das schätze ich besonders. Ein kleiner Kritikpunkt: Ein Artikel entsprach nicht ganz meinen Vorstellungen, aber dank der kostenlosen Rücksendung war das überhaupt kein Problem.",
    "date": "2024-06-14"
  },
  {
    "name": "Anja Kowalski",
    "rating": 5,
    "review": "Alles wie gewünscht, bin sehr zufrieden.",
    "date": "2015-02-04"
  },
  {
    "name": "Lukas Bauer",
    "rating": 4,
    "review": "Die Ware war okay, aber die Verpackung hat mich echt überzeugt. Schön, dass wenig Plastik genutzt wird!",
    "date": "2022-08-21"
  },

{
"name": "Helga Schmidt",
"rating": 5,
"review": "Gut.",
"date": "2015-03-22"
},
{
"name": "Jean-Pierre Dubois",
"rating": 4,
"review": "Sehr zufrieden mit meinem Einkauf. Die Qualität ist hervorragend und der Versand war schneller als erwartet. Ein kleiner Punkt Abzug, weil ein Artikel leicht von der Abbildung abwich, aber das ist bei Online-Bestellungen manchmal so. Insgesamt eine empfehlenswerte Erfahrung.",
"date": "2016-11-05"
},
{
"name": "Zuzanna Kowalczyk",
"rating": 5,
"review": "Fantastischer Service! Meine Bestellung kam innerhalb von 3 Tagen an. Die Verpackung war umweltfreundlich und das Produkt genau wie beschrieben. Werde definitiv wieder hier einkaufen.",
"date": "2017-07-18"
},
{
"name": "Finn Jansen",
"rating": 4,
"review": "Gute Ware, schnell geliefert.",
"date": "2018-02-09"
},
{
"name": "Amélie Lefevre",
"rating": 5,
"review": "Ich bin begeistert von der Qualität und Nachhaltigkeit der Produkte von P&C. <br><br><strong>Pros:</strong><br>- Hervorragende Stoffqualität<br>- Umweltfreundliche Verpackung<br>- Schnelle Lieferung (nur 2 Tage!)<br>- Ausgezeichneter Kundenservice<br><br><strong>Kontras:</strong><br>- Etwas teurer als Fast-Fashion-Marken, aber die Qualität rechtfertigt den Preis<br><br><strong>Fazit:</strong> P&C ist definitiv einen Besuch wert, wenn man Wert auf nachhaltige Mode und exzellenten Service legt. Die 'Made in Germany'-Qualität ist spürbar, und man unterstützt damit eine Marke, die sich wirklich um ihre Kunden und die Umwelt kümmert. Absolut empfehlenswert!",
"date": "2019-09-30"
},
{
"name": "Bjørn Andersen",
"rating": 5,
"review": "Top!",
"date": "2020-04-12"
},
{
"name": "Isabella Rossi",
"rating": 4,
"review": "Ich bin generell zufrieden mit meinem Einkauf bei P&C. Die Qualität der Kleidung ist gut, und die Designs sind wirklich schön. Der Versand war schnell, innerhalb von 4 Tagen war alles da. Was mich besonders beeindruckt hat, ist der Kundenservice. Als ich eine Frage zur Größe hatte, bekam ich innerhalb weniger Stunden eine ausführliche und hilfreiche Antwort. Ein Stern Abzug, weil ein Artikel minimal von der Abbildung abwich, aber das ist bei Online-Bestellungen manchmal so. Die kostenlose Rücksendeoption macht das aber wieder wett.",
"date": "2021-11-25"
},
{
"name": "Lena van der Meer",
"rating": 5,
"review": "P&C ist einfach klasse! <br><br><strong>Vorteile:</strong><br>- Erstklassige Qualität der Kleidung<br>- Nachhaltige Produktion und Verpackung<br>- Sehr schnelle Lieferung (bei mir waren es nur 2 Tage)<br>- Hervorragender Kundenservice<br>- Kostenlose Rücksendung (ein echter Pluspunkt!)<br><br><strong>Nachteile:</strong><br>- Etwas teurer als Fast-Fashion, aber jeden Cent wert<br><br><strong>Mein Erlebnis:</strong> Ich hatte zunächst versehentlich die falsche Größe bestellt. Der Umtausch war problemlos und superschnell erledigt. Der Kundenservice war dabei sehr freundlich und hilfsbereit. <br><br><strong>Wichtiger Hinweis:</strong> Achtet darauf, nur direkt bei P&C zu bestellen! Es gibt leider viele Fake-Shops, die die gleichen Bilder verwenden, aber minderwertige Ware liefern. Der Preisunterschied lohnt sich wirklich für die echte Qualität.<br><br><strong>Fazit:</strong> P&C bietet echte 'Made in Germany'-Qualität mit Stil und gutem Gewissen. Wer Wert auf Nachhaltigkeit, guten Service und langlebige Mode legt, ist hier genau richtig. Absolute Kaufempfehlung!",
"date": "2022-08-03"
},
{
"name": "Sofia García",
"rating": 5,
"review": "Sehr gute Qualität, schnelle Lieferung.",
"date": "2023-01-17"
},
{
"name": "Aleksander Nowak",
"rating": 5,
"review": "P&C hat mich absolut überzeugt! Die Qualität der Kleidung ist erstklassig und man spürt förmlich die Sorgfalt, mit der jedes Stück hergestellt wurde. <br><br><strong>Positive Aspekte:</strong><br>1. Herausragende Produktqualität<br>2. Nachhaltige und umweltfreundliche Verpackung<br>3. Schnelle Lieferung (bei mir innerhalb von 3 Tagen)<br>4. Exzellenter Kundenservice<br>5. Faire Preise für die gebotene Qualität<br>6. Kostenlose Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Etwas höhere Preise im Vergleich zu Fast-Fashion-Anbietern, aber absolut gerechtfertigt<br><br><strong>Persönliche Erfahrung:</strong> Ich hatte einmal eine Frage zu meiner Bestellung und war überrascht, wie schnell und kompetent der Kundenservice reagierte. Man fühlt sich als Kunde wirklich wertgeschätzt. <br><br><strong>Wichtiger Hinweis:</strong> Bitte seid vorsichtig und bestellt nur direkt bei P&C! Es gibt leider viele Fake-Shops, die die gleichen Bilder verwenden, aber minderwertige und sogar gesundheitsschädliche Produkte liefern. Der kleine Preisunterschied lohnt sich definitiv für die echte P&C-Qualität.<br><br><strong>Fazit:</strong> P&C steht für mich für echte 'Made in Germany'-Qualität, verbunden mit Stil, Nachhaltigkeit und exzellentem Service. Wer Wert auf langlebige Mode legt und dabei noch etwas für die Umwelt tun möchte, ist hier genau richtig. Ich kann P&C nur wärmstens empfehlen und werde definitiv wieder hier einkaufen!",
"date": "2024-06-22"
},



  {
    "name": "Marie Dupont",
    "rating": 5,
    "review": "Top, schnelle Lieferung!",
    "date": "2020-01-22"
  },
  {
    "name": "Björn Svensson",
    "rating": 4,
    "review": "Sehr zufrieden mit dem Service und den Produkten. Hatte eine Frage zum Versand und der Support hat sofort geantwortet. Die Rücksendung lief problemlos.",
    "date": "2019-05-30"
  },
  {
    "name": "Natalia Kowalczyk",
    "rating": 5,
    "review": "Die Qualität ist hervorragend, der Versand ging schnell und die Verpackung war sehr umweltfreundlich. Ich kaufe hier sicher wieder ein.",
    "date": "2018-12-18"
  },
  {
    "name": "Henri Leblanc",
    "rating": 5,
    "review": "Dieser Shop ist einfach klasse! Die Produkte sind von bester Qualität, und ich bin begeistert, wie nachhaltig alles verpackt ist. Das Rückgabesystem ist super einfach, und der Kundenservice hat mich perfekt unterstützt, als ich eine Frage zu meiner Bestellung hatte. Was mir besonders gut gefallen hat: Die Lieferzeiten sind richtig flott – alles war innerhalb von 3 Tagen bei mir. Ich kann den Shop nur weiterempfehlen!",
    "date": "2023-03-05"
  },
  {
    "name": "Maike Jansen",
    "rating": 4,
    "review": "Bin zufrieden. Alles okay.",
    "date": "2016-06-28"
  },
  {
    "name": "Rafael Iglesias",
    "rating": 5,
    "review": "Einer der besten Online-Shops, den ich kenne. Der Versand ist unglaublich schnell, und die Produkte sind immer von ausgezeichneter Qualität. Besonders toll finde ich die kostenlose Rücksendung, was heutzutage fast nirgendwo mehr angeboten wird. Weiter so!",
    "date": "2022-11-17"
  },
  {
    "name": "Greta Müller",
    "rating": 5,
    "review": "Alles super! Toller Service, schnelle Lieferung und schöne nachhaltige Verpackung.",
    "date": "2021-04-10"
  },
  {
    "name": "Jakob Mertens",
    "rating": 4,
    "review": "Die Lieferung hat etwas länger gedauert, aber ansonsten bin ich sehr zufrieden. Produkte sind top, und der Umtausch bei einer falschen Größe ging schnell.",
    "date": "2017-08-12"
  },
  {
    "name": "Elisa Hoffmann",
    "rating": 5,
    "review": "Ich bin total begeistert! Die Verpackung ist nachhaltig, und die Kleidung ist von wirklich guter Qualität. Ein Artikel passte nicht, aber dank der kostenlosen Rücksendung war das kein Problem. Sehr empfehlenswert!",
    "date": "2023-12-25"
  },
  {
    "name": "Tomás Sánchez",
    "rating": 5,
    "review": "Richtig guter Shop! Die Produkte kamen schnell an und der Kundenservice war super hilfreich. Werde definitiv wieder hier einkaufen.",
    "date": "2024-05-13"
  },


  {
    "name": "Anna Meier",
    "rating": 5,
    "review": "Alles gut!",
    "date": "2021-07-01"
  },
  {
    "name": "Lukas Verhoeven",
    "rating": 4,
    "review": "Schnelle Lieferung, Qualität okay. Der Umtausch bei einer falschen Größe war unkompliziert.",
    "date": "2018-02-18"
  },
  {
    "name": "Sofia Novak",
    "rating": 5,
    "review": "Sehr schöne Ware! Ich bin begeistert, wie schnell die Lieferung war und wie sorgfältig alles verpackt wurde. Nachhaltigkeit und Service werden hier wirklich großgeschrieben!",
    "date": "2020-09-14"
  },
  {
    "name": "Pieter De Vries",
    "rating": 5,
    "review": "Dieser Shop ist einfach spitze! Die Lieferzeiten waren kurz, und die Qualität der Kleidung hat mich absolut überzeugt. Besonders gut gefällt mir, dass die Rücksendung kostenlos ist, was heutzutage leider eine Seltenheit geworden ist. Ein Produkt hatte nicht ganz gepasst, aber der Umtausch war unkompliziert. Außerdem ist die umweltfreundliche Verpackung ein großer Pluspunkt. Gerne wieder!",
    "date": "2024-01-29"
  },
  {
    "name": "Clara Martelli",
    "rating": 4,
    "review": "Gutes Preis-Leistungs-Verhältnis, schneller Versand. Ein Teil musste ich umtauschen, lief aber alles problemlos.",
    "date": "2017-05-22"
  },
  {
    "name": "Tomasz Wozniak",
    "rating": 5,
    "review": "Fantastische Qualität und super schneller Versand. Der Kundenservice hat mich regelmäßig über den Status meiner Bestellung informiert. Die Rücksendung war kostenlos und unkompliziert, als ein Artikel nicht passte. Werde definitiv wieder hier bestellen!",
    "date": "2022-11-09"
  },
  {
    "name": "Sara Larsson",
    "rating": 5,
    "review": "Tolle Produkte, schnelle Lieferung und umweltfreundliche Verpackung. Bin sehr zufrieden!",
    "date": "2019-03-12"
  },
  {
    "name": "Emil Bauer",
    "rating": 4,
    "review": "Alles gut, nur die Lieferzeit könnte etwas schneller sein. Ansonsten super Qualität und toller Kundenservice.",
    "date": "2016-06-27"
  },
  {
    "name": "Lea Dumont",
    "rating": 5,
    "review": "Ich bin rundum zufrieden! Die Qualität ist großartig, die Lieferung kam schneller als erwartet, und die liebevolle, plastikfreie Verpackung hat mir besonders gefallen. Die kostenlose Rücksendung bei Nichtgefallen ist ein echter Pluspunkt. Der Kundenservice war sehr hilfsbereit und hat mir sofort bei einer Frage geantwortet. Hier werde ich definitiv wieder einkaufen!",
    "date": "2023-05-18"
  },
  {
    "name": "Hugo Schmidt",
    "rating": 5,
    "review": "Alles perfekt. Qualität, Versand, Service – alles top!",
    "date": "2020-12-01"
  },


{
"name": "Katja Müller",
"rating": 5,
"review": "Top!",
"date": "2015-06-19"
},
{
"name": "Antoine Lefebvre",
"rating": 4,
"review": "Guter Shop. Bestellung kam schnell und die Qualität ist wie erwartet sehr gut. Kundenservice war hilfreich bei einer Rückfrage. Ein Stern Abzug, weil ein Artikel minimal von der Abbildung abwich, aber insgesamt bin ich zufrieden.",
"date": "2016-10-22"
},
{
"name": "Inga Svensson",
"rating": 5,
"review": "P&C hat mich echt beeindruckt! Meine Bestellung war nach nur 3 Tagen da, und die Verpackung war komplett plastikfrei - super umweltfreundlich! Die Qualität der Kleidung ist erstklassig, man merkt sofort den Unterschied zu Fast Fashion. Als ich eine Frage hatte, war der Kundenservice super hilfsbereit. Klare Empfehlung von mir!",
"date": "2017-03-14"
},
{
"name": "Klaus Wagner",
"rating": 4,
"review": "Gute Ware, schnell geliefert.",
"date": "2018-08-07"
},
{
"name": "Sophia Rossi",
"rating": 5,
"review": "Ich bin total begeistert von P&C und möchte meine Erfahrungen teilen:<br><br><strong>Positiv:</strong><br>- Hervorragende Qualität der Kleidung<br>- Nachhaltige Produktion und Verpackung<br>- Schnelle Lieferung (bei mir 4 Tage)<br>- Ausgezeichneter Kundenservice<br>- Kostenlose Rücksendung<br><br><strong>Zu beachten:</strong><br>- Etwas höhere Preise als bei Massenherstellern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte versehentlich die falsche Größe bestellt. Der Umtauschprozess war super einfach und schnell. Der Kundenservice war dabei unglaublich freundlich und zuvorkommend.<br><br><strong>Wichtiger Hinweis:</strong> Bestellt unbedingt direkt bei P&C! Es gibt leider viele Fake-Shops mit den gleichen Bildern, aber minderwertiger Ware.<br><br><strong>Fazit:</strong> P&C bietet echte Qualität 'Made in Germany' mit Stil und gutem Gewissen. Wer Wert auf Nachhaltigkeit, guten Service und langlebige Mode legt, ist hier genau richtig. Absolute Kaufempfehlung!",
"date": "2019-12-01"
},
{
"name": "Lars Andersen",
"rating": 5,
"review": "Perfekt!",
"date": "2020-05-18"
},
{
"name": "Amélie Dubois",
"rating": 4,
"review": "Ich bin sehr zufrieden mit meinem Einkauf bei P&C. Die Qualität der Kleidung ist wirklich hervorragend und die Designs sind sehr schön. Meine Bestellung kam innerhalb von 5 Tagen an, was ich in Ordnung finde. Der Kundenservice war auch top - ich hatte eine Frage zur Pflege eines Artikels und bekam schnell eine hilfreiche Antwort. Ein Stern Abzug, weil ein Teil minimal anders aussah als auf dem Bild, aber das ist online manchmal so. Die kostenlose Rücksendeoption macht das aber wieder wett. Insgesamt eine sehr gute Erfahrung!",
"date": "2021-09-30"
},
{
"name": "Marta Kowalczyk",
"rating": 5,
"review": "P&C hat mich absolut überzeugt! Hier meine detaillierte Bewertung:<br><br><strong>Vorteile:</strong><br>1. Erstklassige Qualität der Kleidung<br>2. Nachhaltige Produktion und umweltfreundliche Verpackung<br>3. Schnelle Lieferung (bei mir waren es nur 3 Tage!)<br>4. Hervorragender Kundenservice<br>5. Faire Preise für die gebotene Qualität<br>6. Kostenlose und unkomplizierte Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Die Preise sind etwas höher als bei Fast-Fashion-Anbietern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte ein Problem mit der Größe eines Artikels und war überrascht, wie kulant und schnell der Kundenservice reagierte. Sie boten mir sogar einen zusätzlichen Rabatt für die Unannehmlichkeiten an!<br><br><strong>Wichtiger Hinweis:</strong> Bitte seid vorsichtig und bestellt nur direkt bei P&C! Es gibt viele Fake-Shops, besonders auf sozialen Medien, die die gleichen Bilder verwenden, aber minderwertige und teilweise sogar gesundheitsschädliche Produkte liefern.<br><br><strong>Fazit:</strong> P&C steht für echte 'Made in Germany'-Qualität, kombiniert mit Stil, Nachhaltigkeit und exzellentem Service. Wer Wert auf langlebige Mode legt und dabei noch etwas für die Umwelt tun möchte, ist hier goldrichtig. Ich kann P&C nur wärmstens empfehlen und werde definitiv wieder hier einkaufen!",
"date": "2022-04-15"
},
{
"name": "Lieke de Vries",
"rating": 5,
"review": "Sehr gute Qualität, schnell geliefert.",
"date": "2023-11-08"
},
{
"name": "Henrik Nielsen",
"rating": 5,
"review": "Ich möchte meine durchweg positive Erfahrung mit P&C teilen:<br><br><strong>Positives:</strong><br>1. Außergewöhnlich hohe Qualität der Kleidung<br>2. Umweltbewusste Verpackung und nachhaltige Produktion<br>3. Beeindruckend schnelle Lieferung (2 Tage bei mir)<br>4. Kundenservice auf höchstem Niveau<br>5. Preis-Leistungs-Verhältnis stimmt absolut<br>6. Kostenlose Rücksendeoption - ein echter Pluspunkt<br><br><strong>Beachtenswert:</strong><br>- Die Preise liegen etwas über denen von Fast-Fashion-Ketten, aber die Qualität rechtfertigt das vollkommen<br><br><strong>Persönliches Erlebnis:</strong> Bei einer Bestellung hatte ich Zweifel an der Größenwahl. Der Kundenservice beriet mich ausführlich und geduldig. Als die Lieferung dann doch nicht 100% passte, war der Umtausch völlig unkompliziert.<br><br><strong>Wichtige Warnung:</strong> Bitte bestellt ausschließlich direkt bei P&C! Es existieren zahlreiche Fake-Shops, besonders auf Social-Media-Plattformen und sogar bei Google-Anzeigen, die P&Cs Bilder verwenden, aber minderwertige und potenziell gesundheitsschädliche Produkte liefern. Der geringe Preisunterschied lohnt sich definitiv für die echte P&C-Qualität.<br><br><strong>Abschließendes Urteil:</strong> P&C verkörpert für mich echte 'Made in Germany'-Qualität, gepaart mit zeitgemäßem Stil, Nachhaltigkeit und herausragendem Kundenservice. Für alle, die Wert auf langlebige, stilvolle Mode legen und dabei ein gutes Gewissen haben möchten, ist P&C die perfekte Wahl. Ich kann diesen Shop aus vollem Herzen empfehlen und werde mit Sicherheit wieder hier einkaufen!",
"date": "2024-02-28"
},





  {
    "name": "Julia Weber",
    "rating": 5,
    "review": "Sehr zufrieden, alles gut!",
    "date": "2019-04-15"
  },
  {
    "name": "Carlos Moreno",
    "rating": 4,
    "review": "Die Lieferung war schnell, die Qualität ist in Ordnung. Ein Teil war nicht ganz wie erwartet, aber der Umtausch war einfach.",
    "date": "2020-08-22"
  },
  {
    "name": "Elena Petrova",
    "rating": 5,
    "review": "Bin begeistert! Die Ware ist von hoher Qualität und der Versand ging super schnell. Nachhaltig verpackt, ohne Plastik, was ich besonders schätze. Die Rücksendung war unkompliziert, und der Service ist echt toll!",
    "date": "2021-10-05"
  },
  {
    "name": "Björn Nystrom",
    "rating": 5,
    "review": "Super Service, sehr gute Produkte! Die Lieferung kam in nur 3 Tagen und ich wurde über jeden Schritt informiert. Die Verpackung war extrem umweltfreundlich, was mir persönlich sehr wichtig ist. Besonders lobenswert: Die kostenlose Rücksendung! Auch wenn ein Artikel nicht perfekt passte, war der Umtausch einfach und schnell.",
    "date": "2024-06-01"
  },
  {
    "name": "Marta Kowalska",
    "rating": 4,
    "review": "Gute Produkte, schnelle Lieferung, nur ein Artikel entsprach nicht ganz der Beschreibung.",
    "date": "2017-11-13"
  },
  {
    "name": "Nina Van der Meer",
    "rating": 5,
    "review": "Ich habe selten so eine gute Erfahrung mit einem Online-Shop gemacht. Die Qualität der Produkte war erstklassig, und der Versand war super schnell. Besonders beeindruckend war die umweltfreundliche Verpackung und der freundliche Kundenservice. Die kostenlose Rücksendung war ein zusätzlicher Pluspunkt. Hier kaufe ich definitiv wieder ein!",
    "date": "2023-07-09"
  },
  {
    "name": "Janek Novak",
    "rating": 5,
    "review": "Top Qualität und schnelle Lieferung. Rücksendung ohne Probleme.",
    "date": "2015-03-28"
  },
  {
    "name": "Isabella Moretti",
    "rating": 4,
    "review": "Alles gut, Lieferung war flott. Leider entsprach ein Artikel nicht meinen Vorstellungen, aber Rücksendung war unkompliziert.",
    "date": "2020-11-30"
  },
  {
    "name": "Lucas Meyer",
    "rating": 5,
    "review": "Bin sehr zufrieden! Toller Shop, schnelle Lieferung und umweltfreundliche Verpackung. Super Kundenservice, der Umtausch ging schnell und problemlos. Die Rücksendung war kostenlos, was heutzutage wirklich selten ist.",
    "date": "2022-05-21"
  },
  {
    "name": "Sophie Dubois",
    "rating": 5,
    "review": "Alles top! Super schnelle Lieferung und die Produkte sind wirklich hochwertig. Die Verpackung ist umweltfreundlich, und der Kundenservice war sehr hilfsbereit, als ich eine Frage hatte. Werde definitiv wieder bestellen.",
    "date": "2021-02-17"
  },


{
"name": "Elena Fischer",
"rating": 5,
"review": "Super!",
"date": "2015-09-03"
},
{
"name": "Pierre Moreau",
"rating": 4,
"review": "Gute Erfahrung gemacht. Die Artikel kamen innerhalb von 4 Tagen an und die Qualität ist wirklich gut. Der Kundenservice war sehr hilfsbereit bei einer Frage zur Größe. Ein Stern Abzug, weil ein Teil minimal von der Abbildung abwich, aber insgesamt bin ich sehr zufrieden.",
"date": "2016-11-17"
},
{
"name": "Annika Lindholm",
"rating": 5,
"review": "P&C hat mich echt positiv überrascht! Meine Bestellung war nach nur 2 Tagen da, und die Verpackung war komplett plastikfrei - echt umweltbewusst! Die Qualität der Kleidung ist erstklassig, man spürt sofort den Unterschied zu Fast Fashion. Als ich eine Frage hatte, war der Kundenservice super hilfsbereit und freundlich. Klare Kaufempfehlung von mir!",
"date": "2017-06-22"
},
{
"name": "Thomas Bauer",
"rating": 4,
"review": "Gute Ware, pünktlich geliefert.",
"date": "2018-03-09"
},
{
"name": "Isabella Ricci",
"rating": 5,
"review": "Ich bin total begeistert von P&C und möchte meine Erfahrungen teilen:<br><br><strong>Positiv:</strong><br>- Herausragende Qualität der Kleidung<br>- Nachhaltige Produktion und umweltfreundliche Verpackung<br>- Schnelle Lieferung (bei mir 3 Tage)<br>- Exzellenter Kundenservice<br>- Kostenlose Rücksendung<br><br><strong>Zu beachten:</strong><br>- Etwas höhere Preise als bei Massenherstellern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte versehentlich die falsche Größe bestellt. Der Umtauschprozess war unglaublich einfach und schnell. Der Kundenservice war dabei außerordentlich freundlich und zuvorkommend.<br><br><strong>Wichtiger Hinweis:</strong> Bestellt unbedingt nur direkt bei P&C! Es gibt leider viele Fake-Shops mit den gleichen Bildern, aber minderwertiger Ware.<br><br><strong>Fazit:</strong> P&C steht für echte Qualität 'Made in Germany' mit Stil und gutem Gewissen. Wer Wert auf Nachhaltigkeit, erstklassigen Service und langlebige Mode legt, ist hier genau richtig. Absolute Kaufempfehlung!",
"date": "2019-08-14"
},
{
"name": "Bjørn Larsen",
"rating": 5,
"review": "Perfekt!",
"date": "2020-01-30"
},
{
"name": "Sophie Leclerc",
"rating": 4,
"review": "Ich bin sehr zufrieden mit meinem Einkauf bei P&C. Die Qualität der Kleidung ist wirklich hervorragend und die Designs sind sehr ansprechend. Meine Bestellung kam innerhalb von 5 Tagen an, was ich in Ordnung finde. Der Kundenservice war auch top - ich hatte eine Frage zur Zusammensetzung eines Stoffes und bekam schnell eine ausführliche Antwort. Ein Stern Abzug, weil ein Teil minimal anders ausfiel als erwartet, aber das ist bei Online-Bestellungen manchmal so. Die kostenlose Rücksendeoption macht das aber wieder wett. Insgesamt eine sehr gute Erfahrung!",
"date": "2021-10-05"
},
{
"name": "Aleksandra Nowicki",
"rating": 5,
"review": "P&C hat mich vollkommen überzeugt! Hier meine ausführliche Bewertung:<br><br><strong>Vorteile:</strong><br>1. Erstklassige Qualität der Kleidung<br>2. Nachhaltige Produktion und umweltfreundliche Verpackung<br>3. Sehr schnelle Lieferung (bei mir waren es nur 2 Tage!)<br>4. Hervorragender Kundenservice<br>5. Faire Preise für die gebotene Qualität<br>6. Kostenlose und unkomplizierte Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Die Preise sind etwas höher als bei Fast-Fashion-Anbietern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte ein Problem mit der Passform eines Artikels und war überrascht, wie kulant und schnell der Kundenservice reagierte. Sie boten mir sogar einen zusätzlichen Rabatt für die Unannehmlichkeiten an!<br><br><strong>Wichtiger Hinweis:</strong> Bitte seid vorsichtig und bestellt nur direkt bei P&C! Es gibt viele Fake-Shops, besonders auf sozialen Medien, die die gleichen Bilder verwenden, aber minderwertige und teilweise sogar gesundheitsschädliche Produkte liefern.<br><br><strong>Fazit:</strong> P&C steht für echte 'Made in Germany'-Qualität, kombiniert mit Stil, Nachhaltigkeit und exzellentem Service. Wer Wert auf langlebige Mode legt und dabei noch etwas für die Umwelt tun möchte, ist hier goldrichtig. Ich kann P&C nur wärmstens empfehlen und werde definitiv wieder hier einkaufen!",
"date": "2022-05-19"
},
{
"name": "Femke van der Meer",
"rating": 5,
"review": "Tolle Qualität, schnell geliefert.",
"date": "2023-12-11"
},
{
"name": "Magnus Eriksen",
"rating": 5,
"review": "Ich möchte meine durchweg positive Erfahrung mit P&C teilen:<br><br><strong>Positives:</strong><br>1. Außergewöhnlich hohe Qualität der Kleidung<br>2. Umweltbewusste Verpackung und nachhaltige Produktion<br>3. Beeindruckend schnelle Lieferung (3 Tage bei mir)<br>4. Kundenservice auf höchstem Niveau<br>5. Preis-Leistungs-Verhältnis stimmt absolut<br>6. Kostenlose Rücksendeoption - ein echter Pluspunkt<br><br><strong>Beachtenswert:</strong><br>- Die Preise liegen etwas über denen von Fast-Fashion-Ketten, aber die Qualität rechtfertigt das vollkommen<br><br><strong>Persönliches Erlebnis:</strong> Bei einer Bestellung hatte ich Zweifel an der Größenwahl. Der Kundenservice beriet mich ausführlich und geduldig. Als die Lieferung dann doch nicht 100% passte, war der Umtausch völlig unkompliziert.<br><br><strong>Wichtige Warnung:</strong> Bitte bestellt ausschließlich direkt bei P&C! Es existieren zahlreiche Fake-Shops, besonders auf Social-Media-Plattformen und sogar bei Google-Anzeigen, die P&Cs Bilder verwenden, aber minderwertige und potenziell gesundheitsschädliche Produkte liefern. Der geringe Preisunterschied lohnt sich definitiv für die echte P&C-Qualität.<br><br><strong>Abschließendes Urteil:</strong> P&C verkörpert für mich echte 'Made in Germany'-Qualität, gepaart mit zeitgemäßem Stil, Nachhaltigkeit und herausragendem Kundenservice. Für alle, die Wert auf langlebige, stilvolle Mode legen und dabei ein gutes Gewissen haben möchten, ist P&C die perfekte Wahl. Ich kann diesen Shop aus vollem Herzen empfehlen und werde mit Sicherheit wieder hier einkaufen!",
"date": "2024-03-07"
},

{
"name": "Sabine Weber",
"rating": 5,
"review": "Klasse!",
"date": "2015-04-12"
},
{
"name": "Étienne Dupont",
"rating": 4,
"review": "Gute Erfahrung gemacht. Die Artikel kamen innerhalb von 3 Tagen an und die Qualität ist wirklich überzeugend. Der Kundenservice war sehr freundlich bei einer Frage zum Material. Ein Stern Abzug, weil ein Teil minimal von der Beschreibung abwich, aber insgesamt bin ich zufrieden.",
"date": "2016-08-23"
},
{
"name": "Linnea Johansson",
"rating": 5,
"review": "P&C hat mich echt begeistert! Meine Bestellung war schon nach einem Tag da, und die Verpackung war komplett recyclebar - super umweltfreundlich! Die Qualität der Kleidung ist erstklassig, man merkt sofort den Unterschied zu billiger Massenware. Als ich eine Frage zur Pflege hatte, war der Kundenservice superschnell und kompetent. Klare Empfehlung!",
"date": "2017-12-05"
},
{
"name": "Markus Hoffmann",
"rating": 4,
"review": "Gute Produkte, zügig geliefert.",
"date": "2018-05-17"
},
{
"name": "Chiara Bianchi",
"rating": 5,
"review": "Ich bin total begeistert von P&C und möchte meine Erfahrungen teilen:<br><br><strong>Positiv:</strong><br>- Außergewöhnliche Qualität der Kleidung<br>- Nachhaltige Produktion und umweltschonende Verpackung<br>- Rasche Lieferung (bei mir 4 Tage)<br>- Herausragender Kundenservice<br>- Kostenlose Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Etwas höhere Preise als bei Discountern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte versehentlich die falsche Farbe bestellt. Der Umtauschprozess war unglaublich einfach und schnell. Der Kundenservice war dabei außerordentlich zuvorkommend und lösungsorientiert.<br><br><strong>Wichtiger Hinweis:</strong> Bestellt unbedingt nur direkt bei P&C! Es gibt leider viele Fake-Shops mit den gleichen Bildern, aber minderwertiger Ware.<br><br><strong>Fazit:</strong> P&C steht für echte Qualität 'Made in Germany' mit Stil und gutem Gewissen. Wer Wert auf Nachhaltigkeit, Top-Service und langlebige Mode legt, ist hier genau richtig. Absolute Kaufempfehlung!",
"date": "2019-10-30"
},
{
"name": "Anders Petersen",
"rating": 5,
"review": "Tadellos!",
"date": "2020-03-14"
},
{
"name": "Juliette Rousseau",
"rating": 4,
"review": "Ich bin sehr angetan von meinem Einkauf bei P&C. Die Qualität der Kleidung ist wirklich hervorragend und die Designs sind sehr zeitgemäß. Meine Bestellung kam innerhalb von 5 Tagen an, was ich okay finde. Der Kundenservice war auch top - ich hatte eine Frage zur Kombination verschiedener Teile und bekam tolle Styling-Tipps. Ein Stern Abzug, weil ein Teil minimal anders ausfiel als erwartet, aber das ist bei Online-Bestellungen manchmal so. Die kostenlose Rücksendeoption macht das aber wieder wett. Insgesamt eine sehr positive Erfahrung!",
"date": "2021-07-09"
},
{
"name": "Piotr Kowalski",
"rating": 5,
"review": "P&C hat mich rundum überzeugt! Hier meine detaillierte Bewertung:<br><br><strong>Vorteile:</strong><br>1. Erstklassige Qualität der Kleidung<br>2. Nachhaltige Produktion und umweltfreundliche Verpackung<br>3. Blitzschnelle Lieferung (bei mir waren es nur 2 Tage!)<br>4. Kundenservice der Extraklasse<br>5. Faire Preise für die gebotene Qualität<br>6. Kostenlose und unkomplizierte Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Die Preise sind etwas höher als bei Fast-Fashion-Anbietern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte ein Problem mit der Passform eines Artikels und war überwältigt, wie kulant und schnell der Kundenservice reagierte. Sie boten mir sogar einen zusätzlichen Rabatt für die kleine Unannehmlichkeit an!<br><br><strong>Wichtiger Hinweis:</strong> Bitte seid vorsichtig und bestellt nur direkt bei P&C! Es gibt viele Fake-Shops, besonders auf sozialen Medien, die die gleichen Bilder verwenden, aber minderwertige und teilweise sogar gesundheitsschädliche Produkte liefern.<br><br><strong>Fazit:</strong> P&C steht für echte 'Made in Germany'-Qualität, kombiniert mit Stil, Nachhaltigkeit und exzellentem Service. Wer Wert auf langlebige Mode legt und dabei noch etwas für die Umwelt tun möchte, ist hier goldrichtig. Ich kann P&C nur wärmstens empfehlen und werde definitiv wieder hier einkaufen!",
"date": "2022-11-23"
},
{
"name": "Anouk de Vries",
"rating": 5,
"review": "Hervorragende Qualität, prompt geliefert.",
"date": "2023-06-18"
},
{
"name": "Sven Lindgren",
"rating": 5,
"review": "Ich möchte meine durchweg positive Erfahrung mit P&C teilen:<br><br><strong>Positives:</strong><br>1. Außergewöhnlich hohe Qualität der Kleidung<br>2. Umweltbewusste Verpackung und nachhaltige Produktion<br>3. Beeindruckend schnelle Lieferung (3 Tage bei mir)<br>4. Kundenservice auf höchstem Niveau<br>5. Preis-Leistungs-Verhältnis stimmt absolut<br>6. Kostenlose Rücksendeoption - ein echter Pluspunkt<br><br><strong>Beachtenswert:</strong><br>- Die Preise liegen etwas über denen von Fast-Fashion-Ketten, aber die Qualität rechtfertigt das vollkommen<br><br><strong>Persönliches Erlebnis:</strong> Bei einer Bestellung hatte ich Zweifel an der Größenwahl. Der Kundenservice beriet mich ausführlich und geduldig. Als die Lieferung dann doch nicht 100% passte, war der Umtausch völlig unkompliziert.<br><br><strong>Wichtige Warnung:</strong> Bitte bestellt ausschließlich direkt bei P&C! Es existieren zahlreiche Fake-Shops, besonders auf Social-Media-Plattformen und sogar bei Google-Anzeigen, die P&Cs Bilder verwenden, aber minderwertige und potenziell gesundheitsschädliche Produkte liefern. Der geringe Preisunterschied lohnt sich definitiv für die echte P&C-Qualität.<br><br><strong>Abschließendes Urteil:</strong> P&C verkörpert für mich echte 'Made in Germany'-Qualität, gepaart mit zeitgemäßem Stil, Nachhaltigkeit und herausragendem Kundenservice. Für alle, die Wert auf langlebige, stilvolle Mode legen und dabei ein gutes Gewissen haben möchten, ist P&C die perfekte Wahl. Ich kann diesen Shop aus vollem Herzen empfehlen und werde mit Sicherheit wieder hier einkaufen!",
"date": "2024-01-05"
},


  
  {
    "name": "Franziska Huber",
    "rating": 5,
    "review": "Alles perfekt! Gerne wieder.",
    "date": "2022-04-11"
  },
  {
    "name": "Milan Popovic",
    "rating": 4,
    "review": "Guter Service und schnelle Lieferung. Die Verpackung war sehr umweltfreundlich. Bei einer Frage zum Produkt hat der Kundensupport sofort geantwortet. Ein kleiner Punktabzug, weil ein Artikel nicht ganz der Beschreibung entsprach.",
    "date": "2019-06-04"
  },
  {
    "name": "Elodie Martin",
    "rating": 5,
    "review": "Einfach super! Die Produkte sind von höchster Qualität, der Versand war super schnell und die Verpackung total nachhaltig. Der Umtausch, weil ein Teil nicht gepasst hat, war unkompliziert und schnell. Ich werde hier definitiv wieder einkaufen!",
    "date": "2023-09-01"
  },
  {
    "name": "Andreas Janssen",
    "rating": 5,
    "review": "Wahnsinnig guter Service, tolle Qualität und blitzschneller Versand. Alles in einer schönen, nachhaltigen Verpackung ohne Plastik. Der Kundenservice hat mich über jeden Schritt auf dem Laufenden gehalten, und die Rücksendung eines Artikels war kinderleicht und kostenlos. Absolut empfehlenswert!",
    "date": "2024-02-21"
  },
  {
    "name": "Anja Schmidt",
    "rating": 4,
    "review": "Bin zufrieden, Versand war schnell, aber die Größe passte nicht perfekt.",
    "date": "2018-11-18"
  },
  {
    "name": "Marko Kovač",
    "rating": 5,
    "review": "Ich war positiv überrascht! Der Versand ging super schnell, die Qualität ist spitze, und die Verpackung war ohne Plastik. Ein Artikel war zu klein, aber der Umtausch war unkompliziert und kostenlos. Toller Service!",
    "date": "2020-05-23"
  },
  {
    "name": "Lena Fischer",
    "rating": 5,
    "review": "Super zufrieden! Die Lieferung kam sehr schnell, und die Produkte waren gut verpackt. Besonders toll finde ich die nachhaltige Verpackung und den schnellen Umtausch bei falschen Größen. Das Rückgabesystem ist echt einfach. Werde wieder hier einkaufen!",
    "date": "2021-07-06"
  },
  {
    "name": "Kristof Nagy",
    "rating": 4,
    "review": "Die Ware ist gut, aber die Lieferung hätte schneller sein können. Trotzdem super Service und einfache Rücksendung.",
    "date": "2017-09-27"
  },
  {
    "name": "Giulia Bianchi",
    "rating": 5,
    "review": "Toller Online-Shop! Die Bestellung kam innerhalb von 3 Tagen an, und ich bin von der Qualität wirklich überzeugt. Nachhaltigkeit wird hier großgeschrieben, und die Rücksendung ist kostenlos, was heutzutage eine echte Seltenheit ist. Ich kaufe hier gerne wieder ein.",
    "date": "2022-03-19"
  },
  {
    "name": "Hugo Laurent",
    "rating": 5,
    "review": "Ich bin begeistert von diesem Shop! Die Produkte kamen super schnell, und die Verpackung ist total umweltfreundlich. Der Kundenservice ist großartig, und der Umtausch eines Artikels war einfach und kostenlos. Sehr zu empfehlen!",
    "date": "2023-10-12"
  },




{
"name": "Ute Schneider",
"rating": 5,
"review": "Spitze!",
"date": "2015-07-28"
},
{
"name": "François Martin",
"rating": 4,
"review": "Sehr gute Erfahrung gemacht. Die Artikel kamen innerhalb von 4 Tagen an und die Qualität ist wirklich beeindruckend. Der Kundenservice war äußerst hilfsbereit bei einer Frage zur Stoffzusammensetzung. Ein Stern Abzug, weil ein Teil minimal von der Farbdarstellung online abwich, aber insgesamt bin ich sehr zufrieden.",
"date": "2016-12-15"
},
{
"name": "Astrid Bergström",
"rating": 5,
"review": "P&C hat mich total überzeugt! Meine Bestellung war schon nach 2 Tagen da, und die Verpackung war komplett plastikfrei - echt vorbildlich! Die Qualität der Kleidung ist erstklassig, man spürt sofort den Unterschied zu billiger Massenware. Als ich eine Frage zur Pflege hatte, war der Kundenservice blitzschnell und super kompetent. Absolute Kaufempfehlung!",
"date": "2017-09-03"
},
{
"name": "Dieter Wagner",
"rating": 4,
"review": "Sehr gute Produkte, zügig geliefert.",
"date": "2018-04-19"
},
{
"name": "Giulia Conti",
"rating": 5,
"review": "Ich bin absolut begeistert von P&C und möchte meine Erfahrungen teilen:<br><br><strong>Positiv:</strong><br>- Herausragende Qualität der Kleidung<br>- Nachhaltige Produktion und umweltfreundliche Verpackung<br>- Schnelle Lieferung (bei mir 3 Tage)<br>- Exzellenter Kundenservice<br>- Kostenlose Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Etwas höhere Preise als bei Massenherstellern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte versehentlich die falsche Größe bestellt. Der Umtauschprozess war unglaublich einfach und schnell. Der Kundenservice war dabei außergewöhnlich freundlich und lösungsorientiert.<br><br><strong>Wichtiger Hinweis:</strong> Bestellt unbedingt nur direkt bei P&C! Es gibt leider viele Fake-Shops mit den gleichen Bildern, aber minderwertiger Ware.<br><br><strong>Fazit:</strong> P&C steht für echte Qualität 'Made in Germany' mit Stil und gutem Gewissen. Wer Wert auf Nachhaltigkeit, Top-Service und langlebige Mode legt, ist hier genau richtig. Absolute Kaufempfehlung!",
"date": "2019-11-27"
},
{
"name": "Jens Nielsen",
"rating": 5,
"review": "Erstklassig!",
"date": "2020-06-08"
},
{
"name": "Céline Durand",
"rating": 4,
"review": "Ich bin sehr zufrieden mit meinem Einkauf bei P&C. Die Qualität der Kleidung ist wirklich erstklassig und die Designs sind sehr ansprechend. Meine Bestellung kam innerhalb von 5 Tagen an, was ich in Ordnung finde. Der Kundenservice war auch top - ich hatte eine Frage zur Kombination verschiedener Teile und bekam sehr hilfreiche Styling-Tipps. Ein Stern Abzug, weil ein Teil minimal anders ausfiel als erwartet, aber das ist bei Online-Bestellungen manchmal so. Die kostenlose Rücksendeoption macht das aber wieder wett. Insgesamt eine sehr positive Erfahrung!",
"date": "2021-02-14"
},
{
"name": "Marek Wiśniewski",
"rating": 5,
"review": "P&C hat mich vollkommen überzeugt! Hier meine ausführliche Bewertung:<br><br><strong>Vorteile:</strong><br>1. Herausragende Qualität der Kleidung<br>2. Nachhaltige Produktion und umweltfreundliche Verpackung<br>3. Sehr schnelle Lieferung (bei mir waren es nur 2 Tage!)<br>4. Kundenservice der Spitzenklasse<br>5. Faire Preise für die gebotene Qualität<br>6. Kostenlose und unkomplizierte Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Die Preise sind etwas höher als bei Fast-Fashion-Anbietern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte ein Problem mit der Passform eines Artikels und war überwältigt, wie kulant und schnell der Kundenservice reagierte. Sie boten mir sogar einen zusätzlichen Rabatt für die kleine Unannehmlichkeit an!<br><br><strong>Wichtiger Hinweis:</strong> Bitte seid vorsichtig und bestellt nur direkt bei P&C! Es gibt viele Fake-Shops, besonders auf sozialen Medien, die die gleichen Bilder verwenden, aber minderwertige und teilweise sogar gesundheitsschädliche Produkte liefern.<br><br><strong>Fazit:</strong> P&C steht für echte 'Made in Germany'-Qualität, kombiniert mit Stil, Nachhaltigkeit und exzellentem Service. Wer Wert auf langlebige Mode legt und dabei noch etwas für die Umwelt tun möchte, ist hier goldrichtig. Ich kann P&C nur wärmstens empfehlen und werde definitiv wieder hier einkaufen!",
"date": "2022-08-30"
},
{
"name": "Fleur van den Berg",
"rating": 5,
"review": "Ausgezeichnete Qualität, blitzschnell geliefert.",
"date": "2023-05-11"
},
{
"name": "Mikael Svensson",
"rating": 5,
"review": "Ich möchte meine durchweg positive Erfahrung mit P&C teilen:<br><br><strong>Positives:</strong><br>1. Außergewöhnlich hohe Qualität der Kleidung<br>2. Umweltbewusste Verpackung und nachhaltige Produktion<br>3. Beeindruckend schnelle Lieferung (3 Tage bei mir)<br>4. Kundenservice auf höchstem Niveau<br>5. Preis-Leistungs-Verhältnis stimmt absolut<br>6. Kostenlose Rücksendeoption - ein echter Pluspunkt<br><br><strong>Beachtenswert:</strong><br>- Die Preise liegen etwas über denen von Fast-Fashion-Ketten, aber die Qualität rechtfertigt das vollkommen<br><br><strong>Persönliches Erlebnis:</strong> Bei einer Bestellung hatte ich Zweifel an der Größenwahl. Der Kundenservice beriet mich ausführlich und geduldig. Als die Lieferung dann doch nicht 100% passte, war der Umtausch völlig unkompliziert.<br><br><strong>Wichtige Warnung:</strong> Bitte bestellt ausschließlich direkt bei P&C! Es existieren zahlreiche Fake-Shops, besonders auf Social-Media-Plattformen und sogar bei Google-Anzeigen, die P&Cs Bilder verwenden, aber minderwertige und potenziell gesundheitsschädliche Produkte liefern. Der geringe Preisunterschied lohnt sich definitiv für die echte P&C-Qualität.<br><br><strong>Abschließendes Urteil:</strong> P&C verkörpert für mich echte 'Made in Germany'-Qualität, gepaart mit zeitgemäßem Stil, Nachhaltigkeit und herausragendem Kundenservice. Für alle, die Wert auf langlebige, stilvolle Mode legen und dabei ein gutes Gewissen haben möchten, ist P&C die perfekte Wahl. Ich kann diesen Shop aus vollem Herzen empfehlen und werde mit Sicherheit wieder hier einkaufen!",
"date": "2024-01-19"
},

  
  {
    "name": "Hanna Schäfer",
    "rating": 5,
    "review": "Schneller Versand, super zufrieden!",
    "date": "2021-03-14"
  },
  {
    "name": "Olivier Bernard",
    "rating": 4,
    "review": "Die Lieferung war schnell, und die Verpackung sehr umweltfreundlich. Ein Artikel hat nicht ganz gepasst, aber die Rücksendung war einfach und kostenlos. Gerne wieder!",
    "date": "2019-12-02"
  },
  {
    "name": "Karolina Zielinska",
    "rating": 5,
    "review": "Ich bin total begeistert! Die Qualität der Produkte ist super, und die Verpackung ist nachhaltig und ohne Plastik. Die Lieferung war unglaublich schnell, und der Kundenservice hat mir bei einer Frage sofort weitergeholfen. Sehr empfehlenswert!",
    "date": "2023-04-21"
  },
  {
    "name": "Sven Jorgensen",
    "rating": 5,
    "review": "Perfekter Service! Ich wurde immer über den Status meiner Bestellung informiert, und die Qualität der Produkte ist wirklich spitze. Die Verpackung ohne Plastik ist ein großer Pluspunkt. Bei einem kleinen Problem mit der Größe hat der Umtausch reibungslos funktioniert. Kann ich nur empfehlen!",
    "date": "2022-06-30"
  },
  {
    "name": "Marta Nowak",
    "rating": 4,
    "review": "Lieferung war schnell, aber die Größe hat nicht ganz gepasst. Rücksendung lief aber problemlos.",
    "date": "2017-10-07"
  },
  {
    "name": "Luca Romano",
    "rating": 5,
    "review": "Ich bin begeistert von der Qualität der Kleidung. Der Versand war sehr schnell, und die Verpackung war absolut nachhaltig. Rücksendung eines Teils war kostenlos und einfach. Toller Shop, werde wieder bestellen!",
    "date": "2020-08-15"
  },
  {
    "name": "Tineke van der Berg",
    "rating": 5,
    "review": "Fantastischer Shop! Die Kleidung ist von hervorragender Qualität, und die schnelle Lieferung hat mich begeistert. Besonders gut gefällt mir, dass die Verpackung plastikfrei ist. Ich hatte keine Probleme mit der Rücksendung eines Artikels. Super Service!",
    "date": "2023-01-04"
  },
  {
    "name": "Mikko Virtanen",
    "rating": 4,
    "review": "Die Produkte sind gut, aber der Versand könnte schneller sein. Der Umtausch ging dafür reibungslos.",
    "date": "2018-04-19"
  },
  {
    "name": "Zofia Kaminska",
    "rating": 5,
    "review": "Super schnelle Lieferung, tolle Qualität und umweltfreundliche Verpackung! Der Kundenservice hat mir sofort bei meiner Frage geholfen. Die kostenlose Rücksendung ist ein großes Plus. Ich werde hier definitiv wieder einkaufen.",
    "date": "2024-03-12"
  },
  {
    "name": "Henrik Olsen",
    "rating": 5,
    "review": "Absolut empfehlenswert! Die Lieferung kam extrem schnell, die Verpackung ist nachhaltig, und die Qualität der Produkte ist hervorragend. Auch die Rücksendung eines Teils war kinderleicht. Hier werde ich garantiert wieder bestellen!",
    "date": "2020-11-08"
  },


{
"name": "Heike Müller",
"rating": 5,
"review": "Toll!",
"date": "2015-05-16"
},
{
"name": "Léo Dubois",
"rating": 4,
"review": "Sehr gute Erfahrung gemacht. Die Artikel kamen innerhalb von 3 Tagen an und die Qualität ist wirklich überzeugend. Der Kundenservice war sehr hilfsbereit bei einer Frage zur Größenauswahl. Ein Stern Abzug, weil ein Teil minimal von der Farbdarstellung online abwich, aber insgesamt bin ich zufrieden.",
"date": "2016-09-28"
},
{
"name": "Maja Andersson",
"rating": 5,
"review": "P&C hat mich echt beeindruckt! Meine Bestellung war schon nach 2 Tagen da, und die Verpackung war komplett recyclebar - super umweltfreundlich! Die Qualität der Kleidung ist erstklassig, man merkt sofort den Unterschied zu billiger Massenware. Als ich eine Frage zur Kombination hatte, war der Kundenservice superschnell und kompetent. Klare Empfehlung!",
"date": "2017-11-03"
},
{
"name": "Ralf Becker",
"rating": 4,
"review": "Gute Produkte, schnell geliefert.",
"date": "2018-07-20"
},
{
"name": "Sofia Moretti",
"rating": 5,
"review": "Ich bin total begeistert von P&C und möchte meine Erfahrungen teilen:<br><br><strong>Positiv:</strong><br>- Außergewöhnliche Qualität der Kleidung<br>- Nachhaltige Produktion und umweltschonende Verpackung<br>- Rasche Lieferung (bei mir 4 Tage)<br>- Herausragender Kundenservice<br>- Kostenlose Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Etwas höhere Preise als bei Discountern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte versehentlich die falsche Größe bestellt. Der Umtauschprozess war unglaublich einfach und schnell. Der Kundenservice war dabei außerordentlich zuvorkommend und lösungsorientiert.<br><br><strong>Wichtiger Hinweis:</strong> Bestellt unbedingt nur direkt bei P&C! Es gibt leider viele Fake-Shops mit den gleichen Bildern, aber minderwertiger Ware.<br><br><strong>Fazit:</strong> P&C steht für echte Qualität 'Made in Germany' mit Stil und gutem Gewissen. Wer Wert auf Nachhaltigkeit, Top-Service und langlebige Mode legt, ist hier genau richtig. Absolute Kaufempfehlung!",
"date": "2019-02-14"
},
{
"name": "Lars Pedersen",
"rating": 5,
"review": "Perfekt!",
"date": "2020-08-09"
},
{
"name": "Amélie Laurent",
"rating": 4,
"review": "Ich bin sehr angetan von meinem Einkauf bei P&C. Die Qualität der Kleidung ist wirklich hervorragend und die Designs sind sehr zeitgemäß. Meine Bestellung kam innerhalb von 5 Tagen an, was ich okay finde. Der Kundenservice war auch top - ich hatte eine Frage zur Pflege und bekam sehr hilfreiche Tipps. Ein Stern Abzug, weil ein Teil minimal anders ausfiel als erwartet, aber das ist bei Online-Bestellungen manchmal so. Die kostenlose Rücksendeoption macht das aber wieder wett. Insgesamt eine sehr positive Erfahrung!",
"date": "2021-04-30"
},
{
"name": "Tomasz Nowak",
"rating": 5,
"review": "P&C hat mich rundum überzeugt! Hier meine detaillierte Bewertung:<br><br><strong>Vorteile:</strong><br>1. Erstklassige Qualität der Kleidung<br>2. Nachhaltige Produktion und umweltfreundliche Verpackung<br>3. Blitzschnelle Lieferung (bei mir waren es nur 2 Tage!)<br>4. Kundenservice der Extraklasse<br>5. Faire Preise für die gebotene Qualität<br>6. Kostenlose und unkomplizierte Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Die Preise sind etwas höher als bei Fast-Fashion-Anbietern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte ein Problem mit der Passform eines Artikels und war überwältigt, wie kulant und schnell der Kundenservice reagierte. Sie boten mir sogar einen zusätzlichen Rabatt für die kleine Unannehmlichkeit an!<br><br><strong>Wichtiger Hinweis:</strong> Bitte seid vorsichtig und bestellt nur direkt bei P&C! Es gibt viele Fake-Shops, besonders auf sozialen Medien, die die gleichen Bilder verwenden, aber minderwertige und teilweise sogar gesundheitsschädliche Produkte liefern.<br><br><strong>Fazit:</strong> P&C steht für echte 'Made in Germany'-Qualität, kombiniert mit Stil, Nachhaltigkeit und exzellentem Service. Wer Wert auf langlebige Mode legt und dabei noch etwas für die Umwelt tun möchte, ist hier goldrichtig. Ich kann P&C nur wärmstens empfehlen und werde definitiv wieder hier einkaufen!",
"date": "2022-10-17"
},
{
"name": "Lotte de Jong",
"rating": 5,
"review": "Erstklassige Qualität, prompte Lieferung.",
"date": "2023-03-25"
},
{
"name": "Erik Gustafsson",
"rating": 5,
"review": "Ich möchte meine durchweg positive Erfahrung mit P&C teilen:<br><br><strong>Positives:</strong><br>1. Außergewöhnlich hohe Qualität der Kleidung<br>2. Umweltbewusste Verpackung und nachhaltige Produktion<br>3. Beeindruckend schnelle Lieferung (3 Tage bei mir)<br>4. Kundenservice auf höchstem Niveau<br>5. Preis-Leistungs-Verhältnis stimmt absolut<br>6. Kostenlose Rücksendeoption - ein echter Pluspunkt<br><br><strong>Beachtenswert:</strong><br>- Die Preise liegen etwas über denen von Fast-Fashion-Ketten, aber die Qualität rechtfertigt das vollkommen<br><br><strong>Persönliches Erlebnis:</strong> Bei einer Bestellung hatte ich Zweifel an der Größenwahl. Der Kundenservice beriet mich ausführlich und geduldig. Als die Lieferung dann doch nicht 100% passte, war der Umtausch völlig unkompliziert.<br><br><strong>Wichtige Warnung:</strong> Bitte bestellt ausschließlich direkt bei P&C! Es existieren zahlreiche Fake-Shops, besonders auf Social-Media-Plattformen und sogar bei Google-Anzeigen, die P&Cs Bilder verwenden, aber minderwertige und potenziell gesundheitsschädliche Produkte liefern. Der geringe Preisunterschied lohnt sich definitiv für die echte P&C-Qualität.<br><br><strong>Abschließendes Urteil:</strong> P&C verkörpert für mich echte 'Made in Germany'-Qualität, gepaart mit zeitgemäßem Stil, Nachhaltigkeit und herausragendem Kundenservice. Für alle, die Wert auf langlebige, stilvolle Mode legen und dabei ein gutes Gewissen haben möchten, ist P&C die perfekte Wahl. Ich kann diesen Shop aus vollem Herzen empfehlen und werde mit Sicherheit wieder hier einkaufen!",
"date": "2024-07-11"
},




  {
    "name": "Lara Hoffmann",
    "rating": 5,
    "review": "Sehr schnelle Lieferung, alles bestens!",
    "date": "2019-07-10"
  },
  {
    "name": "Jan Kowalski",
    "rating": 4,
    "review": "Die Ware war gut, nur ein Artikel entsprach nicht ganz der Beschreibung. Rücksendung lief problemlos.",
    "date": "2020-02-14"
  },
  {
    "name": "Maria Duarte",
    "rating": 5,
    "review": "Fantastische Qualität und blitzschneller Versand. Die nachhaltige Verpackung hat mir besonders gefallen, da kein Plastik verwendet wurde. Außerdem war der Kundenservice immer erreichbar und hilfsbereit. Rücksendungen sind hier sehr einfach und kostenlos. Rundum zufrieden!",
    "date": "2023-09-20"
  },
  {
    "name": "Niels Rasmussen",
    "rating": 5,
    "review": "Toller Service! Wurde regelmäßig über den Bestellstatus informiert. Die Lieferung war schnell, und die Verpackung ist wirklich umweltfreundlich. Ein Artikel passte nicht, aber der Umtausch war unkompliziert und kostenlos. Super Shop!",
    "date": "2021-05-19"
  },
  {
    "name": "Amelie Schneider",
    "rating": 4,
    "review": "Alles gut, aber die Lieferzeit hätte etwas kürzer sein können. Trotzdem sehr zufrieden.",
    "date": "2017-08-02"
  },
  {
    "name": "Daan de Jong",
    "rating": 5,
    "review": "Ich war sehr positiv überrascht! Die Ware war super schnell da, die Qualität ist überragend und die Verpackung ganz ohne Plastik. Der Umtausch bei einer falschen Größe war einfach und kostenlos. Ein Shop, den ich definitiv weiterempfehle!",
    "date": "2020-04-03"
  },
  {
    "name": "Sofia Costa",
    "rating": 5,
    "review": "Super schneller Versand, die Produkte waren in einer nachhaltigen Verpackung. Die Qualität ist top und der Kundenservice war wirklich hilfreich. Werde hier definitiv wieder bestellen!",
    "date": "2022-12-28"
  },
  {
    "name": "Pavel Horak",
    "rating": 4,
    "review": "Gute Qualität, aber die Lieferung dauerte länger als erwartet. Rücksendung war kostenlos, das hat es wieder gut gemacht.",
    "date": "2016-03-21"
  },
  {
    "name": "Emma Fischer",
    "rating": 5,
    "review": "Ich bin rundum zufrieden! Die Produkte kamen schnell und waren umweltfreundlich verpackt. Ein Artikel war leider zu klein, aber der Umtausch war einfach und problemlos. Großartige Qualität und super Service!",
    "date": "2024-01-15"
  },
  {
    "name": "Lucas Martens",
    "rating": 5,
    "review": "Sehr empfehlenswert! Die Qualität der Kleidung ist erstklassig, und die Lieferung war super schnell. Besonders positiv überrascht hat mich die nachhaltige Verpackung und der tolle Kundenservice. Ich werde definitiv wieder bestellen!",
    "date": "2021-11-09"
  },


{
"name": "Brigitte Schmidt",
"rating": 5,
"review": "Klasse!",
"date": "2015-10-08"
},
{
"name": "Adrien Mercier",
"rating": 4,
"review": "Positive Erfahrung gemacht. Die Bestellung traf innerhalb von 4 Tagen ein und die Qualität ist beeindruckend. Der Kundenservice war sehr hilfreich bei einer Frage zum Material. Ein Stern Abzug, weil ein Artikel leicht von der Online-Darstellung abwich, aber insgesamt bin ich zufrieden.",
"date": "2016-06-19"
},
{
"name": "Ingrid Karlsson",
"rating": 5,
"review": "P&C hat mich echt überrascht! Meine Bestellung war bereits nach einem Tag da, und die Verpackung war komplett plastikfrei - sehr umweltbewusst! Die Qualität der Kleidung ist erstklassig, man spürt direkt den Unterschied zu Fast Fashion. Als ich eine Frage zur Kombinierbarkeit hatte, war der Kundenservice schnell und sehr hilfsbereit. Eindeutige Empfehlung!",
"date": "2017-01-30"
},
{
"name": "Wolfgang Klein",
"rating": 4,
"review": "Gute Artikel, prompt geliefert.",
"date": "2018-11-05"
},
{
"name": "Valentina Rossi",
"rating": 5,
"review": "Ich bin absolut begeistert von P&C und möchte meine Erfahrungen teilen:<br><br><strong>Positiv:</strong><br>- Herausragende Qualität der Kleidung<br>- Nachhaltige Produktion und umweltfreundliche Verpackung<br>- Schnelle Lieferung (bei mir 3 Tage)<br>- Exzellenter Kundenservice<br>- Kostenlose Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Etwas höhere Preise als bei Massenherstellern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte versehentlich die falsche Farbe bestellt. Der Umtauschprozess war unglaublich einfach und schnell. Der Kundenservice war dabei außergewöhnlich freundlich und lösungsorientiert.<br><br><strong>Wichtiger Hinweis:</strong> Bestellt unbedingt nur direkt bei P&C! Es gibt leider viele Fake-Shops mit den gleichen Bildern, aber minderwertiger Ware.<br><br><strong>Fazit:</strong> P&C steht für echte Qualität 'Made in Germany' mit Stil und gutem Gewissen. Wer Wert auf Nachhaltigkeit, Top-Service und langlebige Mode legt, ist hier genau richtig. Absolute Kaufempfehlung!",
"date": "2019-07-22"
},
{
"name": "Magnus Olsen",
"rating": 5,
"review": "Erstklassig!",
"date": "2020-02-14"
},
{
"name": "Sophie Lemaire",
"rating": 4,
"review": "Ich bin sehr zufrieden mit meinem Einkauf bei P&C. Die Qualität der Kleidung ist wirklich hervorragend und die Designs sind sehr ansprechend. Meine Bestellung kam innerhalb von 5 Tagen an, was ich in Ordnung finde. Der Kundenservice war auch top - ich hatte eine Frage zur Pflege und bekam sehr hilfreiche Tipps. Ein Stern Abzug, weil ein Teil minimal anders ausfiel als erwartet, aber das ist bei Online-Bestellungen manchmal so. Die kostenlose Rücksendeoption macht das aber wieder wett. Insgesamt eine sehr positive Erfahrung!",
"date": "2021-12-03"
},
{
"name": "Jakub Kowalczyk",
"rating": 5,
"review": "P&C hat mich vollkommen überzeugt! Hier meine ausführliche Bewertung:<br><br><strong>Vorteile:</strong><br>1. Erstklassige Qualität der Kleidung<br>2. Nachhaltige Produktion und umweltfreundliche Verpackung<br>3. Sehr schnelle Lieferung (bei mir waren es nur 2 Tage!)<br>4. Kundenservice der Spitzenklasse<br>5. Faire Preise für die gebotene Qualität<br>6. Kostenlose und unkomplizierte Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Die Preise sind etwas höher als bei Fast-Fashion-Anbietern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte ein Problem mit der Passform eines Artikels und war überwältigt, wie kulant und schnell der Kundenservice reagierte. Sie boten mir sogar einen zusätzlichen Rabatt für die kleine Unannehmlichkeit an!<br><br><strong>Wichtiger Hinweis:</strong> Bitte seid vorsichtig und bestellt nur direkt bei P&C! Es gibt viele Fake-Shops, besonders auf sozialen Medien, die die gleichen Bilder verwenden, aber minderwertige und teilweise sogar gesundheitsschädliche Produkte liefern.<br><br><strong>Fazit:</strong> P&C steht für echte 'Made in Germany'-Qualität, kombiniert mit Stil, Nachhaltigkeit und exzellentem Service. Wer Wert auf langlebige Mode legt und dabei noch etwas für die Umwelt tun möchte, ist hier goldrichtig. Ich kann P&C nur wärmstens empfehlen und werde definitiv wieder hier einkaufen!",
"date": "2022-09-18"
},
{
"name": "Emma van der Meer",
"rating": 5,
"review": "Hervorragende Qualität, blitzschnell geliefert.",
"date": "2023-04-07"
},
{
"name": "Nils Bergström",
"rating": 5,
"review": "Ich möchte meine durchweg positive Erfahrung mit P&C teilen:<br><br><strong>Positives:</strong><br>1. Außergewöhnlich hohe Qualität der Kleidung<br>2. Umweltbewusste Verpackung und nachhaltige Produktion<br>3. Beeindruckend schnelle Lieferung (3 Tage bei mir)<br>4. Kundenservice auf höchstem Niveau<br>5. Preis-Leistungs-Verhältnis stimmt absolut<br>6. Kostenlose Rücksendeoption - ein echter Pluspunkt<br><br><strong>Beachtenswert:</strong><br>- Die Preise liegen etwas über denen von Fast-Fashion-Ketten, aber die Qualität rechtfertigt das vollkommen<br><br><strong>Persönliches Erlebnis:</strong> Bei einer Bestellung hatte ich Zweifel an der Größenwahl. Der Kundenservice beriet mich ausführlich und geduldig. Als die Lieferung dann doch nicht 100% passte, war der Umtausch völlig unkompliziert.<br><br><strong>Wichtige Warnung:</strong> Bitte bestellt ausschließlich direkt bei P&C! Es existieren zahlreiche Fake-Shops, besonders auf Social-Media-Plattformen und sogar bei Google-Anzeigen, die P&Cs Bilder verwenden, aber minderwertige und potenziell gesundheitsschädliche Produkte liefern. Der geringe Preisunterschied lohnt sich definitiv für die echte P&C-Qualität.<br><br><strong>Abschließendes Urteil:</strong> P&C verkörpert für mich echte 'Made in Germany'-Qualität, gepaart mit zeitgemäßem Stil, Nachhaltigkeit und herausragendem Kundenservice. Für alle, die Wert auf langlebige, stilvolle Mode legen und dabei ein gutes Gewissen haben möchten, ist P&C die perfekte Wahl. Ich kann diesen Shop aus vollem Herzen empfehlen und werde mit Sicherheit wieder hier einkaufen!",
"date": "2024-08-29"
},



  {
    "name": "Isabella Schneider",
    "rating": 5,
    "review": "Schnelle Lieferung, gute Qualität. Gerne wieder!",
    "date": "2018-06-14"
  },
  {
    "name": "Mateo Alonso",
    "rating": 4,
    "review": "Gute Ware, aber die Lieferzeit war etwas länger als erwartet. Rücksendung war zum Glück unkompliziert.",
    "date": "2021-09-07"
  },
  {
    "name": "Katarina Novak",
    "rating": 5,
    "review": "Absolut begeistert! Die Verpackung war sehr umweltfreundlich, und die Lieferung war unglaublich schnell. Der Kundenservice hat mir sofort auf meine Anfrage geantwortet. Ein Artikel passte nicht, aber der Umtausch war kinderleicht. So macht Online-Shopping Spaß!",
    "date": "2023-02-28"
  },
  {
    "name": "Jonas Fischer",
    "rating": 5,
    "review": "Alles top! Schnelle Lieferung, hochwertige Kleidung und die plastikfreie Verpackung finde ich super. Ein Umtausch war nötig, weil die Größe nicht passte, aber das ging problemlos. Werde wieder bestellen!",
    "date": "2022-11-13"
  },
  {
    "name": "Ewa Nowak",
    "rating": 4,
    "review": "Gute Produkte, aber ein Artikel war nicht so wie beschrieben. Rücksendung ging aber einfach und schnell.",
    "date": "2020-03-19"
  },
  {
    "name": "Oliver Dupont",
    "rating": 5,
    "review": "Dieser Shop ist wirklich spitze! Der Versand war schneller als erwartet, und die Qualität ist beeindruckend. Besonders gefallen hat mir, dass die Verpackung komplett ohne Plastik auskommt. Der Umtausch bei einer falschen Größe war kostenlos und schnell erledigt. Ich kaufe hier gerne wieder ein.",
    "date": "2021-05-26"
  },
  {
    "name": "Lea Van Dijk",
    "rating": 5,
    "review": "Super schnelle Lieferung und sehr umweltbewusste Verpackung. Der Kundenservice war extrem hilfsbereit, als ich eine Frage hatte. Die Rücksendung war kostenlos, das schätze ich sehr!",
    "date": "2023-12-09"
  },
  {
    "name": "Timo Müller",
    "rating": 4,
    "review": "Die Produkte sind gut, aber die Lieferung hätte schneller sein können. Rücksendung war aber unkompliziert.",
    "date": "2019-04-23"
  },
  {
    "name": "Anna Petrova",
    "rating": 5,
    "review": "Tolle Qualität und sehr schnelle Lieferung! Die Kleidung ist nachhaltig produziert und die Verpackung umweltfreundlich. Rücksendungen funktionieren problemlos und kostenlos. Definitiv empfehlenswert!",
    "date": "2024-06-18"
  },
  {
    "name": "Maximilian Berg",
    "rating": 5,
    "review": "Ich bin super zufrieden mit meiner Bestellung! Die Produkte sind hochwertig, die Verpackung ist nachhaltig, und die Rücksendung bei einer falschen Größe ging einfach und schnell. Hier werde ich definitiv wieder bestellen.",
    "date": "2020-10-05"
  },


  
  {
    "name": "Sophie Becker",
    "rating": 5,
    "review": "Lieferung ging super schnell, bin sehr zufrieden.",
    "date": "2022-01-25"
  },
  {
    "name": "Luca Rossi",
    "rating": 4,
    "review": "Die Produkte sind gut, aber ein Teil hat nicht ganz der Beschreibung entsprochen. Rücksendung war einfach und kostenlos.",
    "date": "2021-08-14"
  },
  {
    "name": "Maja Svensson",
    "rating": 5,
    "review": "Absolut fantastisch! Die Qualität der Kleidung ist überragend, der Versand war sehr schnell und die plastikfreie Verpackung finde ich klasse. Der Umtausch war super einfach, und der Kundenservice war sehr freundlich. Definitiv mein neuer Lieblingsshop!",
    "date": "2023-03-09"
  },
  {
    "name": "Nikola Kovac",
    "rating": 5,
    "review": "Toller Shop, super schneller Versand, und die Verpackung war nachhaltig und ohne Plastik. Ein Artikel hat nicht gepasst, aber die Rücksendung ging problemlos. Werde hier wieder einkaufen.",
    "date": "2020-10-30"
  },
  {
    "name": "Ayla Meyer",
    "rating": 4,
    "review": "Alles gut, nur die Lieferzeit war etwas lang. Sonst bin ich zufrieden.",
    "date": "2017-04-22"
  },
  {
    "name": "Tomás García",
    "rating": 5,
    "review": "Die Ware kam schnell und in einer nachhaltigen Verpackung. Der Kundenservice war sehr hilfsbereit, als ich eine Frage hatte. Ein Teil war zu klein, aber der Umtausch war unkompliziert und kostenlos. Gerne wieder!",
    "date": "2021-06-12"
  },
  {
    "name": "Pia Dubois",
    "rating": 5,
    "review": "Die Qualität der Produkte ist super, und die Lieferung war sehr schnell. Die plastikfreie Verpackung hat mir besonders gefallen. Rücksendung war kostenlos, und der Umtausch lief reibungslos. Sehr empfehlenswert!",
    "date": "2024-01-08"
  },
  {
    "name": "Erik Johansson",
    "rating": 4,
    "review": "Guter Shop, aber die Lieferung hätte schneller sein können. Rücksendung funktionierte gut.",
    "date": "2018-07-17"
  },
  {
    "name": "Marie Lefevre",
    "rating": 5,
    "review": "Tolle Produkte, schneller Versand, und die Verpackung war total umweltfreundlich. Besonders gefallen hat mir die schnelle Rücksendung, falls mal was nicht passt. Hier werde ich sicher wieder bestellen!",
    "date": "2023-11-01"
  },
  {
    "name": "Henrik Hansen",
    "rating": 5,
    "review": "Ich bin wirklich begeistert! Die Lieferung kam schneller als erwartet, die Produkte sind von bester Qualität, und die Verpackung war komplett nachhaltig. Der Kundenservice war großartig und hat mir schnell geholfen, als ich Fragen hatte. Absolute Empfehlung!",
    "date": "2020-02-19"
  },



{
"name": "Ulrike Weber",
"rating": 5,
"review": "Genial!",
"date": "2015-03-11"
},
{
"name": "Antoine Durand",
"rating": 4,
"review": "Sehr zufrieden mit meinem Einkauf. Die Lieferung erfolgte innerhalb von 3 Tagen und die Qualität ist beeindruckend. Der Kundenservice war äußerst hilfsbereit bei einer Frage zur Größenauswahl. Ein Stern Abzug, weil ein Artikel minimal von der Beschreibung abwich, aber insgesamt eine positive Erfahrung.",
"date": "2016-08-24"
},
{
"name": "Astrid Lindqvist",
"rating": 5,
"review": "P&C hat mich wirklich überrascht! Die Bestellung war schon nach 2 Tagen da, und alles war umweltfreundlich verpackt - kein Plastik in Sicht! Die Qualität der Kleidung ist erstklassig, deutlich besser als Fast Fashion. Der Kundenservice war bei einer Stilfrage superschnell und kompetent. Klare Kaufempfehlung!",
"date": "2017-05-19"
},
{
"name": "Michael Bauer",
"rating": 4,
"review": "Gute Produkte, zügige Lieferung.",
"date": "2018-12-07"
},
{
"name": "Chiara Romano",
"rating": 5,
"review": "Ich bin total begeistert von P&C und teile gerne meine Erfahrungen:<br><br><strong>Positiv:</strong><br>- Außergewöhnliche Qualität der Kleidung<br>- Nachhaltige Produktion und umweltschonende Verpackung<br>- Rasche Lieferung (bei mir 4 Tage)<br>- Herausragender Kundenservice<br>- Kostenlose Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Etwas höhere Preise als bei Discountern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte versehentlich die falsche Größe bestellt. Der Umtauschprozess war unglaublich einfach und schnell. Der Kundenservice war dabei außerordentlich zuvorkommend und lösungsorientiert.<br><br><strong>Wichtiger Hinweis:</strong> Bestellt unbedingt nur direkt bei P&C! Es gibt leider viele Fake-Shops mit den gleichen Bildern, aber minderwertiger Ware.<br><br><strong>Fazit:</strong> P&C steht für echte Qualität 'Made in Germany' mit Stil und gutem Gewissen. Wer Wert auf Nachhaltigkeit, Top-Service und langlebige Mode legt, ist hier genau richtig. Absolute Kaufempfehlung!",
"date": "2019-09-30"
},
{
"name": "Søren Andersen",
"rating": 5,
"review": "Ausgezeichnet!",
"date": "2020-04-15"
},
{
"name": "Marie Dupont",
"rating": 4,
"review": "Ich bin sehr zufrieden mit meinem Einkauf bei P&C. Die Qualität der Kleidung ist wirklich hervorragend und die Designs sind sehr zeitgemäß. Meine Bestellung kam innerhalb von 5 Tagen an, was ich okay finde. Der Kundenservice war auch top - ich hatte eine Frage zur Kombination verschiedener Teile und bekam tolle Styling-Tipps. Ein Stern Abzug, weil ein Teil minimal anders ausfiel als erwartet, aber das ist bei Online-Bestellungen manchmal so. Die kostenlose Rücksendeoption macht das aber wieder wett. Insgesamt eine sehr positive Erfahrung!",
"date": "2021-11-22"
},
{
"name": "Piotr Zieliński",
"rating": 5,
"review": "P&C hat mich rundum überzeugt! Hier meine detaillierte Bewertung:<br><br><strong>Vorteile:</strong><br>1. Erstklassige Qualität der Kleidung<br>2. Nachhaltige Produktion und umweltfreundliche Verpackung<br>3. Blitzschnelle Lieferung (bei mir waren es nur 2 Tage!)<br>4. Kundenservice der Extraklasse<br>5. Faire Preise für die gebotene Qualität<br>6. Kostenlose und unkomplizierte Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Die Preise sind etwas höher als bei Fast-Fashion-Anbietern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte ein Problem mit der Passform eines Artikels und war überwältigt, wie kulant und schnell der Kundenservice reagierte. Sie boten mir sogar einen zusätzlichen Rabatt für die kleine Unannehmlichkeit an!<br><br><strong>Wichtiger Hinweis:</strong> Bitte seid vorsichtig und bestellt nur direkt bei P&C! Es gibt viele Fake-Shops, besonders auf sozialen Medien, die die gleichen Bilder verwenden, aber minderwertige und teilweise sogar gesundheitsschädliche Produkte liefern.<br><br><strong>Fazit:</strong> P&C steht für echte 'Made in Germany'-Qualität, kombiniert mit Stil, Nachhaltigkeit und exzellentem Service. Wer Wert auf langlebige Mode legt und dabei noch etwas für die Umwelt tun möchte, ist hier goldrichtig. Ich kann P&C nur wärmstens empfehlen und werde definitiv wieder hier einkaufen!",
"date": "2022-07-03"
},
{
"name": "Fleur van Dijk",
"rating": 5,
"review": "Top Qualität, super schnelle Lieferung.",
"date": "2023-02-18"
},
{
"name": "Gustav Johansson",
"rating": 5,
"review": "Ich möchte meine durchweg positive Erfahrung mit P&C teilen:<br><br><strong>Positives:</strong><br>1. Außergewöhnlich hohe Qualität der Kleidung<br>2. Umweltbewusste Verpackung und nachhaltige Produktion<br>3. Beeindruckend schnelle Lieferung (3 Tage bei mir)<br>4. Kundenservice auf höchstem Niveau<br>5. Preis-Leistungs-Verhältnis stimmt absolut<br>6. Kostenlose Rücksendeoption - ein echter Pluspunkt<br><br><strong>Beachtenswert:</strong><br>- Die Preise liegen etwas über denen von Fast-Fashion-Ketten, aber die Qualität rechtfertigt das vollkommen<br><br><strong>Persönliches Erlebnis:</strong> Bei einer Bestellung hatte ich Zweifel an der Größenwahl. Der Kundenservice beriet mich ausführlich und geduldig. Als die Lieferung dann doch nicht 100% passte, war der Umtausch völlig unkompliziert.<br><br><strong>Wichtige Warnung:</strong> Bitte bestellt ausschließlich direkt bei P&C! Es existieren zahlreiche Fake-Shops, besonders auf Social-Media-Plattformen und sogar bei Google-Anzeigen, die P&Cs Bilder verwenden, aber minderwertige und potenziell gesundheitsschädliche Produkte liefern. Der geringe Preisunterschied lohnt sich definitiv für die echte P&C-Qualität.<br><br><strong>Abschließendes Urteil:</strong> P&C verkörpert für mich echte 'Made in Germany'-Qualität, gepaart mit zeitgemäßem Stil, Nachhaltigkeit und herausragendem Kundenservice. Für alle, die Wert auf langlebige, stilvolle Mode legen und dabei ein gutes Gewissen haben möchten, ist P&C die perfekte Wahl. Ich kann diesen Shop aus vollem Herzen empfehlen und werde mit Sicherheit wieder hier einkaufen!",
"date": "2024-06-09"
},

  
  {
    "name": "Lena Schuster",
    "rating": 5,
    "review": "Super schnelle Lieferung, top Qualität. Gerne wieder!",
    "date": "2022-05-10"
  },
  {
    "name": "João Pereira",
    "rating": 4,
    "review": "Gutes Produkt, aber die Lieferzeit war länger als erwartet. Rücksendung lief problemlos.",
    "date": "2020-09-23"
  },
  {
    "name": "Emma Dupuis",
    "rating": 5,
    "review": "Ich bin sehr zufrieden! Die Qualität ist hervorragend, und die Lieferung war schneller als gedacht. Besonders toll finde ich die nachhaltige Verpackung ohne Plastik. Der Umtausch bei einer falschen Größe war sehr einfach und schnell. Super Shop!",
    "date": "2023-08-30"
  },
  {
    "name": "Kamil Nowak",
    "rating": 5,
    "review": "Alles perfekt! Schnelle Lieferung, tolle Produkte und die plastikfreie Verpackung ist ein echter Pluspunkt. Die Rücksendung war einfach und kostenlos. Klare Empfehlung!",
    "date": "2021-12-04"
  },
  {
    "name": "Nina Müller",
    "rating": 4,
    "review": "Alles gut, aber ein Artikel entsprach nicht ganz meinen Erwartungen. Trotzdem war die Rücksendung sehr unkompliziert.",
    "date": "2019-03-17"
  },
  {
    "name": "Lars Andersen",
    "rating": 5,
    "review": "Die Produkte kamen schnell an und sind von toller Qualität. Die plastikfreie Verpackung ist ein großer Pluspunkt. Rücksendung ging schnell und problemlos. Werde hier definitiv wieder einkaufen!",
    "date": "2022-11-22"
  },
  {
    "name": "Eva Toma",
    "rating": 5,
    "review": "Die Lieferung war blitzschnell und die Qualität der Produkte ist überragend. Nachhaltige Verpackung ohne Plastik. Ein Artikel musste umgetauscht werden, was super einfach und kostenlos ging. Toller Service!",
    "date": "2024-04-14"
  },
  {
    "name": "Tom Bauer",
    "rating": 4,
    "review": "Gute Qualität, aber die Lieferung dauerte länger als gedacht. Rücksendung war einfach und kostenfrei.",
    "date": "2018-06-29"
  },
  {
    "name": "Sofia Morales",
    "rating": 5,
    "review": "Fantastische Erfahrung! Die Lieferung war schnell, die Verpackung nachhaltig und die Qualität der Produkte top. Der Kundenservice war äußerst hilfsbereit. Ich werde auf jeden Fall wieder bestellen.",
    "date": "2023-07-15"
  },
  {
    "name": "Maximilian Wagner",
    "rating": 5,
    "review": "Absolut begeistert! Schnelle Lieferung, super Qualität und die umweltfreundliche Verpackung ist ein echter Pluspunkt. Rücksendung war kostenlos und unkompliziert. Werde hier sicher öfter bestellen.",
    "date": "2021-10-20"
  },





  {
    "name": "Elena Wagner",
    "rating": 5,
    "review": "Alles bestens, schnelle Lieferung und top Qualität!",
    "date": "2020-05-19"
  },
  {
    "name": "Miguel Santos",
    "rating": 4,
    "review": "Die Produkte sind gut, aber der Versand dauerte etwas länger als erwartet. Der Umtausch war allerdings sehr einfach und problemlos.",
    "date": "2019-11-12"
  },
  {
    "name": "Olga Petrova",
    "rating": 5,
    "review": "Ich bin absolut begeistert! Der Versand war super schnell und die Verpackung komplett plastikfrei. Die Qualität der Produkte hat mich überzeugt, und der Umtausch bei einer falschen Größe lief reibungslos. Werde auf jeden Fall wieder bestellen!",
    "date": "2024-02-07"
  },
  {
    "name": "Lucas Verhoeven",
    "rating": 5,
    "review": "Toller Shop, super schnelle Lieferung und die nachhaltige Verpackung finde ich klasse. Die Rücksendung war kostenlos und unkompliziert. Sehr empfehlenswert!",
    "date": "2021-09-22"
  },
  {
    "name": "Anna Kowalska",
    "rating": 4,
    "review": "Guter Service, schnelle Lieferung. Ein Artikel war nicht ganz wie erwartet, aber die Rücksendung war problemlos.",
    "date": "2018-04-11"
  },
  {
    "name": "Nils Rasmussen",
    "rating": 5,
    "review": "Die Qualität der Produkte ist großartig, und die Lieferung kam sehr schnell an. Die plastikfreie Verpackung ist ein riesiger Vorteil. Auch der Umtausch war schnell und kostenlos. Werde hier sicher wieder einkaufen.",
    "date": "2023-01-18"
  },
  {
    "name": "Carmen Delgado",
    "rating": 5,
    "review": "Sehr schnelle Lieferung und super Qualität. Die nachhaltige Verpackung hat mich überzeugt, und der Kundenservice war extrem hilfreich. Rücksendung war ebenfalls einfach und kostenfrei. Top!",
    "date": "2022-10-03"
  },
  {
    "name": "Tom Weber",
    "rating": 4,
    "review": "Gute Qualität, aber die Lieferung hätte schneller sein können. Rücksendung war einfach und kostenlos.",
    "date": "2017-06-15"
  },
  {
    "name": "Marie Dubois",
    "rating": 5,
    "review": "Die Bestellung kam super schnell, die Qualität ist hervorragend und die plastikfreie Verpackung gefällt mir sehr gut. Der Umtausch war unkompliziert und kostenlos. Hier werde ich definitiv wieder einkaufen.",
    "date": "2023-06-20"
  },
  {
    "name": "Henrik Sørensen",
    "rating": 5,
    "review": "Top Service! Schnelle Lieferung, tolle Produkte und umweltfreundliche Verpackung. Der Umtausch war einfach und kostenlos. Sehr zufrieden!",
    "date": "2021-03-14"
  },


{
"name": "Monika Becker",
"rating": 5,
"review": "Top!",
"date": "2015-02-14"
},
{
"name": "Olivier Dubois",
"rating": 4,
"review": "Gute Erfahrung gemacht. Die Bestellung traf innerhalb von 3 Tagen ein und die Qualität überzeugt. Der Kundenservice war sehr hilfsbereit bei einer Frage zur Größenauswahl. Ein Stern Abzug, weil ein Artikel minimal von der Farbdarstellung online abwich, aber insgesamt bin ich zufrieden.",
"date": "2016-05-29"
},
{
"name": "Elin Gustavsson",
"rating": 5,
"review": "P&C hat mich echt beeindruckt! Meine Bestellung war schon nach 2 Tagen da, und die Verpackung war komplett plastikfrei - super umweltbewusst! Die Qualität der Kleidung ist erstklassig, man merkt sofort den Unterschied zu Fast Fashion. Als ich eine Frage zur Pflege hatte, war der Kundenservice blitzschnell und sehr kompetent. Klare Empfehlung!",
"date": "2017-10-12"
},
{
"name": "Klaus Schulz",
"rating": 4,
"review": "Gute Produkte, zügig geliefert.",
"date": "2018-06-03"
},
{
"name": "Alessandra Ricci",
"rating": 5,
"review": "Ich bin total begeistert von P&C und möchte meine Erfahrungen teilen:<br><br><strong>Positiv:</strong><br>- Herausragende Qualität der Kleidung<br>- Nachhaltige Produktion und umweltfreundliche Verpackung<br>- Schnelle Lieferung (bei mir 4 Tage)<br>- Exzellenter Kundenservice<br>- Kostenlose Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Etwas höhere Preise als bei Massenherstellern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte versehentlich die falsche Größe bestellt. Der Umtauschprozess war unglaublich einfach und schnell. Der Kundenservice war dabei außerordentlich freundlich und lösungsorientiert.<br><br><strong>Wichtiger Hinweis:</strong> Bestellt unbedingt nur direkt bei P&C! Es gibt leider viele Fake-Shops mit den gleichen Bildern, aber minderwertiger Ware.<br><br><strong>Fazit:</strong> P&C steht für echte Qualität 'Made in Germany' mit Stil und gutem Gewissen. Wer Wert auf Nachhaltigkeit, Top-Service und langlebige Mode legt, ist hier genau richtig. Absolute Kaufempfehlung!",
"date": "2019-01-18"
},
{
"name": "Jesper Andersen",
"rating": 5,
"review": "Ausgezeichnet!",
"date": "2020-09-07"
},
{
"name": "Élise Moreau",
"rating": 4,
"review": "Ich bin sehr zufrieden mit meinem Einkauf bei P&C. Die Qualität der Kleidung ist wirklich hervorragend und die Designs sind sehr zeitgemäß. Meine Bestellung kam innerhalb von 5 Tagen an, was ich okay finde. Der Kundenservice war auch top - ich hatte eine Frage zur Kombination verschiedener Teile und bekam tolle Styling-Tipps. Ein Stern Abzug, weil ein Teil minimal anders ausfiel als erwartet, aber das ist bei Online-Bestellungen manchmal so. Die kostenlose Rücksendeoption macht das aber wieder wett. Insgesamt eine sehr positive Erfahrung!",
"date": "2021-04-22"
},
{
"name": "Karolina Nowak",
"rating": 5,
"review": "P&C hat mich rundum überzeugt! Hier meine detaillierte Bewertung:<br><br><strong>Vorteile:</strong><br>1. Erstklassige Qualität der Kleidung<br>2. Nachhaltige Produktion und umweltfreundliche Verpackung<br>3. Blitzschnelle Lieferung (bei mir waren es nur 2 Tage!)<br>4. Kundenservice der Extraklasse<br>5. Faire Preise für die gebotene Qualität<br>6. Kostenlose und unkomplizierte Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Die Preise sind etwas höher als bei Fast-Fashion-Anbietern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte ein Problem mit der Passform eines Artikels und war überwältigt, wie kulant und schnell der Kundenservice reagierte. Sie boten mir sogar einen zusätzlichen Rabatt für die kleine Unannehmlichkeit an!<br><br><strong>Wichtiger Hinweis:</strong> Bitte seid vorsichtig und bestellt nur direkt bei P&C! Es gibt viele Fake-Shops, besonders auf sozialen Medien, die die gleichen Bilder verwenden, aber minderwertige und teilweise sogar gesundheitsschädliche Produkte liefern.<br><br><strong>Fazit:</strong> P&C steht für echte 'Made in Germany'-Qualität, kombiniert mit Stil, Nachhaltigkeit und exzellentem Service. Wer Wert auf langlebige Mode legt und dabei noch etwas für die Umwelt tun möchte, ist hier goldrichtig. Ich kann P&C nur wärmstens empfehlen und werde definitiv wieder hier einkaufen!",
"date": "2022-11-09"
},
{
"name": "Joost van der Meer",
"rating": 5,
"review": "Hervorragende Qualität, prompt geliefert.",
"date": "2023-07-30"
},
{
"name": "Ingrid Eriksson",
"rating": 5,
"review": "Ich möchte meine durchweg positive Erfahrung mit P&C teilen:<br><br><strong>Positives:</strong><br>1. Außergewöhnlich hohe Qualität der Kleidung<br>2. Umweltbewusste Verpackung und nachhaltige Produktion<br>3. Beeindruckend schnelle Lieferung (3 Tage bei mir)<br>4. Kundenservice auf höchstem Niveau<br>5. Preis-Leistungs-Verhältnis stimmt absolut<br>6. Kostenlose Rücksendeoption - ein echter Pluspunkt<br><br><strong>Beachtenswert:</strong><br>- Die Preise liegen etwas über denen von Fast-Fashion-Ketten, aber die Qualität rechtfertigt das vollkommen<br><br><strong>Persönliches Erlebnis:</strong> Bei einer Bestellung hatte ich Zweifel an der Größenwahl. Der Kundenservice beriet mich ausführlich und geduldig. Als die Lieferung dann doch nicht 100% passte, war der Umtausch völlig unkompliziert.<br><br><strong>Wichtige Warnung:</strong> Bitte bestellt ausschließlich direkt bei P&C! Es existieren zahlreiche Fake-Shops, besonders auf Social-Media-Plattformen und sogar bei Google-Anzeigen, die P&Cs Bilder verwenden, aber minderwertige und potenziell gesundheitsschädliche Produkte liefern. Der geringe Preisunterschied lohnt sich definitiv für die echte P&C-Qualität.<br><br><strong>Abschließendes Urteil:</strong> P&C verkörpert für mich echte 'Made in Germany'-Qualität, gepaart mit zeitgemäßem Stil, Nachhaltigkeit und herausragendem Kundenservice. Für alle, die Wert auf langlebige, stilvolle Mode legen und dabei ein gutes Gewissen haben möchten, ist P&C die perfekte Wahl. Ich kann diesen Shop aus vollem Herzen empfehlen und werde mit Sicherheit wieder hier einkaufen!",
"date": "2024-03-12"
},

  {
    "name": "Lisa Müller",
    "rating": 5,
    "review": "Super schneller Versand und tolle Qualität. Bin sehr zufrieden!",
    "date": "2022-02-11"
  },
  {
    "name": "Pablo Martinez",
    "rating": 4,
    "review": "Die Ware war gut, aber die Lieferung hat etwas länger gedauert als erwartet. Rücksendung war zum Glück einfach und kostenlos.",
    "date": "2021-07-25"
  },
  {
    "name": "Natalie Fischer",
    "rating": 5,
    "review": "Absolut begeistert! Die Produkte sind von super Qualität, und der Versand war blitzschnell. Die nachhaltige Verpackung ohne Plastik finde ich großartig. Der Umtausch eines Artikels lief völlig problemlos und kostenlos. Klare Empfehlung!",
    "date": "2023-09-08"
  },
  {
    "name": "Johan Andersen",
    "rating": 5,
    "review": "Tolles Einkaufserlebnis! Die Produkte kamen sehr schnell an, die Qualität ist fantastisch, und die Verpackung war umweltfreundlich. Der Umtausch war einfach und kostenlos. Ich kaufe hier auf jeden Fall wieder ein!",
    "date": "2020-06-30"
  },
  {
    "name": "Ewa Lewandowski",
    "rating": 4,
    "review": "Gute Produkte, aber die Lieferzeit hätte kürzer sein können. Die kostenlose Rücksendung war ein großer Pluspunkt.",
    "date": "2019-10-14"
  },
  {
    "name": "Marco Moretti",
    "rating": 5,
    "review": "Ich bin super zufrieden! Die Ware kam schnell an, und die Qualität ist erstklassig. Besonders toll finde ich, dass die Verpackung komplett plastikfrei war. Die Rücksendung eines Artikels war unkompliziert. Super Service!",
    "date": "2024-04-19"
  },
  {
    "name": "Jana Hoffmann",
    "rating": 5,
    "review": "Sehr schnelle Lieferung und die Produkte waren gut verpackt. Die Qualität ist super, und der Umtausch war kostenlos und einfach. Werde auf jeden Fall wieder hier bestellen!",
    "date": "2021-12-02"
  },
  {
    "name": "Tomáš Novák",
    "rating": 4,
    "review": "Gute Produkte, aber die Lieferung dauerte etwas. Rücksendung war unkompliziert und kostenfrei.",
    "date": "2018-08-09"
  },
  {
    "name": "Alicia Dupont",
    "rating": 5,
    "review": "Die Bestellung war super schnell da, und die Qualität hat mich wirklich überzeugt. Die plastikfreie Verpackung und die einfache Rücksendung bei einer falschen Größe haben mir besonders gut gefallen. Sehr empfehlenswert!",
    "date": "2023-07-21"
  },
  {
    "name": "Henrik Jansen",
    "rating": 5,
    "review": "Perfekte Lieferung, tolle Qualität, und die umweltfreundliche Verpackung ist ein Highlight. Der Umtausch eines Artikels war super einfach und kostenlos. Werde definitiv wieder bestellen!",
    "date": "2020-11-18"
  },



  {
    "name": "Anna Schmidt",
    "rating": 5,
    "review": "Sehr schnelle Lieferung, die Produkte sind top. Werde definitiv wieder bestellen.",
    "date": "2021-05-22"
  },
  {
    "name": "Pedro González",
    "rating": 4,
    "review": "Die Lieferung war etwas langsamer als erwartet, aber die Qualität der Produkte ist gut. Der Rückgabeprozess war unkompliziert.",
    "date": "2022-03-15"
  },
  {
    "name": "Elisa Weber",
    "rating": 5,
    "review": "Ich bin wirklich begeistert! Die Bestellung kam schneller an als gedacht, und die Produkte sind von toller Qualität. Besonders gut gefallen hat mir die plastikfreie Verpackung. Der Umtausch war kostenlos und super einfach. Toller Shop!",
    "date": "2023-09-02"
  },
  {
    "name": "Marek Kowalski",
    "rating": 5,
    "review": "Alles lief reibungslos. Lieferung kam schnell, Qualität wie erwartet. Rücksendung war kinderleicht und kostenlos. Sehr zufrieden!",
    "date": "2020-07-10"
  },
  {
    "name": "Nina Van den Berg",
    "rating": 4,
    "review": "Die Produkte sind in Ordnung, die Lieferung dauerte etwas länger. Der kostenlose Umtausch war ein großer Vorteil.",
    "date": "2018-12-19"
  },
  {
    "name": "Victor Lefevre",
    "rating": 5,
    "review": "Fantastische Erfahrung! Die Produkte kamen schnell an und waren in perfektem Zustand. Die plastikfreie Verpackung und der einfache Umtausch haben mich wirklich überzeugt. Werde hier sicher wieder bestellen.",
    "date": "2022-10-05"
  },
  {
    "name": "Laura Fischer",
    "rating": 5,
    "review": "Top Service, schnelle Lieferung und die Produkte sind von sehr guter Qualität. Nachhaltige Verpackung und kostenloser Rückversand – besser geht’s nicht!",
    "date": "2024-01-16"
  },
  {
    "name": "Jakub Novak",
    "rating": 4,
    "review": "Gute Produkte, aber die Lieferzeit war länger als erwartet. Die Rücksendung lief problemlos.",
    "date": "2017-11-03"
  },
  {
    "name": "Clara Dupont",
    "rating": 5,
    "review": "Ich war sehr beeindruckt von der schnellen Lieferung und der tollen Qualität. Die Rücksendung war einfach und kostenlos. Besonders die umweltfreundliche Verpackung hat mich überzeugt. Gerne wieder!",
    "date": "2023-05-09"
  },
  {
    "name": "Erik Hansen",
    "rating": 5,
    "review": "Die Qualität der Produkte ist überragend, und die Lieferung war super schnell. Die Verpackung ist komplett ohne Plastik, was ich toll finde. Der Umtausch war einfach und kostenlos. Top Shop!",
    "date": "2021-02-14"
  },


{
"name": "Hannelore Fischer",
"rating": 5,
"review": "Prima!",
"date": "2015-04-29"
},
{
"name": "Mathieu Rousseau",
"rating": 4,
"review": "Gute Erfahrung gemacht. Die Artikel kamen innerhalb von 3 Tagen an und die Qualität ist wirklich überzeugend. Der Kundenservice war sehr freundlich bei einer Frage zur Stoffzusammensetzung. Ein Stern Abzug, weil ein Teil minimal von der Farbdarstellung online abwich, aber insgesamt bin ich zufrieden.",
"date": "2016-10-12"
},
{
"name": "Astrid Bergman",
"rating": 5,
"review": "P&C hat mich total überzeugt! Meine Bestellung war schon nach 2 Tagen da, und die Verpackung war komplett plastikfrei - echt vorbildlich! Die Qualität der Kleidung ist erstklassig, man spürt sofort den Unterschied zu billiger Massenware. Als ich eine Frage zur Pflege hatte, war der Kundenservice blitzschnell und super kompetent. Absolute Kaufempfehlung!",
"date": "2017-07-18"
},
{
"name": "Torsten Schulze",
"rating": 4,
"review": "Sehr gute Produkte, zügig geliefert.",
"date": "2018-01-05"
},
{
"name": "Giulia Ferrari",
"rating": 5,
"review": "Ich bin absolut begeistert von P&C und möchte meine Erfahrungen teilen:<br><br><strong>Positiv:</strong><br>- Herausragende Qualität der Kleidung<br>- Nachhaltige Produktion und umweltfreundliche Verpackung<br>- Schnelle Lieferung (bei mir 4 Tage)<br>- Exzellenter Kundenservice<br>- Kostenlose Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Etwas höhere Preise als bei Massenherstellern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte versehentlich die falsche Größe bestellt. Der Umtauschprozess war unglaublich einfach und schnell. Der Kundenservice war dabei außergewöhnlich freundlich und lösungsorientiert.<br><br><strong>Wichtiger Hinweis:</strong> Bestellt unbedingt nur direkt bei P&C! Es gibt leider viele Fake-Shops mit den gleichen Bildern, aber minderwertiger Ware.<br><br><strong>Fazit:</strong> P&C steht für echte Qualität 'Made in Germany' mit Stil und gutem Gewissen. Wer Wert auf Nachhaltigkeit, Top-Service und langlebige Mode legt, ist hier genau richtig. Absolute Kaufempfehlung!",
"date": "2019-11-23"
},
{
"name": "Rasmus Larsen",
"rating": 5,
"review": "Erstklassig!",
"date": "2020-05-09"
},
{
"name": "Margot Lefevre",
"rating": 4,
"review": "Ich bin sehr zufrieden mit meinem Einkauf bei P&C. Die Qualität der Kleidung ist wirklich hervorragend und die Designs sind sehr ansprechend. Meine Bestellung kam innerhalb von 5 Tagen an, was ich in Ordnung finde. Der Kundenservice war auch top - ich hatte eine Frage zur Kombination verschiedener Teile und bekam sehr hilfreiche Styling-Tipps. Ein Stern Abzug, weil ein Teil minimal anders ausfiel als erwartet, aber das ist bei Online-Bestellungen manchmal so. Die kostenlose Rücksendeoption macht das aber wieder wett. Insgesamt eine sehr positive Erfahrung!",
"date": "2021-12-14"
},
{
"name": "Wojciech Dąbrowski",
"rating": 5,
"review": "P&C hat mich rundum überzeugt! Hier meine detaillierte Bewertung:<br><br><strong>Vorteile:</strong><br>1. Erstklassige Qualität der Kleidung<br>2. Nachhaltige Produktion und umweltfreundliche Verpackung<br>3. Blitzschnelle Lieferung (bei mir waren es nur 2 Tage!)<br>4. Kundenservice der Extraklasse<br>5. Faire Preise für die gebotene Qualität<br>6. Kostenlose und unkomplizierte Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Die Preise sind etwas höher als bei Fast-Fashion-Anbietern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte ein Problem mit der Passform eines Artikels und war überwältigt, wie kulant und schnell der Kundenservice reagierte. Sie boten mir sogar einen zusätzlichen Rabatt für die kleine Unannehmlichkeit an!<br><br><strong>Wichtiger Hinweis:</strong> Bitte seid vorsichtig und bestellt nur direkt bei P&C! Es gibt viele Fake-Shops, besonders auf sozialen Medien, die die gleichen Bilder verwenden, aber minderwertige und teilweise sogar gesundheitsschädliche Produkte liefern.<br><br><strong>Fazit:</strong> P&C steht für echte 'Made in Germany'-Qualität, kombiniert mit Stil, Nachhaltigkeit und exzellentem Service. Wer Wert auf langlebige Mode legt und dabei noch etwas für die Umwelt tun möchte, ist hier goldrichtig. Ich kann P&C nur wärmstens empfehlen und werde definitiv wieder hier einkaufen!",
"date": "2022-08-30"
},
{
"name": "Sofie van der Linden",
"rating": 5,
"review": "Hervorragende Qualität, prompt geliefert.",
"date": "2023-03-17"
},
{
"name": "Gustav Lundqvist",
"rating": 5,
"review": "Ich möchte meine durchweg positive Erfahrung mit P&C teilen:<br><br><strong>Positives:</strong><br>1. Außergewöhnlich hohe Qualität der Kleidung<br>2. Umweltbewusste Verpackung und nachhaltige Produktion<br>3. Beeindruckend schnelle Lieferung (3 Tage bei mir)<br>4. Kundenservice auf höchstem Niveau<br>5. Preis-Leistungs-Verhältnis stimmt absolut<br>6. Kostenlose Rücksendeoption - ein echter Pluspunkt<br><br><strong>Beachtenswert:</strong><br>- Die Preise liegen etwas über denen von Fast-Fashion-Ketten, aber die Qualität rechtfertigt das vollkommen<br><br><strong>Persönliches Erlebnis:</strong> Bei einer Bestellung hatte ich Zweifel an der Größenwahl. Der Kundenservice beriet mich ausführlich und geduldig. Als die Lieferung dann doch nicht 100% passte, war der Umtausch völlig unkompliziert.<br><br><strong>Wichtige Warnung:</strong> Bitte bestellt ausschließlich direkt bei P&C! Es existieren zahlreiche Fake-Shops, besonders auf Social-Media-Plattformen und sogar bei Google-Anzeigen, die P&Cs Bilder verwenden, aber minderwertige und potenziell gesundheitsschädliche Produkte liefern. Der geringe Preisunterschied lohnt sich definitiv für die echte P&C-Qualität.<br><br><strong>Abschließendes Urteil:</strong> P&C verkörpert für mich echte 'Made in Germany'-Qualität, gepaart mit zeitgemäßem Stil, Nachhaltigkeit und herausragendem Kundenservice. Für alle, die Wert auf langlebige, stilvolle Mode legen und dabei ein gutes Gewissen haben möchten, ist P&C die perfekte Wahl. Ich kann diesen Shop aus vollem Herzen empfehlen und werde mit Sicherheit wieder hier einkaufen!",
"date": "2024-01-08"
},


  {
    "name": "Maria Braun",
    "rating": 5,
    "review": "Schnelle Lieferung und super Qualität. Sehr zufrieden!",
    "date": "2022-08-12"
  },
  {
    "name": "Luca Bianchi",
    "rating": 4,
    "review": "Die Ware war gut, aber die Lieferung hat ein wenig gedauert. Rücksendung war einfach.",
    "date": "2020-04-25"
  },
  {
    "name": "Sophie Dubois",
    "rating": 5,
    "review": "Sehr beeindruckt! Die Bestellung kam schnell und die Qualität ist top. Besonders gefällt mir die nachhaltige Verpackung. Der Umtausch war einfach und kostenlos. Gerne wieder!",
    "date": "2023-11-05"
  },
  {
    "name": "Oskar Johansson",
    "rating": 5,
    "review": "Perfekter Service, schnelle Lieferung und die Qualität ist hervorragend. Auch die umweltfreundliche Verpackung ist ein großes Plus. Ein Umtausch lief reibungslos. Absolut empfehlenswert!",
    "date": "2021-06-28"
  },
  {
    "name": "Hanna Nowak",
    "rating": 4,
    "review": "Die Produkte sind in Ordnung, die Lieferung dauerte aber etwas länger als erwartet. Der Umtausch war unkompliziert.",
    "date": "2019-10-15"
  },
  {
    "name": "Matthias Van Dijk",
    "rating": 5,
    "review": "Ich bin begeistert! Die Qualität der Produkte ist wirklich gut, und die plastikfreie Verpackung ist ein echtes Highlight. Die Rücksendung eines Teils war problemlos. Werde definitiv wieder bestellen.",
    "date": "2023-06-12"
  },
  {
    "name": "Greta Müller",
    "rating": 5,
    "review": "Super schnelle Lieferung, hochwertige Produkte und eine nachhaltige Verpackung. Der kostenlose Rückversand bei falschen Größen hat mich überzeugt. Werde hier wieder bestellen!",
    "date": "2024-01-30"
  },
  {
    "name": "Timo Garcia",
    "rating": 4,
    "review": "Alles gut, Lieferung war in Ordnung, aber hätte schneller sein können. Produkte sind wie beschrieben.",
    "date": "2017-09-23"
  },
  {
    "name": "Eva Hansen",
    "rating": 5,
    "review": "Ich war sehr zufrieden mit der schnellen Lieferung und der hervorragenden Qualität. Der Umtausch war einfach und kostenlos, und die nachhaltige Verpackung war ein toller Bonus. Sehr empfehlenswert!",
    "date": "2023-04-17"
  },
  {
    "name": "Jakob Fischer",
    "rating": 5,
    "review": "Alles lief reibungslos. Die Lieferung kam schnell, die Qualität ist super und die plastikfreie Verpackung ist ein großes Plus. Rücksendung war kostenlos. Gerne wieder!",
    "date": "2020-12-11"
  },

{
"name": "Gisela Wagner",
"rating": 5,
"review": "Spitze!",
"date": "2015-09-14"
},
{
"name": "Pierre Moreau",
"rating": 4,
"review": "Sehr zufrieden mit meinem Einkauf. Die Lieferung erfolgte innerhalb von 4 Tagen und die Qualität ist beeindruckend. Der Kundenservice war äußerst hilfsbereit bei einer Frage zur Größenauswahl. Ein Stern Abzug, weil ein Artikel minimal von der Beschreibung abwich, aber insgesamt eine positive Erfahrung.",
"date": "2016-02-28"
},
{
"name": "Lena Söderström",
"rating": 5,
"review": "P&C hat mich wirklich überrascht! Die Bestellung war schon nach 2 Tagen da, und alles war umweltfreundlich verpackt - kein Plastik in Sicht! Die Qualität der Kleidung ist erstklassig, deutlich besser als Fast Fashion. Der Kundenservice war bei einer Stilfrage superschnell und kompetent. Klare Kaufempfehlung!",
"date": "2017-11-05"
},
{
"name": "Dieter Hoffmann",
"rating": 4,
"review": "Gute Produkte, zügig geliefert.",
"date": "2018-05-19"
},
{
"name": "Chiara Romano",
"rating": 5,
"review": "Ich bin total begeistert von P&C und teile gerne meine Erfahrungen:<br><br><strong>Positiv:</strong><br>- Außergewöhnliche Qualität der Kleidung<br>- Nachhaltige Produktion und umweltschonende Verpackung<br>- Rasche Lieferung (bei mir 3 Tage)<br>- Herausragender Kundenservice<br>- Kostenlose Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Etwas höhere Preise als bei Discountern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte versehentlich die falsche Größe bestellt. Der Umtauschprozess war unglaublich einfach und schnell. Der Kundenservice war dabei außerordentlich zuvorkommend und lösungsorientiert.<br><br><strong>Wichtiger Hinweis:</strong> Bestellt unbedingt nur direkt bei P&C! Es gibt leider viele Fake-Shops mit den gleichen Bildern, aber minderwertiger Ware.<br><br><strong>Fazit:</strong> P&C steht für echte Qualität 'Made in Germany' mit Stil und gutem Gewissen. Wer Wert auf Nachhaltigkeit, Top-Service und langlebige Mode legt, ist hier genau richtig. Absolute Kaufempfehlung!",
"date": "2019-08-02"
},
{
"name": "Anders Petersen",
"rating": 5,
"review": "Fantastisch!",
"date": "2020-12-11"
},
{
"name": "Amélie Laurent",
"rating": 4,
"review": "Ich bin sehr angetan von meinem Einkauf bei P&C. Die Qualität der Kleidung ist wirklich hervorragend und die Designs sind sehr zeitgemäß. Meine Bestellung kam innerhalb von 5 Tagen an, was ich okay finde. Der Kundenservice war auch top - ich hatte eine Frage zur Pflege und bekam sehr hilfreiche Tipps. Ein Stern Abzug, weil ein Teil minimal anders ausfiel als erwartet, aber das ist bei Online-Bestellungen manchmal so. Die kostenlose Rücksendeoption macht das aber wieder wett. Insgesamt eine sehr positive Erfahrung!",
"date": "2021-06-30"
},
{
"name": "Marek Nowicki",
"rating": 5,
"review": "P&C hat mich vollkommen überzeugt! Hier meine ausführliche Bewertung:<br><br><strong>Vorteile:</strong><br>1. Erstklassige Qualität der Kleidung<br>2. Nachhaltige Produktion und umweltfreundliche Verpackung<br>3. Sehr schnelle Lieferung (bei mir waren es nur 2 Tage!)<br>4. Kundenservice der Spitzenklasse<br>5. Faire Preise für die gebotene Qualität<br>6. Kostenlose und unkomplizierte Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Die Preise sind etwas höher als bei Fast-Fashion-Anbietern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte ein Problem mit der Passform eines Artikels und war überwältigt, wie kulant und schnell der Kundenservice reagierte. Sie boten mir sogar einen zusätzlichen Rabatt für die kleine Unannehmlichkeit an!<br><br><strong>Wichtiger Hinweis:</strong> Bitte seid vorsichtig und bestellt nur direkt bei P&C! Es gibt viele Fake-Shops, besonders auf sozialen Medien, die die gleichen Bilder verwenden, aber minderwertige und teilweise sogar gesundheitsschädliche Produkte liefern.<br><br><strong>Fazit:</strong> P&C steht für echte 'Made in Germany'-Qualität, kombiniert mit Stil, Nachhaltigkeit und exzellentem Service. Wer Wert auf langlebige Mode legt und dabei noch etwas für die Umwelt tun möchte, ist hier goldrichtig. Ich kann P&C nur wärmstens empfehlen und werde definitiv wieder hier einkaufen!",
"date": "2022-03-17"
},
{
"name": "Lotte van den Berg",
"rating": 5,
"review": "Exzellente Qualität, blitzschnell geliefert.",
"date": "2023-09-22"
},
{
"name": "Erik Johansson",
"rating": 5,
"review": "Ich möchte meine durchweg positive Erfahrung mit P&C teilen:<br><br><strong>Positives:</strong><br>1. Außergewöhnlich hohe Qualität der Kleidung<br>2. Umweltbewusste Verpackung und nachhaltige Produktion<br>3. Beeindruckend schnelle Lieferung (3 Tage bei mir)<br>4. Kundenservice auf höchstem Niveau<br>5. Preis-Leistungs-Verhältnis stimmt absolut<br>6. Kostenlose Rücksendeoption - ein echter Pluspunkt<br><br><strong>Beachtenswert:</strong><br>- Die Preise liegen etwas über denen von Fast-Fashion-Ketten, aber die Qualität rechtfertigt das vollkommen<br><br><strong>Persönliches Erlebnis:</strong> Bei einer Bestellung hatte ich Zweifel an der Größenwahl. Der Kundenservice beriet mich ausführlich und geduldig. Als die Lieferung dann doch nicht 100% passte, war der Umtausch völlig unkompliziert.<br><br><strong>Wichtige Warnung:</strong> Bitte bestellt ausschließlich direkt bei P&C! Es existieren zahlreiche Fake-Shops, besonders auf Social-Media-Plattformen und sogar bei Google-Anzeigen, die P&Cs Bilder verwenden, aber minderwertige und potenziell gesundheitsschädliche Produkte liefern. Der geringe Preisunterschied lohnt sich definitiv für die echte P&C-Qualität.<br><br><strong>Abschließendes Urteil:</strong> P&C verkörpert für mich echte 'Made in Germany'-Qualität, gepaart mit zeitgemäßem Stil, Nachhaltigkeit und herausragendem Kundenservice. Für alle, die Wert auf langlebige, stilvolle Mode legen und dabei ein gutes Gewissen haben möchten, ist P&C die perfekte Wahl. Ich kann diesen Shop aus vollem Herzen empfehlen und werde mit Sicherheit wieder hier einkaufen!",
"date": "2024-07-05"
},



  {
    "name": "Lisa Berger",
    "rating": 5,
    "review": "Super schnelle Lieferung, tolle Produkte. Alles bestens!",
    "date": "2022-03-14"
  },
  {
    "name": "David Fernández",
    "rating": 4,
    "review": "Die Ware ist gut, aber die Lieferung hat länger gedauert als erwartet. Rücksendung war zum Glück unkompliziert.",
    "date": "2020-07-08"
  },
  {
    "name": "Marta Kowalski",
    "rating": 5,
    "review": "Ich bin begeistert! Die Bestellung kam schnell an, und die Qualität der Produkte ist großartig. Besonders gut gefällt mir die nachhaltige Verpackung. Der Umtausch war einfach und kostenlos. Werde definitiv wieder bestellen!",
    "date": "2023-09-15"
  },
  {
    "name": "Leon Verhoeven",
    "rating": 5,
    "review": "Alles perfekt! Super schnelle Lieferung, die Qualität der Produkte ist wirklich überzeugend. Die plastikfreie Verpackung finde ich klasse. Der kostenlose Umtausch hat reibungslos funktioniert. Gerne wieder!",
    "date": "2021-05-26"
  },
  {
    "name": "Sofia Dubois",
    "rating": 4,
    "review": "Produkte sind in Ordnung, Lieferung war etwas langsamer als erwartet. Umtausch war aber problemlos.",
    "date": "2019-08-18"
  },
  {
    "name": "Lukas Müller",
    "rating": 5,
    "review": "Sehr zufrieden! Lieferung war schnell, Qualität der Produkte ist toll, und die nachhaltige Verpackung ohne Plastik hat mich begeistert. Der Umtausch war einfach und kostenlos. Werde sicher wieder bestellen.",
    "date": "2023-01-22"
  },
  {
    "name": "Elena Rossi",
    "rating": 5,
    "review": "Fantastische Qualität und blitzschneller Versand. Die nachhaltige Verpackung und der tolle Kundenservice haben mich überzeugt. Rücksendungen sind kostenlos und einfach. Perfekt!",
    "date": "2022-11-14"
  },
  {
    "name": "Hans Jørgensen",
    "rating": 4,
    "review": "Die Lieferung war okay, hätte aber schneller sein können. Die Produkte sind gut, und der Umtausch war problemlos.",
    "date": "2017-10-02"
  },
  {
    "name": "Clara Petrova",
    "rating": 5,
    "review": "Tolle Produkte, schneller Versand und die umweltfreundliche Verpackung ohne Plastik ist ein großes Plus. Der Kundenservice war sehr hilfreich, und die Rücksendung war kinderleicht. Absolut empfehlenswert!",
    "date": "2023-06-05"
  },
  {
    "name": "Maximilian Bauer",
    "rating": 5,
    "review": "Ich bin absolut begeistert! Die Qualität der Produkte ist erstklassig, die Lieferung kam sehr schnell und die plastikfreie Verpackung hat mich überzeugt. Der Umtausch war kostenlos und einfach. Klare Empfehlung!",
    "date": "2020-12-27"
  },


{
"name": "Helga Becker",
"rating": 5,
"review": "Toll!",
"date": "2015-05-23"
},
{
"name": "Jean-Luc Dupont",
"rating": 4,
"review": "Gute Erfahrung gemacht. Die Artikel kamen innerhalb von 3 Tagen an und die Qualität ist wirklich überzeugend. Der Kundenservice war sehr hilfsbereit bei einer Frage zum Material. Ein Stern Abzug, weil ein Teil minimal von der Farbdarstellung online abwich, aber insgesamt bin ich zufrieden.",
"date": "2016-11-09"
},
{
"name": "Ingrid Svensson",
"rating": 5,
"review": "P&C hat mich echt beeindruckt! Meine Bestellung war schon nach einem Tag da, und die Verpackung war komplett plastikfrei - super umweltfreundlich! Die Qualität der Kleidung ist erstklassig, man merkt sofort den Unterschied zu billiger Massenware. Als ich eine Frage zur Kombination hatte, war der Kundenservice superschnell und kompetent. Klare Empfehlung!",
"date": "2017-08-14"
},
{
"name": "Manfred Klein",
"rating": 4,
"review": "Gute Ware, prompt geliefert.",
"date": "2018-02-28"
},
{
"name": "Sofia Conti",
"rating": 5,
"review": "Ich bin absolut begeistert von P&C und möchte meine Erfahrungen teilen:<br><br><strong>Positiv:</strong><br>- Herausragende Qualität der Kleidung<br>- Nachhaltige Produktion und umweltfreundliche Verpackung<br>- Schnelle Lieferung (bei mir 4 Tage)<br>- Exzellenter Kundenservice<br>- Kostenlose Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Etwas höhere Preise als bei Massenherstellern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte versehentlich die falsche Größe bestellt. Der Umtauschprozess war unglaublich einfach und schnell. Der Kundenservice war dabei außergewöhnlich freundlich und lösungsorientiert.<br><br><strong>Wichtiger Hinweis:</strong> Bestellt unbedingt nur direkt bei P&C! Es gibt leider viele Fake-Shops mit den gleichen Bildern, aber minderwertiger Ware.<br><br><strong>Fazit:</strong> P&C steht für echte Qualität 'Made in Germany' mit Stil und gutem Gewissen. Wer Wert auf Nachhaltigkeit, Top-Service und langlebige Mode legt, ist hier genau richtig. Absolute Kaufempfehlung!",
"date": "2019-10-07"
},
{
"name": "Lars Andersen",
"rating": 5,
"review": "Erstklassig!",
"date": "2020-07-19"
},
{
"name": "Céline Martin",
"rating": 4,
"review": "Ich bin sehr zufrieden mit meinem Einkauf bei P&C. Die Qualität der Kleidung ist wirklich hervorragend und die Designs sind sehr ansprechend. Meine Bestellung kam innerhalb von 5 Tagen an, was ich in Ordnung finde. Der Kundenservice war auch top - ich hatte eine Frage zur Kombination verschiedener Teile und bekam sehr hilfreiche Styling-Tipps. Ein Stern Abzug, weil ein Teil minimal anders ausfiel als erwartet, aber das ist bei Online-Bestellungen manchmal so. Die kostenlose Rücksendeoption macht das aber wieder wett. Insgesamt eine sehr positive Erfahrung!",
"date": "2021-03-02"
},
{
"name": "Tomasz Kowalczyk",
"rating": 5,
"review": "P&C hat mich rundum überzeugt! Hier meine detaillierte Bewertung:<br><br><strong>Vorteile:</strong><br>1. Erstklassige Qualität der Kleidung<br>2. Nachhaltige Produktion und umweltfreundliche Verpackung<br>3. Blitzschnelle Lieferung (bei mir waren es nur 2 Tage!)<br>4. Kundenservice der Extraklasse<br>5. Faire Preise für die gebotene Qualität<br>6. Kostenlose und unkomplizierte Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Die Preise sind etwas höher als bei Fast-Fashion-Anbietern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte ein Problem mit der Passform eines Artikels und war überwältigt, wie kulant und schnell der Kundenservice reagierte. Sie boten mir sogar einen zusätzlichen Rabatt für die kleine Unannehmlichkeit an!<br><br><strong>Wichtiger Hinweis:</strong> Bitte seid vorsichtig und bestellt nur direkt bei P&C! Es gibt viele Fake-Shops, besonders auf sozialen Medien, die die gleichen Bilder verwenden, aber minderwertige und teilweise sogar gesundheitsschädliche Produkte liefern.<br><br><strong>Fazit:</strong> P&C steht für echte 'Made in Germany'-Qualität, kombiniert mit Stil, Nachhaltigkeit und exzellentem Service. Wer Wert auf langlebige Mode legt und dabei noch etwas für die Umwelt tun möchte, ist hier goldrichtig. Ich kann P&C nur wärmstens empfehlen und werde definitiv wieder hier einkaufen!",
"date": "2022-09-11"
},
{
"name": "Anouk de Jong",
"rating": 5,
"review": "Hervorragende Qualität, schnell geliefert.",
"date": "2023-04-26"
},
{
"name": "Sven Lindgren",
"rating": 5,
"review": "Ich möchte meine durchweg positive Erfahrung mit P&C teilen:<br><br><strong>Positives:</strong><br>1. Außergewöhnlich hohe Qualität der Kleidung<br>2. Umweltbewusste Verpackung und nachhaltige Produktion<br>3. Beeindruckend schnelle Lieferung (3 Tage bei mir)<br>4. Kundenservice auf höchstem Niveau<br>5. Preis-Leistungs-Verhältnis stimmt absolut<br>6. Kostenlose Rücksendeoption - ein echter Pluspunkt<br><br><strong>Beachtenswert:</strong><br>- Die Preise liegen etwas über denen von Fast-Fashion-Ketten, aber die Qualität rechtfertigt das vollkommen<br><br><strong>Persönliches Erlebnis:</strong> Bei einer Bestellung hatte ich Zweifel an der Größenwahl. Der Kundenservice beriet mich ausführlich und geduldig. Als die Lieferung dann doch nicht 100% passte, war der Umtausch völlig unkompliziert.<br><br><strong>Wichtige Warnung:</strong> Bitte bestellt ausschließlich direkt bei P&C! Es existieren zahlreiche Fake-Shops, besonders auf Social-Media-Plattformen und sogar bei Google-Anzeigen, die P&Cs Bilder verwenden, aber minderwertige und potenziell gesundheitsschädliche Produkte liefern. Der geringe Preisunterschied lohnt sich definitiv für die echte P&C-Qualität.<br><br><strong>Abschließendes Urteil:</strong> P&C verkörpert für mich echte 'Made in Germany'-Qualität, gepaart mit zeitgemäßem Stil, Nachhaltigkeit und herausragendem Kundenservice. Für alle, die Wert auf langlebige, stilvolle Mode legen und dabei ein gutes Gewissen haben möchten, ist P&C die perfekte Wahl. Ich kann diesen Shop aus vollem Herzen empfehlen und werde mit Sicherheit wieder hier einkaufen!",
"date": "2024-01-13"
},


  {
    "name": "Hannah Lehmann",
    "rating": 5,
    "review": "Schneller Versand, tolle Qualität und umweltfreundliche Verpackung. Sehr zufrieden!",
    "date": "2022-08-19"
  },
  {
    "name": "Carlos Almeida",
    "rating": 4,
    "review": "Die Lieferung war etwas langsam, aber die Produkte sind gut. Rücksendung war unkompliziert und kostenlos.",
    "date": "2020-06-14"
  },
  {
    "name": "Elena Garcia",
    "rating": 5,
    "review": "Sehr zufrieden! Die Bestellung kam schnell an und die Qualität ist super. Die plastikfreie Verpackung hat mir besonders gefallen. Umtausch war ebenfalls sehr einfach. Gerne wieder!",
    "date": "2023-09-29"
  },
  {
    "name": "Johannes Schmidt",
    "rating": 5,
    "review": "Alles lief reibungslos! Die Produkte kamen schnell und die Qualität ist hervorragend. Die nachhaltige Verpackung ist ein echter Pluspunkt. Die Rücksendung war kostenlos und einfach. Top Shop!",
    "date": "2021-11-21"
  },
  {
    "name": "Isabel Novak",
    "rating": 4,
    "review": "Produkte sind in Ordnung, aber die Lieferung hätte schneller sein können. Rücksendung war einfach.",
    "date": "2018-09-16"
  },
  {
    "name": "Nico Dupont",
    "rating": 5,
    "review": "Ich bin sehr zufrieden! Die Ware kam schnell an und war gut verpackt. Die Qualität ist super, und der Umtausch lief problemlos. Sehr empfehlenswert!",
    "date": "2023-07-13"
  },
  {
    "name": "Maja Van den Berg",
    "rating": 5,
    "review": "Toller Shop, schnelle Lieferung und die Qualität ist einfach fantastisch. Die umweltfreundliche Verpackung ist ein echter Bonus. Der Umtausch bei einem Artikel war unkompliziert und schnell. Werde auf jeden Fall wieder bestellen!",
    "date": "2024-02-12"
  },
  {
    "name": "Tommy Nilsson",
    "rating": 4,
    "review": "Gute Produkte, aber die Lieferung war etwas langsam. Rücksendung lief problemlos.",
    "date": "2019-10-03"
  },
  {
    "name": "Alicia Nowak",
    "rating": 5,
    "review": "Fantastische Erfahrung! Die Lieferung war schnell, die Verpackung nachhaltig und die Qualität der Produkte top. Der Kundenservice war ebenfalls sehr hilfsbereit. Gerne wieder!",
    "date": "2023-05-22"
  },
  {
    "name": "Matthias Meier",
    "rating": 5,
    "review": "Die Lieferung kam super schnell und die Qualität der Produkte ist wirklich überzeugend. Die plastikfreie Verpackung ist ein großes Plus. Die Rücksendung war kostenlos und sehr einfach. Werde auf jeden Fall wieder hier bestellen!",
    "date": "2020-04-28"
  },



{
"name": "Ursula Meyer",
"rating": 5,
"review": "Klasse!",
"date": "2015-12-07"
},
{
"name": "François Leclerc",
"rating": 4,
"review": "Sehr zufrieden mit meinem Einkauf. Die Lieferung erfolgte innerhalb von 4 Tagen und die Qualität ist beeindruckend. Der Kundenservice war äußerst hilfsbereit bei einer Frage zur Größenauswahl. Ein Stern Abzug, weil ein Artikel minimal von der Beschreibung abwich, aber insgesamt eine positive Erfahrung.",
"date": "2016-06-22"
},
{
"name": "Maja Lindholm",
"rating": 5,
"review": "P&C hat mich wirklich überrascht! Die Bestellung war schon nach 2 Tagen da, und alles war umweltfreundlich verpackt - kein Plastik in Sicht! Die Qualität der Kleidung ist erstklassig, deutlich besser als Fast Fashion. Der Kundenservice war bei einer Stilfrage superschnell und kompetent. Klare Kaufempfehlung!",
"date": "2017-02-14"
},
{
"name": "Klaus Weber",
"rating": 4,
"review": "Gute Produkte, zügig geliefert.",
"date": "2018-09-30"
},
{
"name": "Alessandra Rossi",
"rating": 5,
"review": "Ich bin total begeistert von P&C und teile gerne meine Erfahrungen:<br><br><strong>Positiv:</strong><br>- Außergewöhnliche Qualität der Kleidung<br>- Nachhaltige Produktion und umweltschonende Verpackung<br>- Rasche Lieferung (bei mir 3 Tage)<br>- Herausragender Kundenservice<br>- Kostenlose Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Etwas höhere Preise als bei Discountern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte versehentlich die falsche Größe bestellt. Der Umtauschprozess war unglaublich einfach und schnell. Der Kundenservice war dabei außerordentlich zuvorkommend und lösungsorientiert.<br><br><strong>Wichtiger Hinweis:</strong> Bestellt unbedingt nur direkt bei P&C! Es gibt leider viele Fake-Shops mit den gleichen Bildern, aber minderwertiger Ware.<br><br><strong>Fazit:</strong> P&C steht für echte Qualität 'Made in Germany' mit Stil und gutem Gewissen. Wer Wert auf Nachhaltigkeit, Top-Service und langlebige Mode legt, ist hier genau richtig. Absolute Kaufempfehlung!",
"date": "2019-04-18"
},
{
"name": "Jens Nielsen",
"rating": 5,
"review": "Fantastisch!",
"date": "2020-11-03"
},
{
"name": "Sophie Dubois",
"rating": 4,
"review": "Ich bin sehr angetan von meinem Einkauf bei P&C. Die Qualität der Kleidung ist wirklich hervorragend und die Designs sind sehr zeitgemäß. Meine Bestellung kam innerhalb von 5 Tagen an, was ich okay finde. Der Kundenservice war auch top - ich hatte eine Frage zur Pflege und bekam sehr hilfreiche Tipps. Ein Stern Abzug, weil ein Teil minimal anders ausfiel als erwartet, aber das ist bei Online-Bestellungen manchmal so. Die kostenlose Rücksendeoption macht das aber wieder wett. Insgesamt eine sehr positive Erfahrung!",
"date": "2021-08-27"
},
{
"name": "Piotr Wiśniewski",
"rating": 5,
"review": "P&C hat mich vollkommen überzeugt! Hier meine ausführliche Bewertung:<br><br><strong>Vorteile:</strong><br>1. Erstklassige Qualität der Kleidung<br>2. Nachhaltige Produktion und umweltfreundliche Verpackung<br>3. Sehr schnelle Lieferung (bei mir waren es nur 2 Tage!)<br>4. Kundenservice der Spitzenklasse<br>5. Faire Preise für die gebotene Qualität<br>6. Kostenlose und unkomplizierte Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Die Preise sind etwas höher als bei Fast-Fashion-Anbietern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte ein Problem mit der Passform eines Artikels und war überwältigt, wie kulant und schnell der Kundenservice reagierte. Sie boten mir sogar einen zusätzlichen Rabatt für die kleine Unannehmlichkeit an!<br><br><strong>Wichtiger Hinweis:</strong> Bitte seid vorsichtig und bestellt nur direkt bei P&C! Es gibt viele Fake-Shops, besonders auf sozialen Medien, die die gleichen Bilder verwenden, aber minderwertige und teilweise sogar gesundheitsschädliche Produkte liefern.<br><br><strong>Fazit:</strong> P&C steht für echte 'Made in Germany'-Qualität, kombiniert mit Stil, Nachhaltigkeit und exzellentem Service. Wer Wert auf langlebige Mode legt und dabei noch etwas für die Umwelt tun möchte, ist hier goldrichtig. Ich kann P&C nur wärmstens empfehlen und werde definitiv wieder hier einkaufen!",
"date": "2022-05-11"
},
{
"name": "Femke van der Meer",
"rating": 5,
"review": "Exzellente Qualität, blitzschnell geliefert.",
"date": "2023-01-20"
},
{
"name": "Mikael Bergström",
"rating": 5,
"review": "Ich möchte meine durchweg positive Erfahrung mit P&C teilen:<br><br><strong>Positives:</strong><br>1. Außergewöhnlich hohe Qualität der Kleidung<br>2. Umweltbewusste Verpackung und nachhaltige Produktion<br>3. Beeindruckend schnelle Lieferung (3 Tage bei mir)<br>4. Kundenservice auf höchstem Niveau<br>5. Preis-Leistungs-Verhältnis stimmt absolut<br>6. Kostenlose Rücksendeoption - ein echter Pluspunkt<br><br><strong>Beachtenswert:</strong><br>- Die Preise liegen etwas über denen von Fast-Fashion-Ketten, aber die Qualität rechtfertigt das vollkommen<br><br><strong>Persönliches Erlebnis:</strong> Bei einer Bestellung hatte ich Zweifel an der Größenwahl. Der Kundenservice beriet mich ausführlich und geduldig. Als die Lieferung dann doch nicht 100% passte, war der Umtausch völlig unkompliziert.<br><br><strong>Wichtige Warnung:</strong> Bitte bestellt ausschließlich direkt bei P&C! Es existieren zahlreiche Fake-Shops, besonders auf Social-Media-Plattformen und sogar bei Google-Anzeigen, die P&Cs Bilder verwenden, aber minderwertige und potenziell gesundheitsschädliche Produkte liefern. Der geringe Preisunterschied lohnt sich definitiv für die echte P&C-Qualität.<br><br><strong>Abschließendes Urteil:</strong> P&C verkörpert für mich echte 'Made in Germany'-Qualität, gepaart mit zeitgemäßem Stil, Nachhaltigkeit und herausragendem Kundenservice. Für alle, die Wert auf langlebige, stilvolle Mode legen und dabei ein gutes Gewissen haben möchten, ist P&C die perfekte Wahl. Ich kann diesen Shop aus vollem Herzen empfehlen und werde mit Sicherheit wieder hier einkaufen!",
"date": "2024-09-08"
},


  {
    "name": "Sofia Kraus",
    "rating": 5,
    "review": "Schnelle Lieferung und die Produkte sind top! Sehr empfehlenswert.",
    "date": "2022-04-21"
  },
  {
    "name": "Luca Moretti",
    "rating": 4,
    "review": "Die Qualität ist gut, aber die Lieferung war etwas langsam. Rücksendung lief problemlos.",
    "date": "2021-08-05"
  },
  {
    "name": "Clara Dubois",
    "rating": 5,
    "review": "Ich bin begeistert! Die Ware kam schnell und in einer umweltfreundlichen Verpackung. Der Kundenservice war sehr freundlich und der Umtausch lief reibungslos. Gerne wieder!",
    "date": "2023-09-18"
  },
  {
    "name": "Jan Novak",
    "rating": 5,
    "review": "Tolle Qualität, schnelle Lieferung und die plastikfreie Verpackung finde ich großartig. Umtausch war kostenlos und einfach. Sehr zufrieden!",
    "date": "2020-03-12"
  },
  {
    "name": "Elena Müller",
    "rating": 4,
    "review": "Die Produkte sind super, aber die Lieferzeit war etwas länger als erwartet. Rücksendung war unkompliziert.",
    "date": "2019-06-30"
  },
  {
    "name": "Victor Fernandez",
    "rating": 5,
    "review": "Fantastische Erfahrung! Die Qualität der Produkte ist hervorragend, und die Lieferung war sehr schnell. Besonders gut fand ich die umweltfreundliche Verpackung und den einfachen Umtausch. Klare Empfehlung!",
    "date": "2024-01-17"
  },
  {
    "name": "Greta Schneider",
    "rating": 5,
    "review": "Super schneller Versand und tolle Produkte. Besonders die plastikfreie Verpackung hat mir gefallen. Rücksendung war einfach. Gerne wieder!",
    "date": "2023-07-02"
  },
  {
    "name": "Marek Kowalczyk",
    "rating": 4,
    "review": "Die Lieferung hätte etwas schneller sein können, aber die Qualität der Ware ist super. Umtausch lief problemlos.",
    "date": "2018-11-09"
  },
  {
    "name": "Emma Dupont",
    "rating": 5,
    "review": "Die Produkte kamen schnell an und waren in einer nachhaltigen Verpackung. Qualität ist top und der Kundenservice war sehr hilfreich. Rücksendung war kinderleicht.",
    "date": "2023-05-10"
  },
  {
    "name": "Henrik Sørensen",
    "rating": 5,
    "review": "Die Qualität der Produkte ist spitze, und die Lieferung kam schneller als erwartet. Die umweltfreundliche Verpackung ist ein großes Plus. Werde auf jeden Fall wieder bestellen!",
    "date": "2020-10-28"
  },
  


{
"name": "Renate Schüller",
"rating": 5,
"review": "Super!",
"date": "2015-03-19"
},
{
"name": "Antoine Mercier",
"rating": 4,
"review": "Gute Erfahrung gemacht. Die Artikel kamen innerhalb von 3 Tagen an und die Qualität ist wirklich überzeugend. Der Kundenservice war sehr hilfsbereit bei einer Frage zur Stoffzusammensetzung. Ein Stern Abzug, weil ein Teil minimal von der Farbdarstellung online abwich, aber insgesamt bin ich zufrieden.",
"date": "2016-09-05"
},
{
"name": "Astrid Larsson",
"rating": 5,
"review": "P&C hat mich echt beeindruckt! Meine Bestellung war schon nach einem Tag da, und die Verpackung war komplett plastikfrei - super umweltfreundlich! Die Qualität der Kleidung ist erstklassig, man merkt sofort den Unterschied zu billiger Massenware. Als ich eine Frage zur Kombination hatte, war der Kundenservice superschnell und kompetent. Klare Empfehlung!",
"date": "2017-05-22"
},
{
"name": "Wolfgang Schmidt",
"rating": 4,
"review": "Gute Ware, prompt geliefert.",
"date": "2018-11-14"
},
{
"name": "Francesca Marino",
"rating": 5,
"review": "Ich bin absolut begeistert von P&C und möchte meine Erfahrungen teilen:<br><br><strong>Positiv:</strong><br>- Herausragende Qualität der Kleidung<br>- Nachhaltige Produktion und umweltfreundliche Verpackung<br>- Schnelle Lieferung (bei mir 4 Tage)<br>- Exzellenter Kundenservice<br>- Kostenlose Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Etwas höhere Preise als bei Massenherstellern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte versehentlich die falsche Größe bestellt. Der Umtauschprozess war unglaublich einfach und schnell. Der Kundenservice war dabei außergewöhnlich freundlich und lösungsorientiert.<br><br><strong>Wichtiger Hinweis:</strong> Bestellt unbedingt nur direkt bei P&C! Es gibt leider viele Fake-Shops mit den gleichen Bildern, aber minderwertiger Ware.<br><br><strong>Fazit:</strong> P&C steht für echte Qualität 'Made in Germany' mit Stil und gutem Gewissen. Wer Wert auf Nachhaltigkeit, Top-Service und langlebige Mode legt, ist hier genau richtig. Absolute Kaufempfehlung!",
"date": "2019-07-30"
},
{
"name": "Magnus Olsen",
"rating": 5,
"review": "Erstklassig!",
"date": "2020-02-11"
},
{
"name": "Élise Petit",
"rating": 4,
"review": "Ich bin sehr zufrieden mit meinem Einkauf bei P&C. Die Qualität der Kleidung ist wirklich hervorragend und die Designs sind sehr ansprechend. Meine Bestellung kam innerhalb von 5 Tagen an, was ich in Ordnung finde. Der Kundenservice war auch top - ich hatte eine Frage zur Kombination verschiedener Teile und bekam sehr hilfreiche Styling-Tipps. Ein Stern Abzug, weil ein Teil minimal anders ausfiel als erwartet, aber das ist bei Online-Bestellungen manchmal so. Die kostenlose Rücksendeoption macht das aber wieder wett. Insgesamt eine sehr positive Erfahrung!",
"date": "2021-10-18"
},
{
"name": "Jakub Nowak",
"rating": 5,
"review": "P&C hat mich rundum überzeugt! Hier meine detaillierte Bewertung:<br><br><strong>Vorteile:</strong><br>1. Erstklassige Qualität der Kleidung<br>2. Nachhaltige Produktion und umweltfreundliche Verpackung<br>3. Blitzschnelle Lieferung (bei mir waren es nur 2 Tage!)<br>4. Kundenservice der Extraklasse<br>5. Faire Preise für die gebotene Qualität<br>6. Kostenlose und unkomplizierte Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Die Preise sind etwas höher als bei Fast-Fashion-Anbietern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte ein Problem mit der Passform eines Artikels und war überwältigt, wie kulant und schnell der Kundenservice reagierte. Sie boten mir sogar einen zusätzlichen Rabatt für die kleine Unannehmlichkeit an!<br><br><strong>Wichtiger Hinweis:</strong> Bitte seid vorsichtig und bestellt nur direkt bei P&C! Es gibt viele Fake-Shops, besonders auf sozialen Medien, die die gleichen Bilder verwenden, aber minderwertige und teilweise sogar gesundheitsschädliche Produkte liefern.<br><br><strong>Fazit:</strong> P&C steht für echte 'Made in Germany'-Qualität, kombiniert mit Stil, Nachhaltigkeit und exzellentem Service. Wer Wert auf langlebige Mode legt und dabei noch etwas für die Umwelt tun möchte, ist hier goldrichtig. Ich kann P&C nur wärmstens empfehlen und werde definitiv wieder hier einkaufen!",
"date": "2022-06-07"
},
{
"name": "Lotte de Vries",
"rating": 5,
"review": "Hervorragende Qualität, schnell geliefert.",
"date": "2023-12-01"
},
{
"name": "Gustav Eriksson",
"rating": 5,
"review": "Ich möchte meine durchweg positive Erfahrung mit P&C teilen:<br><br><strong>Positives:</strong><br>1. Außergewöhnlich hohe Qualität der Kleidung<br>2. Umweltbewusste Verpackung und nachhaltige Produktion<br>3. Beeindruckend schnelle Lieferung (3 Tage bei mir)<br>4. Kundenservice auf höchstem Niveau<br>5. Preis-Leistungs-Verhältnis stimmt absolut<br>6. Kostenlose Rücksendeoption - ein echter Pluspunkt<br><br><strong>Beachtenswert:</strong><br>- Die Preise liegen etwas über denen von Fast-Fashion-Ketten, aber die Qualität rechtfertigt das vollkommen<br><br><strong>Persönliches Erlebnis:</strong> Bei einer Bestellung hatte ich Zweifel an der Größenwahl. Der Kundenservice beriet mich ausführlich und geduldig. Als die Lieferung dann doch nicht 100% passte, war der Umtausch völlig unkompliziert.<br><br><strong>Wichtige Warnung:</strong> Bitte bestellt ausschließlich direkt bei P&C! Es existieren zahlreiche Fake-Shops, besonders auf Social-Media-Plattformen und sogar bei Google-Anzeigen, die P&Cs Bilder verwenden, aber minderwertige und potenziell gesundheitsschädliche Produkte liefern. Der geringe Preisunterschied lohnt sich definitiv für die echte P&C-Qualität.<br><br><strong>Abschließendes Urteil:</strong> P&C verkörpert für mich echte 'Made in Germany'-Qualität, gepaart mit zeitgemäßem Stil, Nachhaltigkeit und herausragendem Kundenservice. Für alle, die Wert auf langlebige, stilvolle Mode legen und dabei ein gutes Gewissen haben möchten, ist P&C die perfekte Wahl. Ich kann diesen Shop aus vollem Herzen empfehlen und werde mit Sicherheit wieder hier einkaufen!",
"date": "2024-08-15"
},


  {
    "name": "Laura Hoffmann",
    "rating": 5,
    "review": "Sehr schnelle Lieferung und die Produkte sind genau wie beschrieben. Perfekt!",
    "date": "2021-07-14"
  },
  {
    "name": "Pietro Romano",
    "rating": 4,
    "review": "Die Produkte sind gut, aber die Lieferung war langsamer als erwartet. Rücksendung war einfach und kostenlos.",
    "date": "2019-05-21"
  },
  {
    "name": "Anna Nowak",
    "rating": 5,
    "review": "Ich bin absolut begeistert! Die Produkte sind hochwertig, und der Versand war unglaublich schnell. Der Umtausch bei einer falschen Größe war einfach und kostenlos. Werde auf jeden Fall wieder bestellen!",
    "date": "2023-08-01"
  },
  {
    "name": "Oliver Dupont",
    "rating": 5,
    "review": "Tolle Qualität, schnelle Lieferung und die plastikfreie Verpackung hat mich überzeugt. Der kostenlose Rückversand war sehr unkompliziert. Gerne wieder!",
    "date": "2020-02-15"
  },
  {
    "name": "Sophie Van der Meer",
    "rating": 4,
    "review": "Die Produkte sind gut, aber die Lieferung dauerte etwas länger als erwartet. Der kostenlose Rückversand war ein Pluspunkt.",
    "date": "2022-03-08"
  },
  {
    "name": "Jakob Fischer",
    "rating": 5,
    "review": "Super schneller Versand und die Produkte sind von hervorragender Qualität. Die umweltfreundliche Verpackung hat mir gefallen, und der Rückversand war einfach. Sehr empfehlenswert!",
    "date": "2023-11-19"
  },
  {
    "name": "Marta Kowalska",
    "rating": 5,
    "review": "Toller Service! Die Produkte kamen schnell, und die Qualität ist hervorragend. Der Umtausch war kostenlos und lief ohne Probleme. Sehr zufrieden!",
    "date": "2024-04-10"
  },
  {
    "name": "Finn Larsson",
    "rating": 4,
    "review": "Gute Produkte, aber die Lieferung hätte schneller sein können. Rücksendung lief problemlos.",
    "date": "2017-06-17"
  },
  {
    "name": "Clara Meyer",
    "rating": 5,
    "review": "Sehr zufrieden mit meiner Bestellung! Die Produkte sind super, und die Lieferung war blitzschnell. Der Umtausch eines Artikels ging problemlos und kostenlos. Werde definitiv wieder bestellen.",
    "date": "2023-02-27"
  },
  {
    "name": "Henrik Schmidt",
    "rating": 5,
    "review": "Top Shop! Die Produkte kamen schnell an und sind von ausgezeichneter Qualität. Besonders gefallen hat mir die nachhaltige Verpackung. Gerne wieder!",
    "date": "2020-12-05"
  },


{
"name": "Inge Müller",
"rating": 5,
"review": "Spitze!",
"date": "2015-06-11"
},
{
"name": "Olivier Dubois",
"rating": 4,
"review": "Sehr zufrieden mit meinem Einkauf. Die Lieferung erfolgte innerhalb von 4 Tagen und die Qualität ist beeindruckend. Der Kundenservice war äußerst hilfsbereit bei einer Frage zur Größenauswahl. Ein Stern Abzug, weil ein Artikel minimal von der Beschreibung abwich, aber insgesamt eine positive Erfahrung.",
"date": "2016-12-03"
},
{
"name": "Linnea Söderström",
"rating": 5,
"review": "P&C hat mich wirklich überrascht! Die Bestellung war schon nach 2 Tagen da, und alles war umweltfreundlich verpackt - kein Plastik in Sicht! Die Qualität der Kleidung ist erstklassig, deutlich besser als Fast Fashion. Der Kundenservice war bei einer Stilfrage superschnell und kompetent. Klare Kaufempfehlung!",
"date": "2017-08-19"
},
{
"name": "Jörg Bauer",
"rating": 4,
"review": "Gute Produkte, zügig geliefert.",
"date": "2018-03-27"
},
{
"name": "Chiara Ricci",
"rating": 5,
"review": "Ich bin total begeistert von P&C und teile gerne meine Erfahrungen:<br><br><strong>Positiv:</strong><br>- Außergewöhnliche Qualität der Kleidung<br>- Nachhaltige Produktion und umweltschonende Verpackung<br>- Rasche Lieferung (bei mir 3 Tage)<br>- Herausragender Kundenservice<br>- Kostenlose Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Etwas höhere Preise als bei Discountern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte versehentlich die falsche Größe bestellt. Der Umtauschprozess war unglaublich einfach und schnell. Der Kundenservice war dabei außerordentlich zuvorkommend und lösungsorientiert.<br><br><strong>Wichtiger Hinweis:</strong> Bestellt unbedingt nur direkt bei P&C! Es gibt leider viele Fake-Shops mit den gleichen Bildern, aber minderwertiger Ware.<br><br><strong>Fazit:</strong> P&C steht für echte Qualität 'Made in Germany' mit Stil und gutem Gewissen. Wer Wert auf Nachhaltigkeit, Top-Service und langlebige Mode legt, ist hier genau richtig. Absolute Kaufempfehlung!",
"date": "2019-10-14"
},
{
"name": "Anders Pedersen",
"rating": 5,
"review": "Fantastisch!",
"date": "2020-05-02"
},
{
"name": "Marie Rousseau",
"rating": 4,
"review": "Ich bin sehr angetan von meinem Einkauf bei P&C. Die Qualität der Kleidung ist wirklich hervorragend und die Designs sind sehr zeitgemäß. Meine Bestellung kam innerhalb von 5 Tagen an, was ich okay finde. Der Kundenservice war auch top - ich hatte eine Frage zur Pflege und bekam sehr hilfreiche Tipps. Ein Stern Abzug, weil ein Teil minimal anders ausfiel als erwartet, aber das ist bei Online-Bestellungen manchmal so. Die kostenlose Rücksendeoption macht das aber wieder wett. Insgesamt eine sehr positive Erfahrung!",
"date": "2021-11-29"
},
{
"name": "Marek Kowalski",
"rating": 5,
"review": "P&C hat mich vollkommen überzeugt! Hier meine ausführliche Bewertung:<br><br><strong>Vorteile:</strong><br>1. Erstklassige Qualität der Kleidung<br>2. Nachhaltige Produktion und umweltfreundliche Verpackung<br>3. Sehr schnelle Lieferung (bei mir waren es nur 2 Tage!)<br>4. Kundenservice der Spitzenklasse<br>5. Faire Preise für die gebotene Qualität<br>6. Kostenlose und unkomplizierte Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Die Preise sind etwas höher als bei Fast-Fashion-Anbietern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte ein Problem mit der Passform eines Artikels und war überwältigt, wie kulant und schnell der Kundenservice reagierte. Sie boten mir sogar einen zusätzlichen Rabatt für die kleine Unannehmlichkeit an!<br><br><strong>Wichtiger Hinweis:</strong> Bitte seid vorsichtig und bestellt nur direkt bei P&C! Es gibt viele Fake-Shops, besonders auf sozialen Medien, die die gleichen Bilder verwenden, aber minderwertige und teilweise sogar gesundheitsschädliche Produkte liefern.<br><br><strong>Fazit:</strong> P&C steht für echte 'Made in Germany'-Qualität, kombiniert mit Stil, Nachhaltigkeit und exzellentem Service. Wer Wert auf langlebige Mode legt und dabei noch etwas für die Umwelt tun möchte, ist hier goldrichtig. Ich kann P&C nur wärmstens empfehlen und werde definitiv wieder hier einkaufen!",
"date": "2022-07-16"
},
{
"name": "Fleur van den Berg",
"rating": 5,
"review": "Exzellente Qualität, blitzschnell geliefert.",
"date": "2023-02-08"
},
{
"name": "Nils Johansson",
"rating": 5,
"review": "Ich möchte meine durchweg positive Erfahrung mit P&C teilen:<br><br><strong>Positives:</strong><br>1. Außergewöhnlich hohe Qualität der Kleidung<br>2. Umweltbewusste Verpackung und nachhaltige Produktion<br>3. Beeindruckend schnelle Lieferung (3 Tage bei mir)<br>4. Kundenservice auf höchstem Niveau<br>5. Preis-Leistungs-Verhältnis stimmt absolut<br>6. Kostenlose Rücksendeoption - ein echter Pluspunkt<br><br><strong>Beachtenswert:</strong><br>- Die Preise liegen etwas über denen von Fast-Fashion-Ketten, aber die Qualität rechtfertigt das vollkommen<br><br><strong>Persönliches Erlebnis:</strong> Bei einer Bestellung hatte ich Zweifel an der Größenwahl. Der Kundenservice beriet mich ausführlich und geduldig. Als die Lieferung dann doch nicht 100% passte, war der Umtausch völlig unkompliziert.<br><br><strong>Wichtige Warnung:</strong> Bitte bestellt ausschließlich direkt bei P&C! Es existieren zahlreiche Fake-Shops, besonders auf Social-Media-Plattformen und sogar bei Google-Anzeigen, die P&Cs Bilder verwenden, aber minderwertige und potenziell gesundheitsschädliche Produkte liefern. Der geringe Preisunterschied lohnt sich definitiv für die echte P&C-Qualität.<br><br><strong>Abschließendes Urteil:</strong> P&C verkörpert für mich echte 'Made in Germany'-Qualität, gepaart mit zeitgemäßem Stil, Nachhaltigkeit und herausragendem Kundenservice. Für alle, die Wert auf langlebige, stilvolle Mode legen und dabei ein gutes Gewissen haben möchten, ist P&C die perfekte Wahl. Ich kann diesen Shop aus vollem Herzen empfehlen und werde mit Sicherheit wieder hier einkaufen!",
"date": "2024-09-03"
},

  
  {
    "name": "Lea Schneider",
    "rating": 5,
    "review": "Alles top! Schneller Versand und die Qualität ist super.",
    "date": "2022-05-18"
  },
  {
    "name": "David Silva",
    "rating": 4,
    "review": "Die Produkte sind gut, aber die Lieferzeit war länger als erwartet. Rücksendung lief unkompliziert.",
    "date": "2020-09-11"
  },
  {
    "name": "Sophie Weber",
    "rating": 5,
    "review": "Ich bin begeistert! Die Lieferung war blitzschnell und die Qualität ist hervorragend. Der kostenlose Rückversand hat den Umtausch einfach gemacht. Werde wieder hier bestellen!",
    "date": "2023-08-21"
  },
  {
    "name": "Jan Novak",
    "rating": 5,
    "review": "Sehr zufrieden mit der gesamten Erfahrung. Schneller Versand, tolle Qualität und die nachhaltige Verpackung ist ein Plus. Rückversand war ebenfalls problemlos.",
    "date": "2021-07-05"
  },
  {
    "name": "Isabella Rossi",
    "rating": 4,
    "review": "Die Produkte sind schön, aber die Lieferung hätte schneller sein können. Trotzdem sehr zufrieden mit dem Service.",
    "date": "2019-11-22"
  },
  {
    "name": "Marek Kowalski",
    "rating": 5,
    "review": "Ich war sehr beeindruckt! Die Bestellung kam schnell an und war perfekt verpackt. Die Qualität der Produkte ist herausragend. Der Umtausch war problemlos und kostenlos.",
    "date": "2023-04-17"
  },
  {
    "name": "Klara Jansen",
    "rating": 5,
    "review": "Super schneller Versand, großartige Qualität und die plastikfreie Verpackung ist ein echter Bonus. Sehr zufrieden und werde wieder bestellen!",
    "date": "2024-02-09"
  },
  {
    "name": "Lars Hansen",
    "rating": 4,
    "review": "Die Lieferung dauerte etwas länger, aber die Produkte sind gut. Rücksendung war unkompliziert.",
    "date": "2018-08-29"
  },
  {
    "name": "Elena Müller",
    "rating": 5,
    "review": "Fantastische Qualität und sehr schnelle Lieferung. Die umweltfreundliche Verpackung hat mich ebenfalls überzeugt. Werde auf jeden Fall wieder hier bestellen!",
    "date": "2023-10-15"
  },
  {
    "name": "Oliver Dupont",
    "rating": 5,
    "review": "Schnelle Lieferung, super Qualität und toller Service. Besonders die nachhaltige Verpackung ohne Plastik ist ein großes Plus. Der Umtausch lief auch reibungslos. Sehr zufrieden!",
    "date": "2020-11-30"
  },

{
"name": "Helga Fischer",
"rating": 5,
"review": "Toll!",
"date": "2015-09-22"
},
{
"name": "Pierre Lefevre",
"rating": 4,
"review": "Gute Erfahrung gemacht. Die Artikel kamen innerhalb von 3 Tagen an und die Qualität ist wirklich überzeugend. Der Kundenservice war sehr hilfsbereit bei einer Frage zum Material. Ein Stern Abzug, weil ein Teil minimal von der Farbdarstellung online abwich, aber insgesamt bin ich zufrieden.",
"date": "2016-04-15"
},
{
"name": "Elin Gustafsson",
"rating": 5,
"review": "P&C hat mich echt beeindruckt! Meine Bestellung war schon nach einem Tag da, und die Verpackung war komplett plastikfrei - super umweltfreundlich! Die Qualität der Kleidung ist erstklassig, man merkt sofort den Unterschied zu billiger Massenware. Als ich eine Frage zur Kombination hatte, war der Kundenservice superschnell und kompetent. Klare Empfehlung!",
"date": "2017-11-30"
},
{
"name": "Markus Schulz",
"rating": 4,
"review": "Gute Ware, pünktlich geliefert.",
"date": "2018-07-09"
},
{
"name": "Sofia Romano",
"rating": 5,
"review": "Ich bin absolut begeistert von P&C und möchte meine Erfahrungen teilen:<br><br><strong>Positiv:</strong><br>- Herausragende Qualität der Kleidung<br>- Nachhaltige Produktion und umweltfreundliche Verpackung<br>- Schnelle Lieferung (bei mir 4 Tage)<br>- Exzellenter Kundenservice<br>- Kostenlose Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Etwas höhere Preise als bei Massenherstellern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte versehentlich die falsche Größe bestellt. Der Umtauschprozess war unglaublich einfach und schnell. Der Kundenservice war dabei außergewöhnlich freundlich und lösungsorientiert.<br><br><strong>Wichtiger Hinweis:</strong> Bestellt unbedingt nur direkt bei P&C! Es gibt leider viele Fake-Shops mit den gleichen Bildern, aber minderwertiger Ware.<br><br><strong>Fazit:</strong> P&C steht für echte Qualität 'Made in Germany' mit Stil und gutem Gewissen. Wer Wert auf Nachhaltigkeit, Top-Service und langlebige Mode legt, ist hier genau richtig. Absolute Kaufempfehlung!",
"date": "2019-01-23"
},
{
"name": "Lars Andersen",
"rating": 5,
"review": "Erstklassig!",
"date": "2020-08-17"
},
{
"name": "Camille Dupont",
"rating": 4,
"review": "Ich bin sehr zufrieden mit meinem Einkauf bei P&C. Die Qualität der Kleidung ist wirklich hervorragend und die Designs sind sehr ansprechend. Meine Bestellung kam innerhalb von 5 Tagen an, was ich in Ordnung finde. Der Kundenservice war auch top - ich hatte eine Frage zur Kombination verschiedener Teile und bekam sehr hilfreiche Styling-Tipps. Ein Stern Abzug, weil ein Teil minimal anders ausfiel als erwartet, aber das ist bei Online-Bestellungen manchmal so. Die kostenlose Rücksendeoption macht das aber wieder wett. Insgesamt eine sehr positive Erfahrung!",
"date": "2021-03-09"
},
{
"name": "Adam Nowak",
"rating": 5,
"review": "P&C hat mich rundum überzeugt! Hier meine detaillierte Bewertung:<br><br><strong>Vorteile:</strong><br>1. Erstklassige Qualität der Kleidung<br>2. Nachhaltige Produktion und umweltfreundliche Verpackung<br>3. Blitzschnelle Lieferung (bei mir waren es nur 2 Tage!)<br>4. Kundenservice der Extraklasse<br>5. Faire Preise für die gebotene Qualität<br>6. Kostenlose und unkomplizierte Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Die Preise sind etwas höher als bei Fast-Fashion-Anbietern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte ein Problem mit der Passform eines Artikels und war überwältigt, wie kulant und schnell der Kundenservice reagierte. Sie boten mir sogar einen zusätzlichen Rabatt für die kleine Unannehmlichkeit an!<br><br><strong>Wichtiger Hinweis:</strong> Bitte seid vorsichtig und bestellt nur direkt bei P&C! Es gibt viele Fake-Shops, besonders auf sozialen Medien, die die gleichen Bilder verwenden, aber minderwertige und teilweise sogar gesundheitsschädliche Produkte liefern.<br><br><strong>Fazit:</strong> P&C steht für echte 'Made in Germany'-Qualität, kombiniert mit Stil, Nachhaltigkeit und exzellentem Service. Wer Wert auf langlebige Mode legt und dabei noch etwas für die Umwelt tun möchte, ist hier goldrichtig. Ich kann P&C nur wärmstens empfehlen und werde definitiv wieder hier einkaufen!",
"date": "2022-10-05"
},
{
"name": "Anouk de Vries",
"rating": 5,
"review": "Hervorragende Qualität, schnell geliefert.",
"date": "2023-06-28"
},
{
"name": "Erik Lindgren",
"rating": 5,
"review": "Ich möchte meine durchweg positive Erfahrung mit P&C teilen:<br><br><strong>Positives:</strong><br>1. Außergewöhnlich hohe Qualität der Kleidung<br>2. Umweltbewusste Verpackung und nachhaltige Produktion<br>3. Beeindruckend schnelle Lieferung (3 Tage bei mir)<br>4. Kundenservice auf höchstem Niveau<br>5. Preis-Leistungs-Verhältnis stimmt absolut<br>6. Kostenlose Rücksendeoption - ein echter Pluspunkt<br><br><strong>Beachtenswert:</strong><br>- Die Preise liegen etwas über denen von Fast-Fashion-Ketten, aber die Qualität rechtfertigt das vollkommen<br><br><strong>Persönliches Erlebnis:</strong> Bei einer Bestellung hatte ich Zweifel an der Größenwahl. Der Kundenservice beriet mich ausführlich und geduldig. Als die Lieferung dann doch nicht 100% passte, war der Umtausch völlig unkompliziert.<br><br><strong>Wichtige Warnung:</strong> Bitte bestellt ausschließlich direkt bei P&C! Es existieren zahlreiche Fake-Shops, besonders auf Social-Media-Plattformen und sogar bei Google-Anzeigen, die P&Cs Bilder verwenden, aber minderwertige und potenziell gesundheitsschädliche Produkte liefern. Der geringe Preisunterschied lohnt sich definitiv für die echte P&C-Qualität.<br><br><strong>Abschließendes Urteil:</strong> P&C verkörpert für mich echte 'Made in Germany'-Qualität, gepaart mit zeitgemäßem Stil, Nachhaltigkeit und herausragendem Kundenservice. Für alle, die Wert auf langlebige, stilvolle Mode legen und dabei ein gutes Gewissen haben möchten, ist P&C die perfekte Wahl. Ich kann diesen Shop aus vollem Herzen empfehlen und werde mit Sicherheit wieder hier einkaufen!",
"date": "2024-02-14"
},


  {
    "name": "Lena Bauer",
    "rating": 5,
    "review": "Alles bestens, schnelle Lieferung und die Qualität ist top!",
    "date": "2022-06-13"
  },
  {
    "name": "Miguel Pereira",
    "rating": 4,
    "review": "Die Produkte sind gut, aber die Lieferung dauerte länger als erwartet. Rücksendung war einfach und kostenlos.",
    "date": "2020-12-05"
  },
  {
    "name": "Anna Müller",
    "rating": 5,
    "review": "Ich bin sehr zufrieden! Die Produkte kamen schnell an und die Qualität ist super. Der Umtausch war unkompliziert. Gerne wieder!",
    "date": "2023-07-11"
  },
  {
    "name": "Lucas Dubois",
    "rating": 5,
    "review": "Tolle Qualität, blitzschneller Versand und die umweltfreundliche Verpackung ist ein großes Plus. Rücksendung war einfach und kostenlos. Werde definitiv wieder bestellen!",
    "date": "2021-09-25"
  },
  {
    "name": "Sofia Novak",
    "rating": 4,
    "review": "Gute Produkte, aber die Lieferung hätte schneller sein können. Rückversand war einfach.",
    "date": "2019-04-18"
  },
  {
    "name": "Maja Lewandowski",
    "rating": 5,
    "review": "Fantastische Qualität, schnelle Lieferung und die plastikfreie Verpackung hat mich überzeugt. Der Umtausch war kostenlos und lief reibungslos. Sehr empfehlenswert!",
    "date": "2023-11-10"
  },
  {
    "name": "Tom Janssen",
    "rating": 5,
    "review": "Super schneller Versand, die Produkte sind hochwertig und die umweltfreundliche Verpackung finde ich klasse. Rücksendung war kostenlos. Werde hier sicher wieder bestellen!",
    "date": "2024-03-04"
  },
  {
    "name": "Emma Schmidt",
    "rating": 4,
    "review": "Die Produkte sind gut, aber die Lieferung hat etwas länger gedauert. Der kostenlose Rückversand war sehr einfach.",
    "date": "2018-10-21"
  },
  {
    "name": "Victor Moretti",
    "rating": 5,
    "review": "Die Bestellung kam schneller als erwartet und die Qualität ist hervorragend. Die plastikfreie Verpackung hat mir besonders gefallen. Rücksendung war kostenlos und einfach.",
    "date": "2023-05-27"
  },
  {
    "name": "Henrik Andersen",
    "rating": 5,
    "review": "Alles perfekt! Die Qualität der Produkte ist großartig, die Lieferung war schnell und der Umtausch lief problemlos. Sehr zufrieden!",
    "date": "2020-11-19"
  },


  {
    "name": "Laura Meier",
    "rating": 5,
    "review": "Sehr schnelle Lieferung und die Produkte sind von toller Qualität. Alles super!",
    "date": "2021-08-14"
  },
  {
    "name": "Pablo Garcia",
    "rating": 4,
    "review": "Die Ware ist gut, aber die Lieferung hat länger gedauert als erwartet. Rücksendung war einfach und kostenlos.",
    "date": "2020-07-29"
  },
  {
    "name": "Nina Wagner",
    "rating": 5,
    "review": "Ich bin begeistert! Die Lieferung war schnell, die Qualität hervorragend und die umweltfreundliche Verpackung ist ein echter Pluspunkt. Rücksendung war ebenfalls problemlos.",
    "date": "2023-06-21"
  },
  {
    "name": "Lukas Schmidt",
    "rating": 5,
    "review": "Toller Shop! Schnelle Lieferung, hochwertige Produkte und die plastikfreie Verpackung hat mich überzeugt. Rücksendung war kostenlos. Gerne wieder!",
    "date": "2021-11-08"
  },
  {
    "name": "Sofia Russo",
    "rating": 4,
    "review": "Die Produkte sind schön, aber die Lieferzeit hätte kürzer sein können. Rücksendung lief problemlos.",
    "date": "2019-09-05"
  },
  {
    "name": "Jakub Kowalski",
    "rating": 5,
    "review": "Sehr zufrieden! Die Produkte kamen schneller als erwartet und die Qualität ist top. Besonders gut finde ich die nachhaltige Verpackung und den einfachen Rückversand.",
    "date": "2024-01-19"
  },
  {
    "name": "Klara Jensen",
    "rating": 5,
    "review": "Fantastische Qualität, blitzschneller Versand und die plastikfreie Verpackung ist einfach super. Werde auf jeden Fall wieder bestellen!",
    "date": "2023-02-14"
  },
  {
    "name": "Timo Novak",
    "rating": 4,
    "review": "Die Lieferung war etwas langsamer, aber die Produkte sind gut. Rücksendung war unkompliziert und kostenlos.",
    "date": "2018-06-12"
  },
  {
    "name": "Emma Dupont",
    "rating": 5,
    "review": "Top Qualität, schnelle Lieferung und die umweltfreundliche Verpackung hat mich überzeugt. Der Umtausch war kostenlos und einfach. Sehr zufrieden!",
    "date": "2023-05-30"
  },
  {
    "name": "Henrik Larsen",
    "rating": 5,
    "review": "Sehr schnelle Lieferung, die Produkte sind hochwertig und die plastikfreie Verpackung hat mich begeistert. Rücksendung lief reibungslos. Gerne wieder!",
    "date": "2020-11-04"
  },



{
"name": "Gerda Weber",
"rating": 5,
"review": "Klasse!",
"date": "2015-07-03"
},
{
"name": "Louis Moreau",
"rating": 4,
"review": "Sehr zufrieden mit meinem Einkauf. Die Lieferung erfolgte innerhalb von 4 Tagen und die Qualität ist beeindruckend. Der Kundenservice war äußerst hilfsbereit bei einer Frage zur Größenauswahl. Ein Stern Abzug, weil ein Artikel minimal von der Beschreibung abwich, aber insgesamt eine positive Erfahrung.",
"date": "2016-01-19"
},
{
"name": "Maja Andersson",
"rating": 5,
"review": "P&C hat mich wirklich überrascht! Die Bestellung war schon nach 2 Tagen da, und alles war umweltfreundlich verpackt - kein Plastik in Sicht! Die Qualität der Kleidung ist erstklassig, deutlich besser als Fast Fashion. Der Kundenservice war bei einer Stilfrage superschnell und kompetent. Klare Kaufempfehlung!",
"date": "2017-10-08"
},
{
"name": "Thomas Becker",
"rating": 4,
"review": "Gute Produkte, zügig geliefert.",
"date": "2018-05-27"
},
{
"name": "Alessandra Conti",
"rating": 5,
"review": "Ich bin total begeistert von P&C und teile gerne meine Erfahrungen:<br><br><strong>Positiv:</strong><br>- Außergewöhnliche Qualität der Kleidung<br>- Nachhaltige Produktion und umweltschonende Verpackung<br>- Rasche Lieferung (bei mir 3 Tage)<br>- Herausragender Kundenservice<br>- Kostenlose Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Etwas höhere Preise als bei Discountern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte versehentlich die falsche Größe bestellt. Der Umtauschprozess war unglaublich einfach und schnell. Der Kundenservice war dabei außerordentlich zuvorkommend und lösungsorientiert.<br><br><strong>Wichtiger Hinweis:</strong> Bestellt unbedingt nur direkt bei P&C! Es gibt leider viele Fake-Shops mit den gleichen Bildern, aber minderwertiger Ware.<br><br><strong>Fazit:</strong> P&C steht für echte Qualität 'Made in Germany' mit Stil und gutem Gewissen. Wer Wert auf Nachhaltigkeit, Top-Service und langlebige Mode legt, ist hier genau richtig. Absolute Kaufempfehlung!",
"date": "2019-12-14"
},
{
"name": "Jesper Nielsen",
"rating": 5,
"review": "Fantastisch!",
"date": "2020-06-30"
},
{
"name": "Sophie Laurent",
"rating": 4,
"review": "Ich bin sehr angetan von meinem Einkauf bei P&C. Die Qualität der Kleidung ist wirklich hervorragend und die Designs sind sehr zeitgemäß. Meine Bestellung kam innerhalb von 5 Tagen an, was ich okay finde. Der Kundenservice war auch top - ich hatte eine Frage zur Pflege und bekam sehr hilfreiche Tipps. Ein Stern Abzug, weil ein Teil minimal anders ausfiel als erwartet, aber das ist bei Online-Bestellungen manchmal so. Die kostenlose Rücksendeoption macht das aber wieder wett. Insgesamt eine sehr positive Erfahrung!",
"date": "2021-09-11"
},
{
"name": "Piotr Kowalczyk",
"rating": 5,
"review": "P&C hat mich vollkommen überzeugt! Hier meine ausführliche Bewertung:<br><br><strong>Vorteile:</strong><br>1. Erstklassige Qualität der Kleidung<br>2. Nachhaltige Produktion und umweltfreundliche Verpackung<br>3. Sehr schnelle Lieferung (bei mir waren es nur 2 Tage!)<br>4. Kundenservice der Spitzenklasse<br>5. Faire Preise für die gebotene Qualität<br>6. Kostenlose und unkomplizierte Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Die Preise sind etwas höher als bei Fast-Fashion-Anbietern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte ein Problem mit der Passform eines Artikels und war überwältigt, wie kulant und schnell der Kundenservice reagierte. Sie boten mir sogar einen zusätzlichen Rabatt für die kleine Unannehmlichkeit an!<br><br><strong>Wichtiger Hinweis:</strong> Bitte seid vorsichtig und bestellt nur direkt bei P&C! Es gibt viele Fake-Shops, besonders auf sozialen Medien, die die gleichen Bilder verwenden, aber minderwertige und teilweise sogar gesundheitsschädliche Produkte liefern.<br><br><strong>Fazit:</strong> P&C steht für echte 'Made in Germany'-Qualität, kombiniert mit Stil, Nachhaltigkeit und exzellentem Service. Wer Wert auf langlebige Mode legt und dabei noch etwas für die Umwelt tun möchte, ist hier goldrichtig. Ich kann P&C nur wärmstens empfehlen und werde definitiv wieder hier einkaufen!",
"date": "2022-04-25"
},
{
"name": "Femke van der Linden",
"rating": 5,
"review": "Exzellente Qualität, blitzschnell geliefert.",
"date": "2023-11-19"
},
{
"name": "Björn Svensson",
"rating": 5,
"review": "Ich möchte meine durchweg positive Erfahrung mit P&C teilen:<br><br><strong>Positives:</strong><br>1. Außergewöhnlich hohe Qualität der Kleidung<br>2. Umweltbewusste Verpackung und nachhaltige Produktion<br>3. Beeindruckend schnelle Lieferung (3 Tage bei mir)<br>4. Kundenservice auf höchstem Niveau<br>5. Preis-Leistungs-Verhältnis stimmt absolut<br>6. Kostenlose Rücksendeoption - ein echter Pluspunkt<br><br><strong>Beachtenswert:</strong><br>- Die Preise liegen etwas über denen von Fast-Fashion-Ketten, aber die Qualität rechtfertigt das vollkommen<br><br><strong>Persönliches Erlebnis:</strong> Bei einer Bestellung hatte ich Zweifel an der Größenwahl. Der Kundenservice beriet mich ausführlich und geduldig. Als die Lieferung dann doch nicht 100% passte, war der Umtausch völlig unkompliziert.<br><br><strong>Wichtige Warnung:</strong> Bitte bestellt ausschließlich direkt bei P&C! Es existieren zahlreiche Fake-Shops, besonders auf Social-Media-Plattformen und sogar bei Google-Anzeigen, die P&Cs Bilder verwenden, aber minderwertige und potenziell gesundheitsschädliche Produkte liefern. Der geringe Preisunterschied lohnt sich definitiv für die echte P&C-Qualität.<br><br><strong>Abschließendes Urteil:</strong> P&C verkörpert für mich echte 'Made in Germany'-Qualität, gepaart mit zeitgemäßem Stil, Nachhaltigkeit und herausragendem Kundenservice. Für alle, die Wert auf langlebige, stilvolle Mode legen und dabei ein gutes Gewissen haben möchten, ist P&C die perfekte Wahl. Ich kann diesen Shop aus vollem Herzen empfehlen und werde mit Sicherheit wieder hier einkaufen!",
"date": "2024-05-07"
},


  {
    "name": "Lara Fischer",
    "rating": 5,
    "review": "Schneller Versand und die Produkte sind genau wie beschrieben. Sehr zufrieden!",
    "date": "2022-04-11"
  },
  {
    "name": "Ricardo Silva",
    "rating": 4,
    "review": "Die Qualität ist gut, aber die Lieferzeit war etwas länger. Rücksendung war unkompliziert.",
    "date": "2020-06-23"
  },
  {
    "name": "Sophie Dubois",
    "rating": 5,
    "review": "Super schnelle Lieferung und die Qualität der Produkte ist top. Besonders gut fand ich die umweltfreundliche Verpackung. Gerne wieder!",
    "date": "2023-09-02"
  },
  {
    "name": "Jan Novak",
    "rating": 5,
    "review": "Ich bin begeistert! Tolle Qualität, schnelle Lieferung und die Rücksendung war kostenlos und einfach.",
    "date": "2021-05-12"
  },
  {
    "name": "Elena Rossi",
    "rating": 4,
    "review": "Die Produkte sind gut, aber die Lieferung hat länger gedauert als erwartet. Umtausch war jedoch problemlos.",
    "date": "2019-07-20"
  },
  {
    "name": "Victor Moretti",
    "rating": 5,
    "review": "Sehr zufrieden! Die Bestellung kam schneller als gedacht und die Qualität ist hervorragend. Die plastikfreie Verpackung ist ein großer Pluspunkt.",
    "date": "2023-12-15"
  },
  {
    "name": "Klara Jensen",
    "rating": 5,
    "review": "Top Qualität, schnelle Lieferung und die nachhaltige Verpackung hat mich überzeugt. Der Rückversand war kostenlos und einfach.",
    "date": "2024-03-29"
  },
  {
    "name": "Timo Kowalski",
    "rating": 4,
    "review": "Die Produkte sind gut, aber die Lieferung war langsamer als erwartet. Rücksendung war unkompliziert.",
    "date": "2018-09-14"
  },
  {
    "name": "Emma Dupont",
    "rating": 5,
    "review": "Ich bin sehr zufrieden mit meiner Bestellung. Die Qualität ist super und der Versand war schnell. Die plastikfreie Verpackung ist ein Bonus!",
    "date": "2023-04-22"
  },
  {
    "name": "Henrik Larsson",
    "rating": 5,
    "review": "Sehr schnelle Lieferung, hochwertige Produkte und die umweltfreundliche Verpackung ist ein großer Pluspunkt. Gerne wieder!",
    "date": "2020-11-01"
  },




{
"name": "Ursula Schröder",
"rating": 5,
"review": "Prima!",
"date": "2015-08-17"
},
{
"name": "Étienne Dupont",
"rating": 4,
"review": "Gute Erfahrung gemacht. Die Artikel kamen innerhalb von 3 Tagen an und die Qualität ist wirklich überzeugend. Der Kundenservice war sehr hilfsbereit bei einer Frage zur Stoffzusammensetzung. Ein Stern Abzug, weil ein Teil minimal von der Farbdarstellung online abwich, aber insgesamt bin ich zufrieden.",
"date": "2016-03-29"
},
{
"name": "Lina Eriksson",
"rating": 5,
"review": "P&C hat mich echt beeindruckt! Meine Bestellung war schon nach einem Tag da, und die Verpackung war komplett plastikfrei - super umweltfreundlich! Die Qualität der Kleidung ist erstklassig, man merkt sofort den Unterschied zu billiger Massenware. Als ich eine Frage zur Kombination hatte, war der Kundenservice superschnell und kompetent. Klare Empfehlung!",
"date": "2017-11-12"
},
{
"name": "Wolfgang Huber",
"rating": 4,
"review": "Gute Ware, pünktlich geliefert.",
"date": "2018-06-05"
},
{
"name": "Giulia Rossi",
"rating": 5,
"review": "Ich bin absolut begeistert von P&C und möchte meine Erfahrungen teilen:<br><br><strong>Positiv:</strong><br>- Herausragende Qualität der Kleidung<br>- Nachhaltige Produktion und umweltfreundliche Verpackung<br>- Schnelle Lieferung (bei mir 4 Tage)<br>- Exzellenter Kundenservice<br>- Kostenlose Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Etwas höhere Preise als bei Massenherstellern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte versehentlich die falsche Größe bestellt. Der Umtauschprozess war unglaublich einfach und schnell. Der Kundenservice war dabei außergewöhnlich freundlich und lösungsorientiert.<br><br><strong>Wichtiger Hinweis:</strong> Bestellt unbedingt nur direkt bei P&C! Es gibt leider viele Fake-Shops mit den gleichen Bildern, aber minderwertiger Ware.<br><br><strong>Fazit:</strong> P&C steht für echte Qualität 'Made in Germany' mit Stil und gutem Gewissen. Wer Wert auf Nachhaltigkeit, Top-Service und langlebige Mode legt, ist hier genau richtig. Absolute Kaufempfehlung!",
"date": "2019-09-23"
},
{
"name": "Magnus Olsen",
"rating": 5,
"review": "Erstklassig!",
"date": "2020-02-14"
},
{
"name": "Amélie Lefebvre",
"rating": 4,
"review": "Ich bin sehr zufrieden mit meinem Einkauf bei P&C. Die Qualität der Kleidung ist wirklich hervorragend und die Designs sind sehr ansprechend. Meine Bestellung kam innerhalb von 5 Tagen an, was ich in Ordnung finde. Der Kundenservice war auch top - ich hatte eine Frage zur Kombination verschiedener Teile und bekam sehr hilfreiche Styling-Tipps. Ein Stern Abzug, weil ein Teil minimal anders ausfiel als erwartet, aber das ist bei Online-Bestellungen manchmal so. Die kostenlose Rücksendeoption macht das aber wieder wett. Insgesamt eine sehr positive Erfahrung!",
"date": "2021-07-30"
},
{
"name": "Marek Wiśniewski",
"rating": 5,
"review": "P&C hat mich rundum überzeugt! Hier meine detaillierte Bewertung:<br><br><strong>Vorteile:</strong><br>1. Erstklassige Qualität der Kleidung<br>2. Nachhaltige Produktion und umweltfreundliche Verpackung<br>3. Blitzschnelle Lieferung (bei mir waren es nur 2 Tage!)<br>4. Kundenservice der Extraklasse<br>5. Faire Preise für die gebotene Qualität<br>6. Kostenlose und unkomplizierte Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Die Preise sind etwas höher als bei Fast-Fashion-Anbietern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte ein Problem mit der Passform eines Artikels und war überwältigt, wie kulant und schnell der Kundenservice reagierte. Sie boten mir sogar einen zusätzlichen Rabatt für die kleine Unannehmlichkeit an!<br><br><strong>Wichtiger Hinweis:</strong> Bitte seid vorsichtig und bestellt nur direkt bei P&C! Es gibt viele Fake-Shops, besonders auf sozialen Medien, die die gleichen Bilder verwenden, aber minderwertige und teilweise sogar gesundheitsschädliche Produkte liefern.<br><br><strong>Fazit:</strong> P&C steht für echte 'Made in Germany'-Qualität, kombiniert mit Stil, Nachhaltigkeit und exzellentem Service. Wer Wert auf langlebige Mode legt und dabei noch etwas für die Umwelt tun möchte, ist hier goldrichtig. Ich kann P&C nur wärmstens empfehlen und werde definitiv wieder hier einkaufen!",
"date": "2022-12-09"
},
{
"name": "Lotte de Boer",
"rating": 5,
"review": "Hervorragende Qualität, schnell geliefert.",
"date": "2023-05-26"
},
{
"name": "Gustav Bergström",
"rating": 5,
"review": "Ich möchte meine durchweg positive Erfahrung mit P&C teilen:<br><br><strong>Positives:</strong><br>1. Außergewöhnlich hohe Qualität der Kleidung<br>2. Umweltbewusste Verpackung und nachhaltige Produktion<br>3. Beeindruckend schnelle Lieferung (3 Tage bei mir)<br>4. Kundenservice auf höchstem Niveau<br>5. Preis-Leistungs-Verhältnis stimmt absolut<br>6. Kostenlose Rücksendeoption - ein echter Pluspunkt<br><br><strong>Beachtenswert:</strong><br>- Die Preise liegen etwas über denen von Fast-Fashion-Ketten, aber die Qualität rechtfertigt das vollkommen<br><br><strong>Persönliches Erlebnis:</strong> Bei einer Bestellung hatte ich Zweifel an der Größenwahl. Der Kundenservice beriet mich ausführlich und geduldig. Als die Lieferung dann doch nicht 100% passte, war der Umtausch völlig unkompliziert.<br><br><strong>Wichtige Warnung:</strong> Bitte bestellt ausschließlich direkt bei P&C! Es existieren zahlreiche Fake-Shops, besonders auf Social-Media-Plattformen und sogar bei Google-Anzeigen, die P&Cs Bilder verwenden, aber minderwertige und potenziell gesundheitsschädliche Produkte liefern. Der geringe Preisunterschied lohnt sich definitiv für die echte P&C-Qualität.<br><br><strong>Abschließendes Urteil:</strong> P&C verkörpert für mich echte 'Made in Germany'-Qualität, gepaart mit zeitgemäßem Stil, Nachhaltigkeit und herausragendem Kundenservice. Für alle, die Wert auf langlebige, stilvolle Mode legen und dabei ein gutes Gewissen haben möchten, ist P&C die perfekte Wahl. Ich kann diesen Shop aus vollem Herzen empfehlen und werde mit Sicherheit wieder hier einkaufen!",
"date": "2024-01-18"
},



{
"name": "Hildegard Müller",
"rating": 5,
"review": "Spitze!",
"date": "2015-04-03"
},
{
"name": "Antoine Rousseau",
"rating": 4,
"review": "Sehr zufrieden mit meinem Einkauf. Die Lieferung erfolgte innerhalb von 4 Tagen und die Qualität ist beeindruckend. Der Kundenservice war äußerst hilfsbereit bei einer Frage zur Größenauswahl. Ein Stern Abzug, weil ein Artikel minimal von der Beschreibung abwich, aber insgesamt eine positive Erfahrung.",
"date": "2016-10-17"
},
{
"name": "Astrid Johansson",
"rating": 5,
"review": "P&C hat mich wirklich überrascht! Die Bestellung war schon nach 2 Tagen da, und alles war umweltfreundlich verpackt - kein Plastik in Sicht! Die Qualität der Kleidung ist erstklassig, deutlich besser als Fast Fashion. Der Kundenservice war bei einer Stilfrage superschnell und kompetent. Klare Kaufempfehlung!",
"date": "2017-07-22"
},
{
"name": "Klaus Fischer",
"rating": 4,
"review": "Gute Produkte, zügig geliefert.",
"date": "2018-01-09"
},
{
"name": "Chiara Bianchi",
"rating": 5,
"review": "Ich bin total begeistert von P&C und teile gerne meine Erfahrungen:<br><br><strong>Positiv:</strong><br>- Außergewöhnliche Qualität der Kleidung<br>- Nachhaltige Produktion und umweltschonende Verpackung<br>- Rasche Lieferung (bei mir 3 Tage)<br>- Herausragender Kundenservice<br>- Kostenlose Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Etwas höhere Preise als bei Discountern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte versehentlich die falsche Größe bestellt. Der Umtauschprozess war unglaublich einfach und schnell. Der Kundenservice war dabei außerordentlich zuvorkommend und lösungsorientiert.<br><br><strong>Wichtiger Hinweis:</strong> Bestellt unbedingt nur direkt bei P&C! Es gibt leider viele Fake-Shops mit den gleichen Bildern, aber minderwertiger Ware.<br><br><strong>Fazit:</strong> P&C steht für echte Qualität 'Made in Germany' mit Stil und gutem Gewissen. Wer Wert auf Nachhaltigkeit, Top-Service und langlebige Mode legt, ist hier genau richtig. Absolute Kaufempfehlung!",
"date": "2019-05-30"
},
{
"name": "Søren Andersen",
"rating": 5,
"review": "Fantastisch!",
"date": "2020-12-11"
},
{
"name": "Élise Dupont",
"rating": 4,
"review": "Ich bin sehr angetan von meinem Einkauf bei P&C. Die Qualität der Kleidung ist wirklich hervorragend und die Designs sind sehr zeitgemäß. Meine Bestellung kam innerhalb von 5 Tagen an, was ich okay finde. Der Kundenservice war auch top - ich hatte eine Frage zur Pflege und bekam sehr hilfreiche Tipps. Ein Stern Abzug, weil ein Teil minimal anders ausfiel als erwartet, aber das ist bei Online-Bestellungen manchmal so. Die kostenlose Rücksendeoption macht das aber wieder wett. Insgesamt eine sehr positive Erfahrung!",
"date": "2021-09-03"
},
{
"name": "Jakub Kowalski",
"rating": 5,
"review": "P&C hat mich vollkommen überzeugt! Hier meine ausführliche Bewertung:<br><br><strong>Vorteile:</strong><br>1. Erstklassige Qualität der Kleidung<br>2. Nachhaltige Produktion und umweltfreundliche Verpackung<br>3. Sehr schnelle Lieferung (bei mir waren es nur 2 Tage!)<br>4. Kundenservice der Spitzenklasse<br>5. Faire Preise für die gebotene Qualität<br>6. Kostenlose und unkomplizierte Rücksendeoption<br><br><strong>Zu beachten:</strong><br>- Die Preise sind etwas höher als bei Fast-Fashion-Anbietern, aber absolut gerechtfertigt<br><br><strong>Meine Erfahrung:</strong> Ich hatte ein Problem mit der Passform eines Artikels und war überwältigt, wie kulant und schnell der Kundenservice reagierte. Sie boten mir sogar einen zusätzlichen Rabatt für die kleine Unannehmlichkeit an!<br><br><strong>Wichtiger Hinweis:</strong> Bitte seid vorsichtig und bestellt nur direkt bei P&C! Es gibt viele Fake-Shops, besonders auf sozialen Medien, die die gleichen Bilder verwenden, aber minderwertige und teilweise sogar gesundheitsschädliche Produkte liefern.<br><br><strong>Fazit:</strong> P&C steht für echte 'Made in Germany'-Qualität, kombiniert mit Stil, Nachhaltigkeit und exzellentem Service. Wer Wert auf langlebige Mode legt und dabei noch etwas für die Umwelt tun möchte, ist hier goldrichtig. Ich kann P&C nur wärmstens empfehlen und werde definitiv wieder hier einkaufen!",
"date": "2022-03-17"
},
{
"name": "Fleur van Dijk",
"rating": 5,
"review": "Exzellente Qualität, blitzschnell geliefert.",
"date": "2023-11-29"
},
{
"name": "Erik Lindqvist",
"rating": 5,
"review": "Ich möchte meine durchweg positive Erfahrung mit P&C teilen:<br><br><strong>Positives:</strong><br>1. Außergewöhnlich hohe Qualität der Kleidung<br>2. Umweltbewusste Verpackung und nachhaltige Produktion<br>3. Beeindruckend schnelle Lieferung (3 Tage bei mir)<br>4. Kundenservice auf höchstem Niveau<br>5. Preis-Leistungs-Verhältnis stimmt absolut<br>6. Kostenlose Rücksendeoption - ein echter Pluspunkt<br><br><strong>Beachtenswert:</strong><br>- Die Preise liegen etwas über denen von Fast-Fashion-Ketten, aber die Qualität rechtfertigt das vollkommen<br><br><strong>Persönliches Erlebnis:</strong> Bei einer Bestellung hatte ich Zweifel an der Größenwahl. Der Kundenservice beriet mich ausführlich und geduldig. Als die Lieferung dann doch nicht 100% passte, war der Umtausch völlig unkompliziert.<br><br><strong>Wichtige Warnung:</strong> Bitte bestellt ausschließlich direkt bei P&C! Es existieren zahlreiche Fake-Shops, besonders auf Social-Media-Plattformen und sogar bei Google-Anzeigen, die P&Cs Bilder verwenden, aber minderwertige und potenziell gesundheitsschädliche Produkte liefern. Der geringe Preisunterschied lohnt sich definitiv für die echte P&C-Qualität.<br><br><strong>Abschließendes Urteil:</strong> P&C verkörpert für mich echte 'Made in Germany'-Qualität, gepaart mit zeitgemäßem Stil, Nachhaltigkeit und herausragendem Kundenservice. Für alle, die Wert auf langlebige, stilvolle Mode legen und dabei ein gutes Gewissen haben möchten, ist P&C die perfekte Wahl. Ich kann diesen Shop aus vollem Herzen empfehlen und werde mit Sicherheit wieder hier einkaufen!",
"date": "2024-06-08"
},


  
  {
    "name": "Lara Fischer",
    "rating": 5,
    "review": "Schneller Versand und die Produkte sind genau wie beschrieben. Sehr zufrieden!",
    "date": "2022-04-11"
  },
  {
    "name": "Ricardo Silva",
    "rating": 4,
    "review": "Die Qualität ist gut, aber die Lieferzeit war etwas länger. Rücksendung war unkompliziert.",
    "date": "2020-06-23"
  },
  {
    "name": "Sophie Dubois",
    "rating": 5,
    "review": "Super schnelle Lieferung und die Qualität der Produkte ist top. Besonders gut fand ich die umweltfreundliche Verpackung. Gerne wieder!",
    "date": "2023-09-02"
  },
  {
    "name": "Jan Novak",
    "rating": 5,
    "review": "Ich bin begeistert! Tolle Qualität, schnelle Lieferung und die Rücksendung war kostenlos und einfach.",
    "date": "2021-05-12"
  },
  {
    "name": "Elena Rossi",
    "rating": 4,
    "review": "Die Produkte sind gut, aber die Lieferung hat länger gedauert als erwartet. Umtausch war jedoch problemlos.",
    "date": "2019-07-20"
  },
  {
    "name": "Victor Moretti",
    "rating": 5,
    "review": "Sehr zufrieden! Die Bestellung kam schneller als gedacht und die Qualität ist hervorragend. Die plastikfreie Verpackung ist ein großer Pluspunkt.",
    "date": "2023-12-15"
  },
  {
    "name": "Klara Jensen",
    "rating": 5,
    "review": "Top Qualität, schnelle Lieferung und die nachhaltige Verpackung hat mich überzeugt. Der Rückversand war kostenlos und einfach.",
    "date": "2024-03-29"
  },
  {
    "name": "Timo Kowalski",
    "rating": 4,
    "review": "Die Produkte sind gut, aber die Lieferung war langsamer als erwartet. Rücksendung war unkompliziert.",
    "date": "2018-09-14"
  },
  {
    "name": "Emma Dupont",
    "rating": 5,
    "review": "Ich bin sehr zufrieden mit meiner Bestellung. Die Qualität ist super und der Versand war schnell. Die plastikfreie Verpackung ist ein Bonus!",
    "date": "2023-04-22"
  },
  {
    "name": "Henrik Larsson",
    "rating": 5,
    "review": "Sehr schnelle Lieferung, hochwertige Produkte und die umweltfreundliche Verpackung ist ein großer Pluspunkt. Gerne wieder!",
    "date": "2020-11-01"
  },

  
  
];


